import { Article } from '@/types';

export type ArticleMeta = Omit<Article, 'content'> & {
  content: { en: { title: string; excerpt: string; body: string } };
};

export const articles: ArticleMeta[] = [
  {
    id: '52',
    slug: 'camping-basics-complete-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-29',
    updatedAt: '2026-06-29',
    tags: ['camping', 'beginner', 'guide', 'outdoor', 'nature', 'adventure', 'hub', 'structure-5', 'intro-6'],
    shortAnswer: 'Camping is short-term outdoor living using a tent, hammock, or vehicle for shelter. A first trip needs four things to be safe and enjoyable: a weather-appropriate shelter, a sleep system rated below your expected low, a way to cook and store water, and a basic plan for fire, waste, and wildlife at your specific site.',
    content: { en: { title: 'Camping Basics - The Complete Beginner Guide', excerpt: 'From choosing gear to building campfires and handling wildlife - a practical guide for anyone planning their first camping trip with total confidence.', body: '' } },
  },
  {
    id: '49',
    slug: 'van-life-basics-complete-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533591380348-14193f1de18f?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-08',
    updatedAt: '2026-05-20',
    tags: ['van-life', 'beginner', 'guide', 'mobile-living', 'freedom', 'alternative-living', 'hub', 'structure-5', 'intro-6'],
    shortAnswer: 'Van life is full-time or long-term living in a converted van. A workable setup centers on four systems: a reliable vehicle (cargo van or high-roof shuttle), a 200–400Ah battery bank with solar, 20–40 gallons of fresh water with greywater capture, and an insulated sleeping area. Realistic monthly costs run $1,200–$2,500 once fuel, insurance, food, and maintenance are added together.',
    content: { en: { title: 'Van Life Basics - The Complete Beginner Guide', excerpt: 'Choosing your first van, building power and water systems, managing real monthly costs, and creating daily routines that actually work full-time on the road.', body: '' } },
  },
  {
    id: '48',
    slug: 'living-on-a-boat-full-time-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-01',
    updatedAt: '2026-03-25',
    tags: ['boat-living', 'liveaboard', 'sailing', 'marina', 'alternative-living', 'water', 'structure-1', 'intro-1'],
    content: { en: { title: 'Living on a Boat Full-Time - The Complete Guide', excerpt: 'From choosing the right vessel to marina vs. anchor life, maintenance costs, and daily routines - what full-time boat living looks like after three years.', body: '' } },
  },
  {
    id: '47',
    slug: 'ultralight-backpacking-complete-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-27',
    updatedAt: '2026-03-20',
    tags: ['camping', 'backpacking', 'ultralight', 'hiking', 'gear', 'wilderness', 'structure-4', 'intro-3'],
    content: { en: { title: 'Ultralight Backpacking - The Complete Beginner\'s Guide', excerpt: 'Cut your pack weight in half without losing comfort or safety. Gear philosophy, the Big Three upgrades, and real ultralight techniques that actually work.', body: '' } },
  },
  {
    id: '45',
    slug: 'vanlife-with-dogs-complete-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-19',
    updatedAt: '2026-03-21',
    tags: ['van-life', 'dogs', 'pets', 'mobile-living', 'travel', 'adventure', 'structure-3', 'intro-5'],
    content: { en: { title: 'Traveling with Dogs in a Van - What Actually Works', excerpt: 'Temperature management, vet access on the road, exercise routines, and dog-friendly spots - van life with your dog requires real planning and patience.', body: '' } },
  },
  {
    id: '43',
    slug: 'living-on-a-boat-cost-breakdown',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500375592092-40eb2168fd21?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-09',
    updatedAt: '2026-03-22',
    tags: ['boat-living', 'budget', 'costs', 'liveaboard', 'finances', 'savings', 'structure-2', 'intro-4'],
    content: { en: { title: 'Living on a Boat Cost Breakdown - The Complete Financial Guide', excerpt: 'Two years of liveaboard expenses tracked to the dollar. Purchase price, marina fees, the 10% maintenance rule, and the hidden costs nobody warns you about.', body: '' } },
  },
  {
    id: '42',
    slug: 'van-life-for-beginners',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1523712999610-f77fbcfc3843?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-26',
    updatedAt: '2026-03-18',
    tags: ['van-life', 'beginners', 'mobile-living', 'freedom', 'minimalism', 'adventure', 'structure-1', 'intro-1'],
    content: { en: { title: 'Van Life for Beginners - Your First Steps Toward Freedom on', excerpt: 'What I wish someone had told me before starting van life. First vehicle choices, realistic monthly budgets, and the critical mindset shift that matters most.', body: '' } },
  },
  {
    id: '26',
    slug: 'winter-camping-essentials',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1483664852095-d6cc6870702d?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-24',
    updatedAt: '2026-03-15',
    tags: ['winter', 'cold-weather', 'gear', 'sleeping-bags', 'insulation', 'safety', 'structure-2', 'intro-4'],
    content: { en: { title: 'Winter Camping Essentials - Staying Warm When It Matters Most', excerpt: 'Cold-weather camping demands respect and the right gear. Sleeping systems rated to -20°C, layering strategies, and fire skills for sub-zero nights outdoors.', body: '' } },
  },
  {
    id: '27',
    slug: 'campfire-cooking-mastery',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1526491109672-74740652b963?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-13',
    updatedAt: '2026-03-19',
    tags: ['cooking', 'campfire', 'recipes', 'beginner', 'outdoor-meals', 'skills', 'structure-4', 'intro-1'],
    content: { en: { title: 'Campfire Cooking for Beginners - First Flames to First Feast', excerpt: 'Fire-building basics, simple foil-packet meals, and the patience trick that separates burnt hot dogs from genuinely satisfying campfire cooking. Real data.', body: '' } },
  },
  {
    id: '28',
    slug: 'camping-with-kids',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1445307806294-bff7f67ff225?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-09',
    tags: ['family', 'kids', 'education', 'nature', 'activities', 'safety', 'structure-5', 'intro-2'],
    content: { en: { title: 'Camping with Kids - Creating Lifelong Adventurers', excerpt: 'Age-appropriate gear, rainy day backup strategies, and the three rules that turn chaotic family camping trips into memories your kids will treasure forever.', body: '' } },
  },
  {
    id: '18',
    slug: 'water-self-sufficiency-off-grid',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501630834273-4b5604d2ee31?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-12',
    updatedAt: '2026-03-24',
    tags: ['water', 'rainwater', 'filtration', 'wells', 'self-sufficiency', 'sustainability', 'structure-4', 'intro-1'],
    content: { en: { title: 'Water Self-Sufficiency - Wells, Rainwater, and Filtration Systems', excerpt: 'Wells, rainwater harvesting, and filtration systems compared side by side. Real costs, seasonal reliability, and the math of water independence off-grid.', body: '' } },
  },
  {
    id: '19',
    slug: 'living-off-grid-with-kids-family-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516733725897-1aa73b87c8e8?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-19',
    updatedAt: '2026-03-23',
    tags: ['family', 'kids', 'homeschooling', 'education', 'safety', 'parenting', 'nature', 'structure-6', 'intro-2'],
    content: { en: { title: 'Living Off-Grid with Kids - Education, Safety, and Adventures', excerpt: 'Homeschooling routines, wilderness safety protocols, and the surprising developmental benefits kids gain from growing up in a self-sufficient off-grid home.', body: '' } },
  },
  {
    id: '20',
    slug: 'psychology-of-solitude-remote-living',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-20',
    updatedAt: '2026-07-22',
    tags: ['mental-health', 'solitude', 'isolation', 'mindfulness', 'psychology', 'wellbeing', 'structure-5', 'intro-5'],
    content: { en: { title: 'The Psychology of Solitude - Mental Health in Remote Living', excerpt: 'Solitude rewires your brain in measurable ways - some beneficial, some risky. Practical strategies for thriving mentally while living alone in remote places.', body: '' } },
  },
  {
    id: '21',
    slug: 'off-grid-power-solar-battery-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-06',
    updatedAt: '2026-03-26',
    tags: ['solar', 'batteries', 'power', 'energy', 'renewable', 'DIY', 'sustainability', 'structure-4', 'intro-3'],
    content: { en: { title: 'Off-Grid Power - Complete Solar and Battery Guide for Beginners', excerpt: 'Panel sizing, battery chemistry comparisons, inverter selection, and the calculations that determine whether your off-grid solar power system actually works.', body: '' } },
  },
  {
    id: '14',
    slug: 'vanlife-with-partner-relationship-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530789253388-582c481c54b0?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-21',
    updatedAt: '2026-03-16',
    tags: ['van-life', 'relationships', 'couple-travel', 'small-space-living', 'communication', 'freedom', 'structure-6', 'intro-2'],
    content: { en: { title: 'Vanlife with a Partner - Thriving Together in 8 Square Meters', excerpt: 'Sixty square feet with someone you love tests communication daily. Conflict protocols, personal space hacks, and what actually keeps couples together on the.', body: '' } },
  },
  {
    id: '15',
    slug: 'staying-connected-remote-work-van',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1522199755839-a2bacb67c546?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-09',
    updatedAt: '2026-03-17',
    tags: ['van-life', 'remote-work', 'digital-nomad', 'internet', 'productivity', 'work-from-anywhere', 'structure-4', 'intro-3'],
    content: { en: { title: 'Staying Connected - Internet and Remote Work from a Van', excerpt: 'How to maintain a career while living on wheels - the practical reality of mobile hotspots, signal boosters, and staying productive without an office.', body: '' } },
  },
  {
    id: '16',
    slug: 'hidden-costs-of-vanlife',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-11',
    tags: ['van-life', 'budget', 'finances', 'reality-check', 'planning', 'costs', 'structure-2', 'intro-4'],
    content: { en: { title: 'The Hidden Costs of Vanlife - What Nobody Tells You', excerpt: 'Insurance, maintenance surprises, parking tickets, and the $847 alternator - a full year of tracked expenses that catch most new van dwellers completely off.', body: '' } },
  },
  {
    id: '17',
    slug: 'seasonal-vanlife-chasing-weather',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1494783367193-149034c05e8f?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-13',
    updatedAt: '2026-07-22',
    tags: ['van-life', 'seasonal-travel', 'weather', 'routes', 'planning', 'freedom', 'structure-5', 'intro-6'],
    content: { en: { title: 'Seasonal Vanlife - Chasing the Perfect Weather Year-Round', excerpt: 'Follow the sun south in winter and north in summer. Tested route planning, weather windows, and the seasonal migration rhythm that keeps van life comfortable.', body: '' } },
  },
  {
    id: '9',
    slug: 'how-to-choose-your-first-van-or-bus',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-05',
    tags: ['van-life', 'bus-life', 'beginners', 'buying-guide', 'conversion', 'freedom', 'structure-3', 'intro-1'],
    content: { en: { title: 'How to Choose Your First Van or Bus to Live In', excerpt: 'Sprinter vs. Transit vs. bus - engine checks, rust inspection, test drive protocol, and the real math of buying your first mobile home from $5K to $70K.', body: '' } },
  },
  {
    id: '1',
    slug: 'personal-tips-mobile-living',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-09',
    tags: ['van-life', 'bus-life', 'tiny-home-on-wheels', 'nomad', 'freedom', 'tips', 'lifestyle', 'structure-5', 'intro-6'],
    content: { en: { title: 'Van Life for Beginners - Complete Starter Guide 2025', excerpt: 'Power systems, water management, kitchen hacks, and safety strategies refined over three years of full-time van living. Real costs and tested daily routines.', body: '' } },
  },
  {
    id: '2',
    slug: 'personal-tips-off-grid',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1449158743715-0a90ebb6d2d8?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-03',
    tags: ['off-grid', 'sustainable', 'self-sufficient', 'tiny-house', 'dome-home', 'homesteading', 'structure-5', 'intro-3'],
    content: { en: { title: 'Off-Grid Living for Beginners - Essential Guide 2025', excerpt: 'Solar panels, water filters, backup generators, and the quiet recalibration that off-grid life demands. Practical tools and honest reflections from research.', body: '' } },
  },
  {
    id: '3',
    slug: 'personal-tips-boat-living',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500514966906-fe245eea9344?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-17',
    tags: ['boat-life', 'marina', 'sailing', 'liveaboard', 'sailing-lifestyle', 'structure-6', 'intro-2'],
    content: { en: { title: 'Liveaboard Life for Beginners - Complete Guide 2025', excerpt: 'Sailboat or houseboat, marina or anchor, safety protocols and quiet mornings at sea - an honest beginner guide to choosing and living on your floating home.', body: '' } },
  },
  {
    id: '4',
    slug: 'personal-tips-camping',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1510672981848-a1c4f1cb5ccf?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-30',
    tags: ['camping', 'outdoor', 'nature', 'structure-5', 'intro-6'],
    content: { en: { title: 'Camping for Beginners - Complete Starter Guide 2025', excerpt: 'Gear lists, weather preparation, fire-starting reliability, and the patience curriculum - twelve trips of lessons distilled into one practical camping guide.', body: '' } },
  },
  {
    id: '5',
    slug: 'surprising-camping-facts-nature-science',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-14',
    tags: ['camping', 'nature', 'facts', 'science', 'wellness', 'structure-5', 'intro-3'],
    content: { en: { title: '17 Surprising Camping Facts That Will Change How You See Nature', excerpt: 'Campfire light lowers blood pressure in 15 minutes. Forest air boosts immunity for 30 days. The science behind why camping changes your brain and your body.', body: '' } },
  },
  {
    id: '6',
    slug: 'what-to-consider-before-buying-a-liveaboard-boat',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1540946485063-a40da27545f8?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-18',
    tags: ['liveaboard', 'boat-buying', 'tips', 'beginner', 'sailing-lifestyle', 'structure-3', 'intro-5'],
    content: { en: { title: 'Before You Buy Your First Liveaboard Boat', excerpt: 'Hull inspections, engine checks, marina costs, and the emotional rollercoaster of buying your first liveaboard - everything I learned from obsessive research.', body: '' } },
  },
  {
    id: '7',
    slug: 'what-to-consider-before-your-first-camping-trip',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-11',
    tags: ['camping', 'beginner', 'tips', 'outdoor', 'nature', 'first-time', 'structure-3', 'intro-5'],
    content: { en: { title: 'What to Consider Before Your First Camping Trip', excerpt: 'Destination choice, gear priorities, and weather preparation - the decision frameworks that prevent common first-trip failures and build lasting confidence.', body: '' } },
  },
  {
    id: '8',
    slug: 'off-grid-living-rules-regulations-2025',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-18',
    tags: ['off-grid', 'regulations', 'legal', 'permits', 'building-codes', 'zoning', '2025', 'structure-1', 'intro-4'],
    content: { en: { title: 'Off-Grid Living in 2025 - What the Rules Actually Say', excerpt: 'Zoning laws, building codes, septic permits, and the gray areas that define off-grid legality in 2025. What is possible, where it is easy, and what to avoid.', body: '' } },
  },
  {
    id: '10',
    slug: 'first-30-days-living-in-van',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-30',
    tags: ['van-life', 'beginners', 'challenges', 'first-month', 'reality', 'freedom', 'structure-6', 'intro-2'],
    content: { en: { title: 'The First 30 Days Living in a Van - What Nobody Warns You About', excerpt: 'Parking anxiety, condensation at 3 AM, and the $954 first month - a week-by-week account of what nobody warns you about when you start living in a van.', body: '' } },
  },
  {
    id: '11',
    slug: 'building-your-own-tiny-house',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1510798831971-661eb04b3739?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-01',
    tags: ['tiny-house', 'building', 'diy', 'beginners', 'off-grid', 'self-sufficient', 'structure-4', 'intro-4'],
    content: { en: { title: 'Building Your Own Tiny House - A Beginner\'s Honest Guide', excerpt: 'A $14,500 budget became $25,200 over fourteen months. The honest build sequence, material costs, and critical mistakes of building a tiny house yourself.', body: '' } },
  },
  {
    id: '12',
    slug: 'sailing-seasons-weather-boat-living',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1509233725247-49e657c54213?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-23',
    tags: ['boat-life', 'sailing', 'seasons', 'weather', 'winter', 'maintenance', 'structure-5', 'intro-2'],
    content: { en: { title: 'Sailing Seasons - How Weather Shapes Life on the Water', excerpt: 'Spring haul-outs, summer anchoring, autumn storms, and winter condensation - each season aboard demands different skills, budgets, and mental resilience.', body: '' } },
  },
  {
    id: '13',
    slug: 'solo-camping-first-time',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517824806704-9040b037703b?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-18',
    tags: ['camping', 'solo', 'beginners', 'wilderness', 'fear', 'freedom', 'self-discovery', 'structure-2', 'intro-1'],
    content: { en: { title: 'Solo Camping for the First Time - Fear and Freedom', excerpt: 'What happens when you camp alone for the first time? Fear management, site selection, and the unexpected freedom that comes from self-reliance in the wild.', body: '' } },
  },
  {
    id: '22',
    slug: 'boat-maintenance-essentials-liveaboard',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517999144091-3d9dca6d1e43?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-14',
    updatedAt: '2026-07-22',
    tags: ['boat-maintenance', 'liveaboard', 'boat-care', 'diy', 'sailing', 'structure-4', 'intro-4'],
    content: { en: { title: 'Boat Maintenance Essentials - Keeping Your Floating Home', excerpt: 'A $3 hose clamp prevents a $1,400 repair. Daily walk-throughs, weekly checks, seasonal overhauls, and the maintenance mindset that keeps liveaboards safe.', body: '' } },
  },
  {
    id: '23',
    slug: 'boat-living-with-pets',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-15',
    tags: ['pets', 'liveaboard', 'dogs', 'cats', 'boat-life', 'marina', 'structure-4', 'intro-3'],
    content: { en: { title: 'Boat Living with Pets - Making It Work for Your Four-Legged Crew', excerpt: 'Dogs need dinghy trips to shore three times daily. Cats adapt surprisingly well. Pet life jackets, vet access planning, and the daily rhythm of animals aboard.', body: '' } },
  },
  {
    id: '24',
    slug: 'budget-boat-living-real-costs',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-03',
    tags: ['budget', 'costs', 'liveaboard', 'marina-fees', 'boat-expenses', 'structure-2', 'intro-1'],
    content: { en: { title: 'The Real Costs of Boat Living - A Honest Budget Breakdown', excerpt: 'Can you live cheaper on a boat? Maybe. Marina fees, the 10% maintenance rule, insurance, and why your boat budget needs a 30% buffer for year-one surprises.', body: '' } },
  },
  {
    id: '25',
    slug: 'cruising-routes-seasonal-sailing',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-20',
    tags: ['cruising', 'seasonal-sailing', 'routes', 'weather', 'passages', 'structure-6', 'intro-2'],
    content: { en: { title: 'Cruising Routes and Seasonal Sailing - Following the Weather', excerpt: 'Atlantic circuits, Pacific crossings, and the weather windows that keep cruising sailors safe. Route timing, seasonal patterns, and community on the move.', body: '' } },
  },
  {
    id: '30',
    slug: 'vanlife-kitchen-setup-cooking-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-02',
    tags: ['vanlife', 'kitchen', 'cooking', 'food', 'recipes', 'gear', 'structure-4', 'intro-1'],
    content: { en: { title: 'The Vanlife Kitchen - Cooking Magic in Minimal Space', excerpt: 'A two-burner stove and one sharp knife can rival any restaurant. Food storage without refrigeration, one-pot recipes, and market-driven cooking on the road.', body: '' } },
  },
  {
    id: '31',
    slug: 'vanlife-safety-security-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-14',
    tags: ['vanlife', 'safety', 'security', 'stealth', 'tips', 'solo-travel', 'structure-2', 'intro-4'],
    content: { en: { title: 'Vanlife Safety - Staying Secure on the Road', excerpt: 'Practical security strategies for van dwellers - stealth parking, vehicle hardening, emergency preparedness, and trusting your instincts on the road. Real data.', body: '' } },
  },
  {
    id: '32',
    slug: 'vanlife-community-finding-your-tribe',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-03',
    updatedAt: '2026-07-22',
    tags: ['vanlife', 'community', 'social', 'meetups', 'friends', 'travel', 'structure-6', 'intro-2'],
    content: { en: { title: 'Finding Your Tribe - Community in Vanlife', excerpt: 'Van life looks like isolation from outside. Inside, it consistently becomes one of the most connected, community-rich lifestyles most people experience.', body: '' } },
  },
  {
    id: '34',
    slug: 'composting-toilet-guide-off-grid',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-20',
    tags: ['composting-toilet', 'sanitation', 'off-grid', 'sustainable', 'diy', 'structure-2', 'intro-3'],
    content: { en: { title: 'Composting Toilets - The Complete Off-Grid Sanitation Guide', excerpt: 'Four years with a composting toilet and zero regrets. No smell with proper ventilation, zero water waste, and $1,200 installed versus $10,000 for septic.', body: '' } },
  },
  {
    id: '35',
    slug: 'heating-cooling-off-grid-homes',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544984243-ec57ea16fe25?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-18',
    tags: ['heating', 'cooling', 'wood-stove', 'insulation', 'passive-solar', 'structure-2', 'intro-6'],
    content: { en: { title: 'Heating and Cooling Off-Grid - Comfort Without Grid', excerpt: 'Wood stoves, passive solar design, R-20 to R-60 insulation targets, and summer cooling without AC - four seasons of off-grid climate comfort in one guide.', body: '' } },
  },
  {
    id: '36',
    slug: 'winterizing-liveaboard-boat-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-16',
    tags: ['winterizing', 'liveaboard', 'cold-weather', 'maintenance', 'heating', 'boat-living', 'structure-1', 'intro-6'],
    content: { en: { title: 'Winterizing Your Liveaboard - Staying Warm on the Water', excerpt: 'Diesel heaters, condensation management, antifreeze protocols, and the insulation upgrades that transform a freezing boat into a warm winter home on water.', body: '' } },
  },
  {
    id: '38',
    slug: 'cooking-galley-tips-liveaboard',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-14',
    tags: ['cooking', 'galley', 'provisioning', 'recipes', 'storage', 'boat-living', 'structure-4', 'intro-1'],
    content: { en: { title: 'Galley Life - Cooking and Eating Well on Your Liveaboard', excerpt: 'Cast iron in four square feet of counter space, provisioning for weeks, and one-pot meals that taste better afloat. Galley cooking mastered through constraints.', body: '' } },
  },
  {
    id: '39',
    slug: 'campfire-cooking-mastery-advanced',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1470755008296-2939845775eb?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-23',
    tags: ['cooking', 'campfire', 'advanced', 'techniques', 'cast-iron', 'dutch-oven', 'structure-1', 'intro-6'],
    content: { en: { title: 'Advanced Campfire Cooking - Dutch Oven and Cast Iron', excerpt: 'The two-fire system, Dutch oven coal ratios, hand-test temperature control, and cast iron seasoning - advanced techniques for serious outdoor cooks. Real data.', body: '' } },
  },
  {
    id: '40',
    slug: 'hammock-camping-complete-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-11',
    tags: ['hammock', 'setup', 'how-to', 'gear-guide', 'trees', 'suspension', 'structure-6', 'intro-3'],
    content: { en: { title: 'Hammock Camping Setup - Complete Gear and Technique Guide', excerpt: 'Tree selection, strap angles, the 30-degree rule, diagonal lie technique, and underquilt setup - a practical guide to hammock camping gear and configuration.', body: '' } },
  },
  {
    id: '41',
    slug: 'leave-no-trace-camping-principles',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-12',
    tags: ['ethics', 'environment', 'conservation', 'responsible', 'wilderness', 'nature', 'structure-5', 'intro-4'],
    content: { en: { title: 'Leave No Trace - The Art of Invisible Camping', excerpt: 'Seven principles that protect wilderness for future generations. Practical campsite departure checks, fire responsibility, and trail discipline that matters.', body: '' } },
  },
  {
    id: '44',
    slug: 'what-to-consider-before-buying-off-grid-property',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500673922987-e212871fec22?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-29',
    tags: ['off-grid', 'property', 'land-purchase', 'legal', 'budget', 'beginners', 'structure-3', 'intro-1'],
    content: { en: { title: 'What to Consider Before Buying Off-Grid Property', excerpt: 'Perc tests, easements, zoning surprises, and a $50,000 development budget on top of purchase price - the off-grid property checklist I built from my mistakes.', body: '' } },
  },
  {
    id: '46',
    slug: 'growing-your-own-food-off-grid-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-26',
    tags: ['off-grid', 'gardening', 'self-sufficiency', 'food-production', 'permaculture', 'homesteading', 'structure-1', 'intro-2'],
    content: { en: { title: 'Growing Your Own Food Off-Grid - A Complete Guide', excerpt: 'Three years from failed crops to eight months of self-sufficiency. Soil prep, water-smart irrigation, season extension, and the beginner crops that forgive.', body: '' } },
  },
  {
    id: '50',
    slug: 'off-grid-living-basics-complete-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1542202229-7d93c33f5d07?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-06',
    updatedAt: '2026-03-28',
    tags: ['off-grid', 'beginner', 'guide', 'solar', 'water', 'heating', 'toilets', 'self-sufficiency', 'hub', 'structure-5', 'intro-6'],
    shortAnswer: 'Off-grid living means producing your own power, water, heat, and waste handling without utility connections. The four core systems are: a 3–8 kW solar array with 10–20 kWh of battery storage, 1,000–5,000 gallons of rainwater catchment with filtration, a wood or propane heat source sized to insulation level, and a composting or septic toilet matched to local code.',
    content: { en: { title: 'Off-Grid Living Basics - Power, Water, Heat & Toilets', excerpt: 'Solar sizing, battery chemistry, rainwater harvesting, wood stove selection, and composting toilets - the four essential systems every off-grid home requires.', body: '' } },
  },
  {
    id: '51',
    slug: 'boat-living-basics-complete-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1520208422220-d12a3c588e6c?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-03',
    updatedAt: '2026-03-28',
    tags: ['boat-living', 'liveaboard', 'beginner', 'guide', 'sailing', 'marina', 'alternative-living', 'hub', 'structure-5', 'intro-6'],
    shortAnswer: 'Living aboard a boat full-time is realistic on vessels 30 feet and up with adequate headroom, freshwater capacity, and battery storage. First-year liveaboards usually spend $1,500–$3,500 per month covering marina fees, insurance, fuel, maintenance, and a haul-out reserve. Marina life trades autonomy for showers, power, and community; anchoring trades convenience for a watermaker, solar, and a working dinghy.',
    content: { en: { title: 'Boat Living Basics - Your First Year on the Water', excerpt: 'Everything you need to know before moving aboard. From choosing your first boat to marina life, maintenance, costs, and the daily realities of life afloat.', body: '' } },
  },
  {
    id: '53',
    slug: 'camping-on-a-budget-tips',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-24',
    tags: ['camping', 'budget', 'beginner', 'tips', 'affordable', 'frugal', 'structure-3', 'intro-5'],
    content: { en: { title: 'Camping on a Budget - Enjoy Nature for Less', excerpt: 'Free dispersed camping, borrowed gear, and $20 weekend meal plans - proven strategies that deliver the same stars and campfires for a fraction of the cost.', body: '' } },
  },
  {
    id: '54',
    slug: 'vanlife-hygiene-showers-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-23',
    tags: ['vanlife', 'hygiene', 'showers', 'tips', 'practical', 'lifestyle', 'structure-3', 'intro-5'],
    content: { en: { title: 'Vanlife Hygiene - Showers, Laundry, and Staying Fresh on the Road', excerpt: 'Gym showers three times weekly, baby wipes between visits, and merino wool that lasts five days without odor. Vanlife hygiene costs $35 per month and works.', body: '' } },
  },
  {
    id: '56',
    slug: 'first-30-days-living-on-boat',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1551244072-5d12893278ab?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-04',
    tags: ['boat-living', 'beginner', 'liveaboard', 'first-month', 'adjustment', 'tips', 'structure-6', 'intro-2'],
    content: { en: { title: 'Your First 30 Days Living on a Boat - What to Expect', excerpt: 'Week one overwhelm, week two systems learning, week three loneliness, week four belonging - the predictable arc of your first month living on a boat full-time.', body: '' } },
  },
  {
    id: '57',
    slug: 'camping-in-the-rain-tips',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534274988757-a28bf1a57c17?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-04',
    tags: ['camping', 'rain', 'weather', 'gear', 'tarp', 'tips', 'structure-2', 'intro-4'],
    content: { en: { title: 'Camping in the Rain - How to Stay Dry and Actually Enjoy It', excerpt: 'Tarp setup, clothing layers, fire-building in wet conditions, and the mindset shift that turns rainy camping from miserable survival into atmospheric reward.', body: '' } },
  },
  {
    id: '58',
    slug: 'night-sky-camping-stargazing-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-05',
    updatedAt: '2026-07-22',
    tags: ['camping', 'stargazing', 'night-sky', 'photography', 'astronomy', 'nature', 'structure-5', 'intro-2'],
    content: { en: { title: 'Night Sky Camping - Stargazing and Night Photography Outdoors', excerpt: 'Bortle scale locations, moon phase planning, meteor shower timing, and basic astrophotography - everything you need for unforgettable nights under dark skies.', body: '' } },
  },
  {
    id: '59',
    slug: 'van-life-parking-where-to-sleep',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544568100-847a948585b9?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-28',
    updatedAt: '2026-07-22',
    tags: ['van-life', 'parking', 'stealth', 'legal', 'safety', 'overnight', 'structure-1', 'intro-3'],
    content: { en: { title: 'Where to Park Your Van Legally and Sleep Safely', excerpt: 'BLM land, Walmart lots, rest areas, and stealth parking protocols - a three-year guide to finding safe, legal overnight van parking across 37 states. Real data.', body: '' } },
  },
  {
    id: '60',
    slug: 'downsizing-for-van-life-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1543857778-c4a1a3e0b2eb?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-10',
    tags: ['van-life', 'downsizing', 'minimalism', 'declutter', 'transition', 'guide', 'structure-6', 'intro-2'],
    content: { en: { title: 'Downsizing for Van Life - What to Keep, Sell, and Let Go', excerpt: 'Selling 90% of your possessions generates roughly $2,400 and several sleepless nights. The practical sorting process and emotional curve nobody warns about.', body: '' } },
  },
  {
    id: '61',
    slug: 'off-grid-lighting-solutions-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-01',
    tags: ['off-grid', 'lighting', 'solar', 'LED', 'natural-light', 'guide', 'structure-4', 'intro-6'],
    content: { en: { title: 'Off-Grid Lighting - Solar, LED, and Natural Light Solutions', excerpt: 'A complete off-grid lighting system costs $127 and runs on a single 100W solar panel. Natural light maximization, 12V LED design, and seasonal planning.', body: '' } },
  },
  {
    id: '62',
    slug: 'off-grid-laundry-washing-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-21',
    tags: ['off-grid', 'laundry', 'washing', 'water', 'self-sufficiency', 'guide', 'structure-1', 'intro-1'],
    content: { en: { title: 'Off-Grid Laundry - Washing Clothes Without Grid Power', excerpt: 'A hand-washed load uses 8-15 liters versus 50+ for a machine. The bucket method, greywater reuse, and when to upgrade to a 12V portable washer off-grid.', body: '' } },
  },
  {
    id: '63',
    slug: 'dinghy-selection-liveaboard-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-21',
    tags: ['boat-living', 'dinghy', 'liveaboard', 'equipment', 'decision', 'guide', 'structure-3', 'intro-5'],
    content: { en: { title: 'Choosing a Dinghy for Your Liveaboard - The Unsung Essential', excerpt: 'Your dinghy is your car, grocery cart, and emergency exit. Inflatable vs. rigid hull, $300 vs. $4,500, and the three factors that determine which one you need.', body: '' } },
  },
  {
    id: '64',
    slug: 'internet-communication-boat-living',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504681869696-d977211a5f4c?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-29',
    tags: ['boat-living', 'internet', 'communication', 'connectivity', 'remote-work', 'guide', 'structure-5', 'intro-3'],
    content: { en: { title: 'Staying Connected at Sea - Internet for Boat Living', excerpt: 'Cellular routers at masthead height, Starlink maritime plans, and VPN essentials - staying connected at sea costs $100-200 per month with reliable results.', body: '' } },
  },
  {
    id: '65',
    slug: 'camping-first-aid-wilderness-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-10',
    tags: ['camping', 'first-aid', 'safety', 'wilderness', 'medical', 'emergency', 'structure-4', 'intro-6'],
    content: { en: { title: 'Camping First Aid - Handling Common Wilderness Emergencies', excerpt: 'Wounds, sprains, burns, hypothermia account for 80% of wilderness medical situations. Learn when to treat in the field and when to evacuate - with a $47 kit.', body: '' } },
  },
  {
    id: '66',
    slug: 'van-life-remote-work-income-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-23',
    tags: ['van-life', 'remote-work', 'income', 'freelance', 'digital-nomad', 'finances', 'structure-2', 'intro-4'],
    content: { en: { title: 'Van Life Income - Working Remotely on the Road', excerpt: 'Concrete strategies for earning $2,100–$4,800/month from a van - built for patchy internet, no fixed address, and the client-perception challenge. Real data.', body: '' } },
  },
  {
    id: '67',
    slug: 'off-grid-water-heating-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-24',
    tags: ['off-grid', 'water-heating', 'solar', 'wood', 'propane', 'decision', 'structure-3', 'intro-5'],
    content: { en: { title: 'Off-Grid Water Heating - Which System Is Right for Your Situation', excerpt: 'Solar thermal, propane, wood-fired, or heat pump? The right off-grid water heating choice depends on your climate, daily usage, and existing infrastructure.', body: '' } },
  },
  {
    id: '68',
    slug: 'seasickness-liveaboard-motion-sensitivity-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1559827291-72ee739d0d9a?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-01',
    tags: ['boat-living', 'seasickness', 'motion-sickness', 'health', 'adjustment', 'liveaboard', 'structure-1', 'intro-6'],
    content: { en: { title: 'Seasickness for Liveaboards - What Adapts and What Won\'t', excerpt: '85% of new liveaboards adapt to boat motion within 2–6 weeks. The neuroscience of adaptation, what to avoid during adjustment, and when it does not improve.', body: '' } },
  },
  {
    id: '69',
    slug: 'how-to-choose-a-campsite-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-30',
    tags: ['camping', 'campsite', 'decision', 'planning', 'site-selection', 'safety', 'structure-6', 'intro-1'],
    content: { en: { title: 'How to Choose a Campsite - A Scenario-Based Decision Guide', excerpt: 'Good campsites need drainage, no dead trees overhead, and a reason to wake up there. Everything else depends on your camping style, group size, and season.', body: '' } },
  },
  {
    id: '70',
    slug: 'van-life-with-kids-family-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-25',
    tags: ['van-life', 'family', 'kids', 'homeschool', 'parenting', 'mobile-living', 'structure-4', 'intro-6'],
    content: { en: { title: 'Raising Kids on the Road - Van Life Realities', excerpt: 'Van life family decisions, $4,200 in extra build costs most families miss, homeschool options from $30–$150/month, and the honest answer about kids under 3.', body: '' } },
  },
  {
    id: '71',
    slug: 'off-grid-waste-management-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-09',
    tags: ['off-grid', 'waste', 'greywater', 'blackwater', 'sanitation', 'environment', 'structure-5', 'intro-2'],
    content: { en: { title: 'Off-Grid Waste Management Beyond the Composting Toilet', excerpt: 'A composting toilet covers about 30 percent of your waste stream. Greywater, food waste, solid refuse, and recycling logistics make up the rest. Real data.', body: '' } },
  },
  {
    id: '72',
    slug: 'anchoring-out-liveaboard-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-13',
    tags: ['boat-living', 'anchoring', 'liveaboard', 'costs', 'freedom', 'seamanship', 'structure-2', 'intro-4'],
    content: { en: { title: 'Anchoring Out - The Liveaboard\'s Guide to Life on the Hook', excerpt: 'Liveaboards pay $800–$1,200/month for marina berths when free anchorage exists nearby. Anchor-out living has specific requirements most guides skip entirely.', body: '' } },
  },
  {
    id: '73',
    slug: 'camping-night-navigation-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504701954957-2010ec3bcec1?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-08',
    tags: ['camping', 'navigation', 'night', 'stars', 'map', 'torch', 'safety', 'structure-1', 'intro-3'],
    content: { en: { title: 'Night Navigation for Campers - Reading the Dark', excerpt: 'Navigate safely after dark with headtorch discipline, natural night vision preservation, and terrain reading that keeps you on trail when the sun goes down.', body: '' } },
  },
  {
    id: '74',
    slug: 'van-life-sleep-quality-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1512100356356-de1b84283e18?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-20',
    tags: ['van-life', 'sleep', 'insulation', 'bed', 'routine', 'health', 'structure-5', 'intro-1'],
    content: { en: { title: 'Van Life Sleep - Why It Is Hard and How to Fix It', excerpt: 'Sleep quality is the most underrated van build decision. Temperature, condensation, platform design, and noise interact in ways a house never does. Real data.', body: '' } },
  },
  {
    id: '75',
    slug: 'off-grid-emergency-preparedness-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533575770077-052fa2c609fc?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-10',
    tags: ['off-grid', 'emergency', 'preparedness', 'safety', 'fire', 'power-outage', 'medical', 'structure-6', 'intro-4'],
    content: { en: { title: 'Off-Grid Emergency Preparedness for Remote Properties', excerpt: 'Off-grid living removes the safety nets most people rely on. Three scenarios cover 90% of rural emergencies - each requiring a completely different response.', body: '' } },
  },
  {
    id: '76',
    slug: 'liveaboard-fitness-exercise-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-02',
    tags: ['boat-living', 'fitness', 'exercise', 'health', 'liveaboard', 'routine', 'structure-4', 'intro-1'],
    content: { en: { title: 'Liveaboard Fitness - How to Stay in Shape on a Small Boat', excerpt: 'Stay fit on a small boat with bodyweight routines, resistance bands, swimming schedules, and nutrition strategies built for the constraints of liveaboard life.', body: '' } },
  },
  {
    id: '77',
    slug: 'camping-gear-maintenance-repair-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533577116850-9cc66cad8a9b?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-09',
    tags: ['camping', 'gear', 'maintenance', 'repair', 'tent', 'sleeping-bag', 'boots', 'structure-2', 'intro-5'],
    content: { en: { title: 'Camping Gear Maintenance - How to Make Your Equipment Last', excerpt: 'How often you use it, what conditions it sees, and the coating type - those three things determine whether camping gear lasts two seasons or twelve. Real data.', body: '' } },
  },
  {
    id: '78',
    slug: 'van-life-alone-solo-van-lifer-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1476900966873-ab290e38e3f7?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-31',
    tags: ['van-life', 'solo', 'alone', 'safety', 'independence', 'mental-health', 'loneliness', 'structure-6', 'intro-3'],
    content: { en: { title: 'Solo Van Life - Safety, Freedom, and Living Alone', excerpt: 'Solo van life demands intentional safety habits, social strategies, and resilience. The rewards are genuine, but so are the risks most travel guides understate.', body: '' } },
  },
  {
    id: '79',
    slug: 'off-grid-home-internet-connectivity-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-27',
    tags: ['off-grid', 'internet', 'starlink', 'connectivity', 'remote-work', 'satellite', 'mobile-data', 'structure-1', 'intro-6'],
    content: { en: { title: 'Starlink, Cellular, and Off-Grid Connectivity That Works', excerpt: 'Off-grid internet in 2026: whether Starlink fits your property, how much power it draws, when cellular beats satellite, and realistic monthly costs. Real data.', body: '' } },
  },
  {
    id: '80',
    slug: 'liveaboard-marina-vs-anchor-out-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533709752211-118fcaf03312?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-10',
    tags: ['boat-living', 'marina', 'anchoring', 'liveaboard', 'costs', 'community', 'freedom', 'mooring', 'structure-5', 'intro-3'],
    content: { en: { title: 'Marina vs. Anchor Out - What Liveaboards Actually Choose and Why', excerpt: 'The assumption that anchor-out is always cheaper and marina always more comfortable is often wrong. The cheapest setup is the one matched to how you actually.', body: '' } },
  },
  {
    id: '81',
    slug: 'camping-weather-reading-outdoor-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=1200&q=80',
    publishedAt: '2026-01-03',
    tags: ['camping', 'weather', 'clouds', 'wind', 'decision', 'safety', 'outdoor-skills', 'structure-3', 'intro-2'],
    content: { en: { title: 'Reading Weather in the Field - A Framework for Campers', excerpt: 'Read clouds, wind shifts, and barometric pressure to predict weather hours before it arrives. Practical field forecasting for campers without cell service.', body: '' } },
  },
  {
    id: '82',
    slug: 'van-life-vehicle-maintenance-beginners',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1493246507139-91e8fad9978e?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-02',
    tags: ['van-life', 'vehicle', 'maintenance', 'engine', 'oil', 'tyres', 'DIY', 'mechanics', 'structure-1', 'intro-5'],
    content: { en: { title: 'Van Life Vehicle Maintenance - Six Things That Matter', excerpt: 'Oil changes, brake inspections, tire rotation, and rust prevention - the six van maintenance tasks that prevent surprise breakdowns on long-distance trips.', body: '' } },
  },
  {
    id: '83',
    slug: 'off-grid-home-building-permits-regulations',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80',
    publishedAt: '2025-06-17',
    tags: ['off-grid', 'permits', 'regulations', 'zoning', 'planning', 'legal', 'building', 'structure-2', 'intro-3'],
    content: { en: { title: 'Off-Grid Building Permits - What to Check First', excerpt: 'Zoning codes, septic permits, and building inspections apply even off-grid. Know which permits your county requires before pouring foundations or digging wells.', body: '' } },
  },
  {
    id: '84',
    slug: 'liveaboard-boat-documentation-insurance-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=1200&q=80',
    publishedAt: '2025-02-09',
    tags: ['boat-living', 'insurance', 'documentation', 'registration', 'flag', 'legal', 'liveaboard', 'structure-6', 'intro-2'],
    content: { en: { title: 'Liveaboard Documentation and Insurance Explained', excerpt: 'You arrive in a foreign marina and customs asks for zarpe, crew list, and proof of insurance. Two of three is not enough - here is what you actually need.', body: '' } },
  },
  {
    id: '85',
    slug: 'camping-food-planning-backpacking-trips',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1596178065887-1198b6148b2b?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-16',
    tags: ['camping', 'food', 'meal-planning', 'nutrition', 'backpacking', 'calories', 'weight', 'structure-4', 'intro-6'],
    content: { en: { title: 'Backcountry Food Planning - A System That Works', excerpt: 'How many calories you need on trail, the 900g per day planning rule, why palatability matters as much as weight, and how altitude changes everything. Real data.', body: '' } },
  },
  {
    id: '86',
    slug: 'van-life-water-system-complete-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-29',
    tags: ['van-life', 'water', 'plumbing', 'fresh-water', 'grey-water', 'tank', 'pump', 'structure-2', 'intro-4'],
    content: { en: { title: 'Water Capacity for Van Life - How Much Is Enough', excerpt: 'A two-person van needs 6–10 gallons per day for drinking, cooking, and washing. Tank sizing, refill strategies, and conservation habits that prevent dry tanks.', body: '' } },
  },
  {
    id: '87',
    slug: 'off-grid-home-solar-battery-sizing-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-27',
    tags: ['off-grid', 'solar', 'battery', 'sizing', 'lithium', 'lead-acid', 'system-design', 'structure-3', 'intro-1'],
    content: { en: { title: 'Off-Grid Solar and Battery Sizing - LFP vs. AGM', excerpt: 'For a typical small off-grid home using 3–5 kWh per day: 3–4kW solar and a 15–20 kWh lithium iron phosphate battery bank. Everything else is refinement.', body: '' } },
  },
  {
    id: '88',
    slug: 'liveaboard-boat-electrical-systems-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1605281317010-fe5ffe798166?w=1200&q=80',
    publishedAt: '2025-10-07',
    tags: ['boat-living', 'electrical', '12v', 'battery', 'solar', 'inverter', 'shore-power', 'liveaboard', 'structure-1', 'intro-4'],
    content: { en: { title: 'Liveaboard Electrical Systems - What Boats Get Wrong', excerpt: 'Marine electrical systems fail differently than house wiring. Corrosion, voltage drop, and undersized cables cause most liveaboard electrical problems and.', body: '' } },
  },
  {
    id: '89',
    slug: 'camping-layering-system-clothing-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1563299796-17596ed6b017?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-15',
    tags: ['camping', 'clothing', 'layering', 'base-layer', 'mid-layer', 'shell', 'merino', 'waterproof', 'structure-5', 'intro-1'],
    content: { en: { title: 'The Camping Layering System - Three Layers, No Bulk', excerpt: 'Three layers handle every camping condition better than one heavy jacket. Understanding why each layer exists changes how you dress outdoors forever. Real data.', body: '' } },
  },
  {
    id: '90',
    slug: 'van-life-budget-planning-monthly-costs',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-01',
    tags: ['van-life', 'budget', 'costs', 'money', 'fuel', 'campsite', 'insurance', 'food', 'finances', 'structure-3', 'intro-6'],
    content: { en: { title: 'Van Life Budget Planning - Two Monthly Cost Profiles', excerpt: 'Van life costs fall into two clear profiles: $800–$1,200 shoestring or $1,500–$2,500 comfortable. Which one is sustainable depends on your income. Real data.', body: '' } },
  },
  {
    id: '91',
    slug: 'off-grid-home-wood-stove-heating-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544085311-11a028465b03?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-10',
    tags: ['off-grid', 'wood-stove', 'heating', 'firewood', 'installation', 'flue', 'chimney', 'winter', 'structure-4', 'intro-5'],
    content: { en: { title: 'Off-Grid Wood Stove Heating - Selection and Operation', excerpt: 'Sizing a wood stove to your space, installing it safely, and operating it efficiently requires specific knowledge. This step-by-step guide covers all three.', body: '' } },
  },
  {
    id: '92',
    slug: 'liveaboard-boat-safety-equipment-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534008897995-27a23e859048?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-25',
    tags: ['boat-living', 'safety', 'epirb', 'life-raft', 'flares', 'lifejacket', 'jacklines', 'harness', 'liveaboard', 'structure-2', 'intro-6'],
    content: { en: { title: 'Liveaboard Safety Equipment - What You Actually Need', excerpt: 'Most production boats arrive with safety gear calibrated for weekend sailing, not full-time liveaboard use. Here is what needs upgrading and why. Real data.', body: '' } },
  },
  {
    id: '93',
    slug: 'camping-responsible-wildlife-encounters',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504567961542-e24d9439a724?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-01',
    tags: ['camping', 'wildlife', 'bear', 'safety', 'food-storage', 'encounters', 'wilderness', 'nature', 'structure-6', 'intro-4'],
    content: { en: { title: 'Wildlife Encounters While Camping - Stay Safe', excerpt: 'Most wildlife encounters go wrong because of preparation failures before the encounter happened. Prevention eliminates 90% of incidents; response covers the.', body: '' } },
  },
  {
    id: '94',
    slug: 'van-life-extreme-weather-hot-cold-survival',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1489549132488-d00b7eee80f1?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-04',
    tags: ['van-life', 'extreme-weather', 'heat', 'cold', 'desert', 'winter', 'cooling', 'heating', 'survival', 'structure-4', 'intro-2'],
    content: { en: { title: 'Van Life Extreme Weather - Surviving Heat and Cold', excerpt: 'A van in direct sun at 95°F reaches 140°F inside within 30 minutes. A van at -14°F without heating becomes dangerous in hours. Preparation for both matters.', body: '' } },
  },
  {
    id: '96',
    slug: 'liveaboard-boat-engine-maintenance-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502472584811-0a2f2feb8968?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-22',
    tags: ['boat-living', 'engine', 'diesel', 'maintenance', 'inboard', 'outboard', 'oil', 'coolant', 'impeller', 'liveaboard', 'structure-3', 'intro-1'],
    content: { en: { title: 'Liveaboard Engine Maintenance - DIY vs. Professional', excerpt: 'For a typical marine diesel: oil changes, impeller replacement, and zinc inspection are straightforward DIY. Injector service and valve adjustment need a pro.', body: '' } },
  },
  {
    id: '97',
    slug: 'camping-knots-essential-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1496545672447-f699b503d270?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-12',
    tags: ['camping', 'knots', 'rope', 'tarp', 'shelter', 'bear-hang', 'hitches', 'structure-1', 'intro-2'],
    content: { en: { title: 'Essential Camping Knots - Four Knots That Handle 90% of Camp', excerpt: 'Four knots handle 90% of camp rope work: bowline for loops, clove hitch for posts, taut-line for tensioning, and trucker hitch for securing heavy loads.', body: '' } },
  },
  {
    id: '98',
    slug: 'van-life-mental-health-wellbeing-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1557409518-691ebcd96038?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-18',
    tags: ['van-life', 'mental-health', 'wellbeing', 'loneliness', 'burnout', 'anxiety', 'routine', 'structure-5', 'intro-5'],
    content: { en: { title: 'Van Life and Mental Health - What the Road Does to You', excerpt: 'Whether van life helps or hurts mental health depends on your relationship with solitude, social habits, and whether constant novelty energizes or drains you.', body: '' } },
  },
  {
    id: '99',
    slug: 'off-grid-home-guest-hosting-community',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1523301343968-6a6ebf63c672?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-12',
    tags: ['off-grid', 'community', 'guests', 'hosting', 'isolation', 'social', 'neighbors', 'workaway', 'wwoof', 'structure-6', 'intro-3'],
    content: { en: { title: 'Off-Grid Community - Social Life in Remote Locations', excerpt: 'The assumption is that off-grid means isolation. People who have lived this way for years say the opposite - off-grid life demands more intentional community.', body: '' } },
  },
  {
    id: '100',
    slug: 'liveaboard-boat-storage-organization-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-16',
    tags: ['boat-living', 'storage', 'organization', 'provisioning', 'space', 'minimalism', 'stowage', 'liveaboard', 'structure-4', 'intro-5'],
    content: { en: { title: 'Liveaboard Storage - Making Limited Space Work', excerpt: 'How much storage matters depends on your boat size and whether you cruise offshore or stay coastal. This step-by-step system scales to both situations.', body: '' } },
  },
  {
    id: '101',
    slug: 'camping-water-purification-filtration-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500049242364-5f500807cdd7?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-08',
    tags: ['camping', 'water', 'purification', 'filtration', 'giardia', 'sawyer', 'backcountry', 'safety', 'structure-2', 'intro-4'],
    content: { en: { title: 'Purifying Water While Camping - Filters, UV, and More', excerpt: 'Backcountry water carries giardia and crypto risk. Three purification methods solve it differently - each with distinct trade-offs in speed, weight, and cost.', body: '' } },
  },
  {
    id: '102',
    slug: 'van-life-electrical-system-beginners-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-18',
    tags: ['van-life', 'electrical', 'solar', 'battery', 'lfp', 'inverter', 'charging', 'power', 'structure-6', 'intro-3'],
    content: { en: { title: 'Van Life Electrical: Three-Tier Power Systems Explained', excerpt: 'Most van lifers over-build their electrical system. A weekender needs 100Ah; a full-timer needs 200–400Ah. Match your system to actual daily power use.', body: '' } },
  },
  {
    id: '103',
    slug: 'off-grid-home-well-water-drilling-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1468421870903-4df1664ac249?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-01',
    tags: ['off-grid', 'well', 'water', 'drilling', 'groundwater', 'pump', 'aquifer', 'rural', 'structure-1', 'intro-5'],
    content: { en: { title: 'Off-Grid Well Water - Drilling Costs and Well Types', excerpt: 'Well drilling costs $25–$65 per foot with most residential wells at 100–400ft depth. Geology, water table depth, and local regulations determine your actual.', body: '' } },
  },
  {
    id: '104',
    slug: 'liveaboard-boat-weather-routing-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534224039826-c7a0eda0e6b3?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-19',
    tags: ['boat-living', 'weather', 'routing', 'passage-planning', 'grib', 'forecast', 'wind', 'offshore', 'structure-5', 'intro-2'],
    content: { en: { title: 'Weather Routing for Liveaboard Sailors at Sea', excerpt: 'Weather routing uses GRIB files, synoptic charts, and weather windows to plan passages. The 48–72 hour forecast window is the planning unit that matters most.', body: '' } },
  },
  {
    id: '105',
    slug: 'camping-tent-vs-tarp-shelter-decision',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1478827536114-da961b7f86d2?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-25',
    tags: ['camping', 'tent', 'tarp', 'shelter', 'bivy', 'ultralight', 'weight', 'weather-protection', 'structure-3', 'intro-6'],
    content: { en: { title: 'Tent vs. Tarp vs. Bivy - Choosing the Right Camping Shelter', excerpt: 'A quality tarp weighs 400–600g vs. a 3-season tent at 1.5–2.5kg. But weight is only one factor - weather protection, setup skill, and bug pressure matter.', body: '' } },
  },
  {
    id: '106',
    slug: 'van-life-insurance-registration-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530521954074-e64f6810b32d?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-29',
    tags: ['van-life', 'insurance', 'registration', 'legal', 'dwelling', 'conversion', 'coverage', 'structure-1', 'intro-1'],
    content: { en: { title: 'Insurance Essentials for Full-Time Van Dwellers', excerpt: 'Vehicle insurance plus a dwelling rider covers your converted van. The conversion value gap - a $15,000 build unprotected by standard auto - is the key risk.', body: '' } },
  },
  {
    id: '107',
    slug: 'off-grid-home-septic-system-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-22',
    tags: ['off-grid-homes', 'septic', 'wastewater', 'structure-2', 'intro-1'],
    content: { en: { title: 'Off-Grid Septic Systems - Choosing the Right Wastewater Solution', excerpt: 'Conventional septic costs $3,000–$7,000. Advanced off-grid alternatives run $10,000–$20,000. Picking the wrong system means expensive remediation. Real data.', body: '' } },
  },
  {
    id: '108',
    slug: 'liveaboard-boat-diy-repairs-skills-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519810755548-39cd217da494?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-20',
    tags: ['boat-living', 'repairs', 'diy', 'maintenance', 'structure-6', 'intro-6'],
    content: { en: { title: 'Essential DIY Repair Skills Every Liveaboard Sailor Needs', excerpt: 'Most marina mechanics charge $100–$150/hour with multi-day wait times. A $200–$400 tool kit and five core skills handle 80% of common liveaboard failures.', body: '' } },
  },
  {
    id: '109',
    slug: 'camping-fire-building-techniques-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1475483768296-6163e08872a1?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-19',
    tags: ['camping', 'fire', 'skills', 'bushcraft', 'structure-4', 'intro-1'],
    content: { en: { title: 'Campfire Building Techniques - From Spark to Sustained Flame', excerpt: 'Birch bark ignites at 230°C while pine needles need 275°C. Understanding ignition temperatures and fuel progression turns campfire building from luck into.', body: '' } },
  },
  {
    id: '110',
    slug: 'van-life-remote-work-productivity-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-16',
    tags: ['mobile-living', 'remote-work', 'productivity', 'digital-nomad', 'structure-3', 'intro-2'],
    content: { en: { title: 'Remote Work from a Van - Productivity Systems That Actually Work', excerpt: 'A coffee shop has unlimited power and fast wifi. Your van has 200Ah and Starlink. Different constraints demand completely different productivity systems.', body: '' } },
  },
  {
    id: '113',
    slug: 'camping-wildlife-safety-bear-awareness',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-30',
    tags: ['camping', 'safety', 'wildlife', 'bears', 'structure-5', 'intro-2'],
    content: { en: { title: 'Wildlife Safety While Camping - Bear Awareness', excerpt: 'Practical wildlife safety protocols for camping in bear country and beyond. Real encounter data, food storage systems, and response strategies. Real data.', body: '' } },
  },
  {
    id: '114',
    slug: 'van-life-conversion-budget-planning',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1596402184320-417e7178b2cd?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-02',
    tags: ['mobile-living', 'van-life', 'budget', 'conversion', 'structure-3', 'intro-1'],
    content: { en: { title: 'Van Conversion Budget - Prioritizing Your Build Spend', excerpt: 'A practical decision framework for van conversion budgets. Where to splurge, where to save, and how to avoid the $3,000 mistakes most builders make. Real data.', body: '' } },
  },
  {
    id: '115',
    slug: 'off-grid-rainwater-harvesting-systems',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-16',
    tags: ['off-grid', 'water', 'rainwater', 'harvesting', 'self-sufficiency', 'structure-4', 'intro-5'],
    content: { en: { title: 'Off-Grid Rainwater Harvesting - System Design Guide', excerpt: 'Step-by-step rainwater harvesting system design for off-grid homes. Catchment calculations, filtration stages, and storage sizing based on real rainfall data.', body: '' } },
  },
  {
    id: '117',
    slug: 'camping-wet-weather-rain-strategies',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1515942661900-94b3d1972591?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-06',
    tags: ['camping', 'weather', 'rain', 'wet-weather', 'gear', 'structure-6', 'intro-3'],
    content: { en: { title: 'Camping in Rain - Strategies to Stay Comfortable', excerpt: 'Wet weather camping strategies that go beyond "bring a rain jacket." Site selection, tarp architecture, gear management, and the mindset shift that matters.', body: '' } },
  },
  {
    id: '118',
    slug: 'van-life-water-systems-plumbing-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-01',
    tags: ['mobile-living', 'van-life', 'water', 'plumbing', 'systems', 'structure-4', 'intro-2'],
    content: { en: { title: 'Camper Van Plumbing - Tanks, Pumps, and Pipes', excerpt: 'Step-by-step van plumbing installation from tank to tap. Sizing calculations, pump selection, water heating options, and the grey water solutions that.', body: '' } },
  },
  {
    id: '120',
    slug: 'liveaboard-anchoring-techniques-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1536599424071-0b215a388ba7?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-25',
    tags: ['boat-living', 'anchoring', 'seamanship', 'safety', 'structure-3', 'intro-5'],
    content: { en: { title: 'Anchoring Techniques for Liveaboards - Ground Tackle', excerpt: 'A decision framework for liveaboard anchoring: anchor types, rode selection, setting technique, and the scope calculations that prevent midnight drag alarms.', body: '' } },
  },
  {
    id: '121',
    slug: 'camping-gear-field-repair-diy-fixes',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1532339142463-fd0a8979791a?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-22',
    tags: ['camping', 'gear', 'maintenance', 'repair', 'equipment', 'structure-1', 'intro-4'],
    content: { en: { title: 'Camping Gear Maintenance - Keep Equipment Working', excerpt: 'Direct answers on gear maintenance that actually extends equipment life. Tent care, sleeping bag washing, stove servicing, and the field repairs that save.', body: '' } },
  },
  {
    id: '122',
    slug: 'van-life-parking-stealth-camping-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1543465077-db45d34b88a5?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-14',
    tags: ['mobile-living', 'van-life', 'parking', 'stealth', 'boondocking', 'structure-5', 'intro-3'],
    content: { en: { title: 'Finding Legal Overnight Parking for Van Dwellers', excerpt: 'The real rules behind stealth camping and van parking. Legal frameworks, spot-finding strategies, and the behavioral patterns that avoid knocks at 2 AM.', body: '' } },
  },
  {
    id: '124',
    slug: 'liveaboard-with-children-family-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516728778615-2d590ea1855e?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-01',
    tags: ['boat-living', 'family', 'children', 'liveaboard', 'education', 'structure-4', 'intro-6'],
    content: { en: { title: 'Living Aboard a Boat With Children - A Step-by-Step Family Guide', excerpt: 'Everything involved in raising children on a liveaboard boat. Safety systems, education options, social development, and the space adaptations families.', body: '' } },
  },
  {
    id: '125',
    slug: 'camping-navigation-map-compass-skills',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1455763916899-e8b50eca9967?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-14',
    updatedAt: '2026-07-22',
    tags: ['structure-2', 'intro-5'],
    content: { en: { title: 'Camping Navigation Without GPS - Map and Compass', excerpt: 'Practical map reading, compass navigation, and offline app strategies for backcountry camping - including declination, route planning, and GPS backup skills.', body: '' } },
  },
  {
    id: '126',
    slug: 'camping-high-altitude-mountain-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1542359649-31e03cd4d909?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-25',
    tags: ['structure-3', 'intro-6'],
    content: { en: { title: 'High Altitude Camping - What Your Body Needs Above 8,000 Feet', excerpt: 'Everything about high altitude camping from acclimatization schedules to gear choices. Understand altitude sickness, weather dangers, and sleep at elevation.', body: '' } },
  },
  {
    id: '127',
    slug: 'camping-foraging-wild-edibles-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517164850305-99a3e65bb47e?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-31',
    tags: ['structure-4', 'intro-1'],
    content: { en: { title: 'Foraging While Camping - A Practical Guide to Wild Edibles', excerpt: 'Safe foraging basics for campers: identification rules, seasonal edibles, poisonous lookalikes, and responsible harvesting in backcountry settings. Real data.', body: '' } },
  },
  {
    id: '128',
    slug: 'van-life-solar-power-complete-setup',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501877008226-4fca48ee50c1?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-02',
    tags: ['structure-6', 'intro-4'],
    content: { en: { title: 'Van Life Solar Power - Complete Setup From Panels to Battery Bank', excerpt: 'Design a reliable van solar system from scratch. Panel sizing, MPPT controllers, lithium batteries, and real-world power budgets for full-time van life.', body: '' } },
  },
  {
    id: '129',
    slug: 'van-life-cold-weather-winter-living',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1477346611705-65d1883cee1e?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-21',
    tags: ['structure-1', 'intro-5'],
    content: { en: { title: 'Winter Van Life - How to Live in a Van When It\'s Freezing Outside', excerpt: 'Survive and thrive in a van during winter. Insulation strategies, heating systems, condensation management, and cold-weather routines below freezing point.', body: '' } },
  },
  {
    id: '130',
    slug: 'van-life-meal-planning-grocery-budget',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-04',
    tags: ['structure-2', 'intro-6'],
    content: { en: { title: 'Van Life Meal Planning - How to Eat Well on a Tight Grocery', excerpt: 'Practical meal planning for van dwellers on a budget. Fridge management, grocery strategies, no-waste cooking, and realistic food costs for life on the road.', body: '' } },
  },
  {
    id: '131',
    slug: 'off-grid-wind-power-small-turbine-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-29',
    tags: ['structure-1', 'intro-2'],
    content: { en: { title: 'Small Wind Turbines for Off-Grid Homes - What Actually Works', excerpt: 'Honest guide to residential wind power for off-grid living. Turbine sizing, site assessment, tower height, and when wind makes sense vs. solar alone. Real data.', body: '' } },
  },
  {
    id: '132',
    slug: 'off-grid-food-preservation-storage',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502786129293-79981df4e689?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-18',
    tags: ['structure-2', 'intro-3'],
    content: { en: { title: 'Off-Grid Food Preservation Without Electricity', excerpt: 'Master food preservation without grid power. Fermentation, dehydration, root cellaring, salt curing, and smoke preservation for off-grid homesteads. Real data.', body: '' } },
  },
  {
    id: '133',
    slug: 'off-grid-cabin-insulation-weatherproofing',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1471513671800-b09c87e1497c?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-13',
    tags: ['structure-3', 'intro-4'],
    content: { en: { title: 'Off-Grid Cabin Insulation - R-Values and Vapor Barriers', excerpt: 'Complete insulation guide for off-grid cabins. Material comparisons, R-value targets by climate, vapor barrier placement, and air sealing techniques. Real data.', body: '' } },
  },
  {
    id: '134',
    slug: 'liveaboard-navigation-coastal-cruising',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-04',
    tags: ['structure-5', 'intro-1'],
    content: { en: { title: 'Coastal Navigation for Liveaboards - Charts and Tides', excerpt: 'Master coastal navigation for liveaboard sailing. Chart reading, tidal calculations, GPS integration, and passage planning for cruising sailors. Real data.', body: '' } },
  },
  {
    id: '135',
    slug: 'liveaboard-freshwater-systems-watermaker',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-11',
    tags: ['structure-6', 'intro-2'],
    content: { en: { title: 'Freshwater Systems for Liveaboards - Tanks and Filters', excerpt: 'Liveaboard freshwater management from tank sizing to filters. Tank sizing, filtration systems, watermaker operation, and water conservation for cruising sailors.', body: '' } },
  },
  {
    id: '136',
    slug: 'liveaboard-storm-preparation-heavy-weather',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1583394293214-28ded15ee548?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-21',
    tags: ['structure-1', 'intro-3'],
    content: { en: { title: 'Storm Preparation for Liveaboards - Heavy Weather', excerpt: 'Prepare your liveaboard for severe weather. Storm anchoring, emergency equipment, hurricane holes, and heavy weather procedures for cruising sailors. Real data.', body: '' } },
  },
  {
    id: '137',
    slug: 'camping-water-purification-safe-drinking',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600240644455-3edc55c375fe?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-24',
    tags: ['camping', 'water', 'safety', 'purification', 'structure-5', 'intro-2'],
    content: { en: { title: 'Making Wild Water Safe - A Campers Guide', excerpt: 'Four proven methods to purify water in the field - filters, UV light, chemical tablets, and boiling - with real costs and limitations for each. Real data.', body: '' } },
  },
  {
    id: '139',
    slug: 'camping-photography-nature-tips',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-07',
    tags: ['camping', 'photography', 'nature', 'tips', 'structure-1', 'intro-4'],
    content: { en: { title: 'Camping Photography - Better Nature Photos on a Budget', excerpt: 'Photography techniques for campers - golden hour timing, composition rules, phone vs camera trade-offs, and wildlife ethics that protect both subjects and.', body: '' } },
  },
  {
    id: '140',
    slug: 'van-life-electrical-system-wiring-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502161254066-6c74afbf07aa?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-24',
    tags: ['mobile-living', 'electrical', 'wiring', 'solar', 'structure-3', 'intro-1'],
    content: { en: { title: 'Van Life 12V Electrical System - Wiring and Setup Guide', excerpt: 'How to wire a safe 12V electrical system in your van - fuse panels, wire gauges, charge controllers, and the 230V inverter decision with real costs. Real data.', body: '' } },
  },
  {
    id: '141',
    slug: 'van-life-hygiene-shower-solutions',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1570710891163-6d3b5c47248b?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-26',
    tags: ['mobile-living', 'hygiene', 'shower', 'water', 'structure-4', 'intro-2'],
    content: { en: { title: 'Van Life Hygiene - Staying Clean Without a Bathroom', excerpt: 'Portable showers, gym memberships, and water-saving techniques for van dwellers - the daily hygiene routines that actually work on the road. Real data.', body: '' } },
  },
  {
    id: '142',
    slug: 'van-life-parking-overnight-spots-europe',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-02',
    updatedAt: '2026-07-22',
    tags: ['mobile-living', 'parking', 'europe', 'overnight', 'structure-5', 'intro-3'],
    content: { en: { title: 'Van Life Parking in Europe - Country Rules and Apps', excerpt: 'Overnight parking across Europe - 2026 legal frameworks by country, apps like Park4Night and Caramaps, safety protocols, and unwritten vanlife rules.', body: '' } },
  },
  {
    id: '143',
    slug: 'off-grid-natural-building-materials-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1439853949127-fa647821eba0?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-18',
    updatedAt: '2026-04-02',
    tags: ['off-grid-homes', 'building', 'natural-materials', 'construction', 'structure-4', 'intro-5'],
    content: { en: { title: 'Natural Building Materials - Cob, Straw Bale and Earth', excerpt: 'Comparing natural building materials - cob, straw bale, rammed earth, and timber frame - with real costs, thermal performance, and building code realities.', body: '' } },
  },
  {
    id: '144',
    slug: 'off-grid-livestock-small-animals-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-26',
    updatedAt: '2026-07-22',
    tags: ['off-grid-homes', 'livestock', 'animals', 'homesteading', 'structure-5', 'intro-6'],
    content: { en: { title: 'Off-Grid Livestock - Chickens, Goats, and Bees', excerpt: 'Raising chickens, goats, and bees off-grid - space needs, feed costs, regulatory hurdles, and the honest time commitment each animal demands from you.', body: '' } },
  },
  {
    id: '145',
    slug: 'off-grid-septic-waste-management',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-01',
    tags: ['off-grid-homes', 'septic', 'waste', 'composting', 'structure-6', 'intro-1'],
    content: { en: { title: 'Off-Grid Septic and Waste Management - Systems That Actually Work', excerpt: 'Off-grid waste management - conventional septic, aerobic treatment, composting toilets, and greywater systems with real installation costs and maintenance.', body: '' } },
  },
  {
    id: '146',
    slug: 'liveaboard-diesel-engine-maintenance',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-16',
    tags: ['boat-living', 'diesel', 'engine', 'maintenance', 'structure-2', 'intro-4'],
    content: { en: { title: 'Liveaboard Diesel Engine Maintenance Year-Round', excerpt: 'Diesel engine care for liveaboards - fuel filters, impeller replacement, cooling systems, winterization, and the 200-hour service schedule that works.', body: '' } },
  },
  {
    id: '147',
    slug: 'liveaboard-dinghy-tender-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-13',
    updatedAt: '2026-07-22',
    tags: ['boat-living', 'dinghy', 'tender', 'outboard', 'structure-3', 'intro-5'],
    content: { en: { title: 'Liveaboard Dinghy Guide - Choosing Your Shore Boat', excerpt: 'Choosing the right dinghy for liveaboard life - inflatable vs rigid, outboard sizing, storage solutions, security, and maintenance for your shore connection.', body: '' } },
  },
  {
    id: '148',
    slug: 'liveaboard-marina-etiquette-community',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1545579133-99bb5ab189bd?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-07',
    tags: ['boat-living', 'marina', 'etiquette', 'community', 'structure-4', 'intro-6'],
    content: { en: { title: 'Liveaboard Community - Building Trust at the Marina', excerpt: 'Marina culture explained - dock manners, noise expectations, shared facility etiquette, and the social dynamics that shape your liveaboard experience.', body: '' } },
  },
  {
    id: '149',
    slug: 'camping-altitude-mountain-safety',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-28',
    updatedAt: '2026-05-20',
    tags: ['camping', 'mountain', 'altitude', 'safety', 'hiking', 'structure-2', 'intro-5'],
    content: { en: { title: 'Camping at Altitude - Mountain Safety and Acclimatization', excerpt: 'Mountain camping demands respect for altitude. Learn AMS symptoms, acclimatization strategies, and essential gear for safe high-elevation camping. Real data.', body: '' } },
  },
  {
    id: '151',
    slug: 'camping-campsite-selection-terrain',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-31',
    tags: ['camping', 'campsite', 'terrain', 'safety', 'leave-no-trace', 'structure-4', 'intro-1'],
    content: { en: { title: 'Campsite Selection - Reading Terrain for the Perfect Pitch', excerpt: 'Where you pitch your tent matters more than which tent you carry. Master terrain reading, drainage assessment, and hazard avoidance for better camping.', body: '' } },
  },
  {
    id: '152',
    slug: 'van-life-ventilation-moisture-control',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1489824904134-891ab64532f1?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-05',
    updatedAt: '2026-05-21',
    tags: ['van-life', 'ventilation', 'moisture', 'condensation', 'mold', 'structure-6', 'intro-4'],
    content: { en: { title: 'Van Life Ventilation and Moisture Control - Beating Condensation', excerpt: 'Condensation destroys vans from the inside. Learn ventilation design, moisture barriers, and daily habits that keep your mobile home dry and mold-free.', body: '' } },
  },
  {
    id: '154',
    slug: 'van-life-laundry-clothing-management',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1529042410759-befb1204b468?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-26',
    tags: ['van-life', 'laundry', 'clothing', 'minimalism', 'practical', 'structure-2', 'intro-6'],
    content: { en: { title: 'Van Life Laundry - Clothing Management on the Road', excerpt: 'Laundry is the unglamorous reality of van life nobody posts about. Master laundromats, hand-washing techniques, and minimalist wardrobes that actually work.', body: '' } },
  },
  {
    id: '156',
    slug: 'off-grid-community-cohousing-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516156008625-3a9d6067fab5?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-29',
    tags: ['off-grid', 'community', 'cohousing', 'ecovillage', 'shared infrastructure', 'structure-2', 'intro-3'],
    content: { en: { title: 'Off-Grid Community Living - Cohousing and Ecovillages', excerpt: 'How off-grid cohousing and ecovillages actually work - shared infrastructure, governance models, conflict resolution, and realistic costs. With costs.', body: '' } },
  },
  {
    id: '157',
    slug: 'off-grid-internet-connectivity-remote',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-06',
    tags: ['off-grid', 'internet', 'starlink', 'connectivity', 'remote work', 'mesh network', 'structure-3', 'intro-4'],
    content: { en: { title: 'Staying Connected Off-Grid in Remote Areas', excerpt: 'Satellite, cellular boosters, and mesh networks for off-grid homes - real speeds, actual costs, and which setup matches your needs. Field-tested tips.', body: '' } },
  },
  {
    id: '158',
    slug: 'liveaboard-electrical-systems-marine',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500930556163-5c29ef82e76b?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-25',
    tags: ['boat-living', 'electrical', '12V', 'solar', 'marine batteries', 'shore power', 'structure-5', 'intro-1'],
    content: { en: { title: 'Liveaboard Electrical Systems - Marine Power Explained', excerpt: '12V and 24V marine electrical systems explained - battery banks, solar panels, shore power hookups, and the safety essentials every liveaboard needs. Real data.', body: '' } },
  },
  {
    id: '159',
    slug: 'liveaboard-anchoring-mooring-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-17',
    tags: ['boat-living', 'anchoring', 'mooring', 'seamanship', 'ground tackle', 'structure-6', 'intro-2'],
    content: { en: { title: 'Anchoring and Mooring for Liveaboards - Staying Put Safely', excerpt: 'Anchor types, scope calculations, and dragging prevention for full-time liveaboards - plus mooring options and overnight anchoring strategies. Real data.', body: '' } },
  },
  {
    id: '160',
    slug: 'liveaboard-provisioning-long-voyages',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1553531384-cc64ac80f931?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-20',
    updatedAt: '2026-03-30',
    tags: ['boat-living', 'provisioning', 'food storage', 'water management', 'passage planning', 'structure-1', 'intro-3'],
    content: { en: { title: 'Provisioning for Long Voyages - Food, Water and Fuel Plans', excerpt: 'How to provision a liveaboard boat for extended passages - food, water, fuel, freeze-dried backup, and port resupply strategies with 2026 cost data.', body: '' } },
  },
  {
    id: '161',
    slug: 'camping-desert-heat-survival-tips',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-03',
    tags: ['camping', 'desert', 'heat', 'survival', 'hydration', 'structure-5', 'intro-2'],
    content: { en: { title: 'Desert Camping in Extreme Heat - Survival Strategies', excerpt: 'Desert camping demands specific heat management techniques most campers never learn. From hydration math to shade architecture and cooling strategies.', body: '' } },
  },
  {
    id: '162',
    slug: 'camping-fishing-basics-catch-cook',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504309092620-4d0ec726efa4?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-27',
    tags: ['camping', 'fishing', 'cooking', 'outdoor-skills', 'catch-and-cook', 'structure-6', 'intro-3'],
    content: { en: { title: 'Camp Fishing Fundamentals - From First Cast to Fireside Meal', excerpt: 'Catch and cook your own fish while camping with practical tackle advice, technique, local regulations, and campfire cooking methods that make the effort.', body: '' } },
  },
  {
    id: '164',
    slug: 'van-life-solar-panel-setup-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1553697388-94e804e2f0f6?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-17',
    tags: ['mobile-living', 'solar', 'electrical', 'van-life', 'diy', 'structure-3', 'intro-1'],
    content: { en: { title: 'Van Life Solar Panel Setup - The Complete Decision Guide', excerpt: 'How to choose the right solar panel setup for your van - wattage, budget, roof space, and real energy needs explained for first-time builders. Real data.', body: '' } },
  },
  {
    id: '165',
    slug: 'van-life-budgeting-monthly-costs',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1498036882173-b41c28a8ba34?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-29',
    tags: ['mobile-living', 'budget', 'costs', 'van-life', 'finance', 'structure-4', 'intro-2'],
    content: { en: { title: 'Van Life Monthly Budget - Real Costs Broken Down by Category', excerpt: 'Van life costs $800–$2,500/month depending on your lifestyle. A real breakdown by category that most budget guides leave out entirely with real costs.', body: '' } },
  },
  {
    id: '166',
    slug: 'van-life-cooking-one-burner-meals',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-05',
    updatedAt: '2026-03-31',
    tags: ['mobile-living', 'cooking', 'meals', 'van-life', 'one-burner', 'nutrition', 'structure-5', 'intro-3'],
    content: { en: { title: 'One-Burner Van Life Cooking - Meals That Actually Satisfy', excerpt: 'One-burner stove techniques, one-pot recipes, cold-weather cooking tips, and fuel efficiency for compact van kitchens - including 2026 cost breakdowns.', body: '' } },
  },
  {
    id: '168',
    slug: 'off-grid-firewood-heating-efficiency',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1595521624992-48a59aef95e3?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-04',
    tags: ['off-grid-homes', 'firewood', 'heating', 'wood-stove', 'efficiency', 'winter', 'structure-5', 'intro-6'],
    content: { en: { title: 'Firewood Heating for Off-Grid Homes - Efficiency That Matters', excerpt: 'Firewood heating is simple in theory but complex in practice. Efficient vs wasteful wood heating is measured in cords burned and dollars saved each winter.', body: '' } },
  },
  {
    id: '170',
    slug: 'liveaboard-weather-routing-passage',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1549439602-43ebca2327af?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-16',
    tags: ['boat-living', 'weather', 'routing', 'passage-planning', 'safety', 'structure-2', 'intro-4'],
    content: { en: { title: 'Weather Routing for Liveaboard Passage Planning', excerpt: 'Passage weather routing separates comfortable crossings from dangerous ones. GRIB files, barometer trends, and seasonal patterns form the foundation of safety.', body: '' } },
  },
  {
    id: '171',
    slug: 'liveaboard-hull-maintenance-antifouling',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1525183995014-bd94c0750cd5?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-10',
    tags: ['boat-living', 'hull', 'maintenance', 'antifouling', 'haul-out', 'structure-3', 'intro-5'],
    content: { en: { title: 'Hull Maintenance and Antifouling for Liveaboards', excerpt: 'Hull maintenance is the most expensive recurring cost of boat ownership. The right antifouling strategy and haul-out schedule saves thousands over a decade.', body: '' } },
  },
  {
    id: '172',
    slug: 'liveaboard-safety-equipment-emergency',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-04',
    tags: ['boat-living', 'safety', 'equipment', 'emergency', 'epirb', 'life-raft', 'structure-4', 'intro-6'],
    content: { en: { title: 'Liveaboard Safety Equipment - What You Actually Need Aboard', excerpt: 'Safety gear for liveaboards goes beyond coast guard minimums - fire extinguishers, EPIRBs, jacklines, and medical kits sized for the waters you actually sail.', body: '' } },
  },
  {
    id: '173',
    slug: 'camping-river-crossing-water-safety',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-23',
    tags: ['camping', 'safety', 'water', 'river', 'crossing', 'structure-2', 'intro-5'],
    content: { en: { title: 'River Crossing Safety - Reading Water While Camping', excerpt: 'Learn to read current strength, choose safe crossing points, and use proper technique - because most backcountry drownings happen during river crossings.', body: '' } },
  },
  {
    id: '174',
    slug: 'camping-tarp-shelter-setups-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1558979158-65a1eaa08691?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-16',
    tags: ['camping', 'tarp', 'shelter', 'ultralight', 'bushcraft', 'structure-3', 'intro-6'],
    content: { en: { title: 'Tarp Shelter Setups for Every Weather Condition', excerpt: 'Master six tarp configurations from basic A-frame to storm-worthy setups - lighter than a tent, more versatile, and surprisingly weatherproof when pitched.', body: '' } },
  },
  {
    id: '175',
    slug: 'camping-hygiene-sanitation-outdoors',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-06',
    tags: ['camping', 'hygiene', 'sanitation', 'leave-no-trace', 'health', 'structure-4', 'intro-1'],
    content: { en: { title: 'Camping Hygiene - Staying Clean and Healthy Outdoors', excerpt: 'Staying clean, managing waste, and protecting water sources while camping - showers, dental care, sanitation, and Leave No Trace hygiene in practice. Real data.', body: '' } },
  },
  {
    id: '176',
    slug: 'van-life-electrical-system-basics',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1511988617509-a57c8a288659?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-22',
    tags: ['mobile-living', 'electrical', 'vanlife', '12v', 'wiring', 'structure-6', 'intro-4'],
    content: { en: { title: '12V Wiring Basics for Camper Vans: A Beginner Guide', excerpt: 'Understand 12V circuits, fuse sizing, wire gauges, and common electrical faults - the foundational knowledge every van dweller needs before touching a single.', body: '' } },
  },
  {
    id: '177',
    slug: 'van-life-finding-free-campsites',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1473625247510-8ceb1760943f?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-15',
    tags: ['mobile-living', 'vanlife', 'campsites', 'free-camping', 'boondocking', 'structure-1', 'intro-5'],
    content: { en: { title: 'Free Campsites for Van Life - Apps and Practical Ethics', excerpt: 'Discover where to park overnight for free, which apps actually work, wild camping laws across regions, and the ethics that keep spots open for everyone.', body: '' } },
  },
  {
    id: '178',
    slug: 'van-life-pet-friendly-travel-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501554728187-ce583db33af7?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-06',
    tags: ['mobile-living', 'vanlife', 'pets', 'travel', 'dogs', 'cats', 'structure-2', 'intro-6'],
    content: { en: { title: 'Pets on the Road - Temperature, Vets, and Borders', excerpt: 'Temperature extremes, veterinary care, border requirements, and daily routines that keep pets healthy during full-time van travel across multiple countries.', body: '' } },
  },
  {
    id: '180',
    slug: 'off-grid-seasonal-living-rhythms',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-07',
    tags: ['off-grid-homes', 'seasonal', 'rhythms', 'self-sufficiency', 'mental-health', 'structure-2', 'intro-3'],
    content: { en: { title: 'Seasonal Living Off-Grid - Energy and Food Rhythms', excerpt: 'Align off-grid life with seasonal energy production, food growing cycles, and maintenance schedules - plus strategies for the psychological side of winter.', body: '' } },
  },
  {
    id: '181',
    slug: 'off-grid-well-drilling-water-source',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1429552077091-836152271555?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-14',
    tags: ['off-grid-homes', 'water', 'well', 'drilling', 'pump', 'self-sufficiency', 'structure-3', 'intro-4'],
    content: { en: { title: 'Well Drilling Off-Grid - Depth, Permits, and Pumps', excerpt: 'Well drilling from hydrogeological assessment to pump selection and water testing - including realistic costs and alternatives when conventional drilling fails.', body: '' } },
  },
  {
    id: '182',
    slug: 'liveaboard-navigation-electronics-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1562095241-8c6714fd4178?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-22',
    updatedAt: '2026-07-22',
    tags: ['boat-living', 'navigation', 'electronics', 'plotter', 'ais', 'radar', 'structure-5', 'intro-1'],
    content: { en: { title: 'Navigation Electronics for Liveaboards - AIS and Radar', excerpt: 'Chartplotters, AIS, radar, and VHF - how to balance capability with budget for coastal and offshore liveaboard sailing without overcomplicating your helm.', body: '' } },
  },
  {
    id: '183',
    slug: 'liveaboard-dinghy-tender-selection',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-06',
    tags: ['boat-living', 'dinghy', 'tender', 'rib', 'inflatable', 'liveaboard', 'structure-6', 'intro-2'],
    content: { en: { title: 'Choosing a Liveaboard Dinghy - RIB vs Inflatable', excerpt: 'The right tender for liveaboard life - comparing RIBs, soft-floor inflatables, and rigid dinghies by durability, performance, storage, and daily use patterns.', body: '' } },
  },
  {
    id: '184',
    slug: 'liveaboard-customs-clearance-cruising',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-10',
    tags: ['boat-living', 'customs', 'clearance', 'cruising', 'visa', 'documentation', 'structure-1', 'intro-3'],
    content: { en: { title: 'Customs Clearance for Cruising Liveaboards', excerpt: 'International customs procedures for cruising sailors - required documents, flag state rules, visa strategies, and the realities of clearing in at foreign.', body: '' } },
  },
  {
    id: '186',
    slug: 'camping-journal-documentation-tips',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-25',
    tags: ['camping', 'journal', 'documentation', 'photography', 'memories', 'structure-6', 'intro-3'],
    content: { en: { title: 'Documenting Camping Trips - Journals and Photography', excerpt: 'A camping journal transforms fleeting outdoor moments into lasting records - practical approaches to documentation that capture what actually matters.', body: '' } },
  },
  {
    id: '187',
    slug: 'camping-group-trip-planning-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1447684808650-354ae64db5b8?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-05',
    tags: ['camping', 'group', 'planning', 'organization', 'teamwork', 'structure-1', 'intro-4'],
    content: { en: { title: 'Planning Group Camping Trips - Logistics and Roles', excerpt: 'Group camping trips multiply both the fun and the complexity - a practical framework for planning, food sharing, pace management, and conflict resolution.', body: '' } },
  },
  {
    id: '188',
    slug: 'van-life-mail-address-domicile-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1579275542618-a1dfed5f54ba?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-16',
    tags: ['mobile-living', 'mail', 'domicile', 'legal', 'address', 'structure-3', 'intro-1'],
    content: { en: { title: 'Mail and Legal Domicile for Van Life - A Framework', excerpt: 'Living in a van without a fixed address creates real legal and logistical challenges - domicile state, mail forwarding, banking, and insurance all need.', body: '' } },
  },
  {
    id: '189',
    slug: 'van-life-laundry-solutions-road',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1582735689369-4fe89db7114c?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-04',
    tags: ['mobile-living', 'laundry', 'hygiene', 'practical', 'budget', 'structure-4', 'intro-2'],
    content: { en: { title: 'Van Life Laundry - Clean Clothes on the Road', excerpt: 'Clean clothes on the road requires strategy - hand-washing techniques, laundromat logistics, and portable washing solutions that actually work for van life.', body: '' } },
  },
  {
    id: '190',
    slug: 'van-life-mental-health-loneliness',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-08',
    tags: ['mobile-living', 'mental-health', 'loneliness', 'wellbeing', 'psychology', 'structure-5', 'intro-3'],
    content: { en: { title: 'Mental Health in Van Life - Loneliness and Solutions', excerpt: 'Van life freedom comes with psychological costs that few discuss openly - loneliness, decision fatigue, and identity shifts require active management.', body: '' } },
  },
  {
    id: '192',
    slug: 'off-grid-food-preservation-methods',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-25',
    tags: ['off-grid', 'food', 'preservation', 'fermentation', 'drying', 'structure-5', 'intro-6'],
    content: { en: { title: 'Food Preservation Off-Grid Without Electricity', excerpt: 'Preserving food off-grid means working beyond the freezer - dehydration, fermentation, root cellaring, and curing techniques that sustain households year-round.', body: '' } },
  },
  {
    id: '194',
    slug: 'liveaboard-electrical-system-marine',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-15',
    tags: ['boat-living', 'electrical', 'marine', 'battery', 'solar', 'structure-2', 'intro-4'],
    content: { en: { title: 'Marine Electrical for Liveaboards - 12V and Charging', excerpt: 'Living aboard demands understanding your electrical system - battery banks, charging sources, load management, and the safety standards that prevent fires at.', body: '' } },
  },
  {
    id: '195',
    slug: 'liveaboard-anchoring-mooring-techniques',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1532347231146-80afc9e3df2b?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-15',
    tags: ['boat-living', 'anchoring', 'mooring', 'seamanship', 'safety', 'structure-3', 'intro-5'],
    content: { en: { title: 'Anchoring and Mooring for Liveaboards - Key Techniques', excerpt: 'Secure anchoring is the foundation of liveaboard freedom - anchor types, scope calculations, mooring options, and the weather judgment that keeps your home.', body: '' } },
  },
  {
    id: '196',
    slug: 'liveaboard-provisioning-long-passages',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1567306226416-28f0efdc88ce?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-03',
    tags: ['boat-living', 'provisioning', 'passages', 'food', 'planning', 'structure-4', 'intro-6'],
    content: { en: { title: 'Provisioning for Long Passages - Food and Water', excerpt: 'Provisioning for ocean passages requires systematic food planning, water budgeting, and nutritional strategy that sustains crew health across weeks at sea.', body: '' } },
  },
  {
    id: '197',
    slug: 'desert-camping-survival-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1433086966358-54859d0ed716?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-09',
    tags: ['camping', 'desert', 'survival', 'heat', 'water', 'structure-2', 'intro-5'],
    content: { en: { title: 'Desert Camping Survival Guide - Heat, Water, and Navigation', excerpt: 'Desert camping demands respect for extreme heat, scarce water, and vast distances. This guide covers the survival skills that keep you safe. Real data.', body: '' } },
  },
  {
    id: '198',
    slug: 'choosing-right-sleeping-bag',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1491002052546-bf38f186af56?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-11',
    tags: ['camping', 'sleeping-bag', 'gear', 'temperature', 'insulation', 'structure-3', 'intro-6'],
    content: { en: { title: 'Choosing the Right Sleeping Bag - Temperature, Fill, and Shape', excerpt: 'Your sleeping bag determines whether you sleep well or shiver all night. Here is how to match temperature ratings, fill types, and shapes to your needs.', body: '' } },
  },
  {
    id: '199',
    slug: 'camping-water-filtration-methods',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-13',
    tags: ['camping', 'water', 'filtration', 'purification', 'safety', 'structure-4', 'intro-1'],
    content: { en: { title: 'Camping Water Filtration - Filters, UV, and Chemicals', excerpt: 'Safe drinking water in the backcountry requires proper treatment. Compare pump filters, gravity systems, UV purifiers, and chemical options for your needs.', body: '' } },
  },
  {
    id: '200',
    slug: 'vanlife-electrical-troubleshooting',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-26',
    tags: ['mobile-living', 'vanlife', 'electrical', 'troubleshooting', 'diy', 'structure-6', 'intro-4'],
    content: { en: { title: 'Troubleshooting Common Van Electrical Faults', excerpt: 'Electrical problems in your van can strand you or damage equipment. Learn systematic troubleshooting for the most common 12V and solar issues. Real data.', body: '' } },
  },
  {
    id: '201',
    slug: 'vanlife-monthly-budget-breakdown',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-27',
    tags: ['mobile-living', 'vanlife', 'budget', 'costs', 'finance', 'structure-1', 'intro-5'],
    content: { en: { title: 'Van Life Monthly Budget Breakdown - Fixed and Variable Costs', excerpt: 'Van life costs between $800 and $2,500 per month for most people. Here is a detailed breakdown of fixed and variable expenses to plan realistically. Real data.', body: '' } },
  },
  {
    id: '202',
    slug: 'vanlife-cold-climate-winter-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504276048855-f3d60e69632f?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-03',
    tags: ['mobile-living', 'vanlife', 'winter', 'cold', 'insulation', 'heating', 'structure-2', 'intro-6'],
    content: { en: { title: 'Van Life in Cold Climates - Insulation and Heating', excerpt: 'Winter van life demands serious preparation for insulation, heating, moisture control, and cold-start reliability. Here is what actually works below freezing.', body: '' } },
  },
  {
    id: '204',
    slug: 'off-grid-home-security-systems',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1558002038-1055907df827?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-26',
    tags: ['off-grid', 'security', 'cameras', 'alarms', 'protection', 'structure-2', 'intro-3'],
    content: { en: { title: 'Off-Grid Home Security - Alarms, Cameras, and Deterrent', excerpt: 'Remote properties face unique security challenges without neighbors or police nearby. Build layered protection using cameras, alarms, and smart deterrents.', body: '' } },
  },
  {
    id: '205',
    slug: 'natural-building-materials-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1513584684374-8bab748fbf90?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-29',
    tags: ['off-grid', 'building', 'natural-materials', 'cob', 'straw-bale', 'timber', 'structure-3', 'intro-4'],
    content: { en: { title: 'Natural Building Materials - Cob, Straw Bale, and Hemp', excerpt: 'Cob, straw bale, timber, and hempcrete compared honestly - costs, insulation values, labour intensity, and where each method works best for owner-builders.', body: '' } },
  },
  {
    id: '206',
    slug: 'liveaboard-plumbing-systems-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1559825481-12a05cc00344?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-16',
    tags: ['boat-living', 'plumbing', 'water-systems', 'pumps', 'tanks', 'maintenance', 'structure-5', 'intro-1'],
    content: { en: { title: 'Liveaboard Plumbing Systems - Pumps, Tanks, and Water Management', excerpt: 'Marine plumbing fails differently than household plumbing. Understand freshwater pumps, holding tanks, seacocks, and the hose connections that keep your boat.', body: '' } },
  },
  {
    id: '207',
    slug: 'boat-living-tropical-climates',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1520483601560-389dff434fdf?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-02',
    tags: ['boat-living', 'tropical', 'heat', 'ventilation', 'cyclone', 'corrosion', 'structure-6', 'intro-2'],
    content: { en: { title: 'Boat Living in Tropical Climates - Heat and Storms', excerpt: 'Tropical liveaboard life brings unique challenges: relentless heat, accelerated corrosion, mold growth, and cyclone season management from experienced cruisers.', body: '' } },
  },
  {
    id: '208',
    slug: 'liveaboard-communication-systems',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516738901171-8eb4fc13bd20?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-25',
    tags: ['boat-living', 'communication', 'vhf', 'satellite', 'ssb', 'internet', 'structure-1', 'intro-3'],
    content: { en: { title: 'Liveaboard Communication Systems - VHF, SSB, and Satellite', excerpt: 'Layered communication aboard: VHF for safety, SSB for offshore, satellite for internet. What each system costs and delivers for liveaboard connectivity.', body: '' } },
  },
  {
    id: '209',
    slug: 'camping-bear-country-safety-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530210124550-912dc1381cb8?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-06',
    tags: ['camping', 'safety', 'wildlife', 'bears', 'backcountry', 'structure-5', 'intro-2'],
    content: { en: { title: 'Camping in Bear Country - Food Storage and Safety', excerpt: 'Practical bear safety goes beyond hanging food bags. Real protocols for black bear and grizzly territory that keep you calm and prepared. Honest data.', body: '' } },
  },
  {
    id: '212',
    slug: 'vanlife-ventilation-condensation-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1558981285-6f0c94958bb6?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-11',
    tags: ['mobile-living', 'vanlife', 'ventilation', 'condensation', 'moisture', 'structure-3', 'intro-1'],
    content: { en: { title: 'Van Life Ventilation - Managing Moisture and Airflow', excerpt: 'Condensation destroys vans faster than rust. Practical ventilation strategies, vapor barrier placement, and daily habits that keep your mobile home dry.', body: '' } },
  },
  {
    id: '213',
    slug: 'vanlife-stealth-urban-camping-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1511497584788-876760111969?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-12',
    updatedAt: '2026-07-22',
    tags: ['mobile-living', 'vanlife', 'stealth', 'urban', 'parking', 'structure-4', 'intro-2'],
    content: { en: { title: 'Stealth Camping in a Van - Urban Parking Strategies', excerpt: 'Urban stealth parking is an art built on courtesy and discretion. Practical strategies for finding safe overnight spots without drawing attention. Real data.', body: '' } },
  },
  {
    id: '214',
    slug: 'vanlife-pet-cat-travel-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518791841217-8f162f1e1131?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-04',
    tags: ['mobile-living', 'vanlife', 'pets', 'cats', 'travel', 'structure-5', 'intro-3'],
    content: { en: { title: 'Cats in a Camper Van - Litter, Heat, and Travel', excerpt: 'Cats adapt to van life better than most people expect. Practical solutions for litter, heat safety, enrichment, and building feline travel routines. Real data.', body: '' } },
  },
  {
    id: '217',
    slug: 'off-grid-fire-prevention-safety-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1486551937199-baf066858de7?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-29',
    tags: ['off-grid-homes', 'fire-safety', 'prevention', 'emergency', 'building', 'structure-6', 'intro-1'],
    content: { en: { title: 'Fire Safety for Off-Grid Homes - Prevention and Plans', excerpt: 'Remote homes face fire risks that suburban houses never encounter. Prevention strategies, suppression options, and planning for when help is far away.', body: '' } },
  },
  {
    id: '219',
    slug: 'liveaboard-fresh-water-making-watermaker',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516571748831-5d81767b788d?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-04',
    updatedAt: '2026-05-20',
    tags: ['boat-living', 'water', 'watermaker', 'desalination', 'self-sufficiency', 'structure-3', 'intro-5'],
    content: { en: { title: 'Watermakers for Liveaboards - Desalination Guide', excerpt: 'Unlimited fresh water from the ocean changes liveaboard life completely. Watermaker types, costs, maintenance demands, and when they make financial sense.', body: '' } },
  },
  {
    id: '220',
    slug: 'liveaboard-docking-marina-etiquette',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1604537466158-719b1972feb8?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-10',
    tags: ['boat-living', 'marina', 'etiquette', 'docking', 'community', 'structure-4', 'intro-6'],
    content: { en: { title: 'Marina Docking for Liveaboards - Slips and Etiquette', excerpt: 'Good marina neighbors keep their slip for years. Practical etiquette, slip selection strategy, and the unwritten rules that make liveaboard marina life work.', body: '' } },
  },
  {
    id: '221',
    slug: 'camping-water-purification-methods',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1477322524744-0eece9e79640?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-28',
    updatedAt: '2026-05-21',
    tags: ['camping', 'water', 'safety', 'backcountry', 'structure-2', 'intro-5'],
    content: { en: { title: 'Camping Water Purification: Four Methods Compared', excerpt: 'The best water purification method depends on your trip length, water source, and tolerance for inconvenience. Here is what actually works. Real data.', body: '' } },
  },
  {
    id: '222',
    slug: 'camping-wildlife-photography-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-16',
    tags: ['camping', 'photography', 'wildlife', 'nature', 'structure-3', 'intro-6'],
    content: { en: { title: 'Wildlife Photography While Camping - Gear, Fieldcraft, and Ethics', excerpt: 'Great wildlife photos come from patience and fieldcraft, not expensive gear. Photographing animals from camp requires knowing light, distance, and ethics.', body: '' } },
  },
  {
    id: '223',
    slug: 'camping-high-altitude-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1540390769625-2fc3f8b1d50c?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-25',
    updatedAt: '2026-07-22',
    tags: ['camping', 'altitude', 'safety', 'mountain', 'structure-4', 'intro-1'],
    content: { en: { title: 'Camping at High Altitude - Acclimatization and Gear', excerpt: 'Above 2,500 meters, everything changes. Your stove, your sleep, your body. Camping safely at altitude requires gear adjustments and honest self-assessment.', body: '' } },
  },
  {
    id: '224',
    slug: 'vanlife-laundry-hygiene-solutions',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1558981403-c5f9899a28bc?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-17',
    tags: ['mobile-living', 'hygiene', 'laundry', 'practical', 'structure-6', 'intro-4'],
    content: { en: { title: 'Vanlife Laundry and Hygiene - Solutions on the Road', excerpt: 'Staying clean in a van is not about replicating a house bathroom. It is about building routines that work within 6 square meters. Based on experience.', body: '' } },
  },
  {
    id: '225',
    slug: 'vanlife-seasonal-route-planning',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1541280910158-c4e14f9c94a3?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-05',
    tags: ['mobile-living', 'planning', 'routes', 'seasonal', 'structure-1', 'intro-5'],
    content: { en: { title: 'Vanlife Seasonal Route Planning - Chasing the Weather', excerpt: 'Your climate tolerance, work schedule, and willingness to drive shape the best routes. Seasonal migration patterns that make vanlife sustainable year-round.', body: '' } },
  },
  {
    id: '226',
    slug: 'vanlife-electrical-system-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-12',
    tags: ['mobile-living', 'electrical', 'solar', 'technical', 'structure-2', 'intro-6'],
    content: { en: { title: 'Vanlife Electrical Systems - Solar, Batteries, Wiring', excerpt: 'Your electrical system determines what you can power, for how long, and how reliably. Getting it right the first time saves thousands in replacements.', body: '' } },
  },
  {
    id: '229',
    slug: 'off-grid-seasonal-maintenance-calendar',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1528543606781-2f6e6857f318?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-23',
    updatedAt: '2026-07-22',
    tags: ['off-grid-homes', 'maintenance', 'seasonal', 'planning', 'structure-3', 'intro-4'],
    content: { en: { title: 'Off-Grid Seasonal Maintenance - Month-by-Month Guide', excerpt: 'An off-grid property requires year-round attention that follows seasonal patterns. Missing a maintenance window creates problems that compound across seasons.', body: '' } },
  },
  {
    id: '230',
    slug: 'liveaboard-storm-preparation-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500259571355-332da5cb07aa?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-15',
    tags: ['boat-living', 'safety', 'storms', 'preparation', 'structure-5', 'intro-1'],
    content: { en: { title: 'Liveaboard Storm Preparation - Hurricane and Anchoring', excerpt: 'A tropical storm warning gives you 48 hours to protect your floating home. Knowing your plan before the warning arrives is what separates preparation from.', body: '' } },
  },
  {
    id: '233',
    slug: 'camping-navigation-map-compass-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-24',
    tags: ['camping', 'navigation', 'compass', 'map-reading', 'structure-5', 'intro-2'],
    content: { en: { title: 'Map and Compass for Campers - Beyond GPS Skills', excerpt: 'Master traditional navigation with map and compass. Learn route finding, terrain association, and why these skills remain essential in the GPS era. Real data.', body: '' } },
  },
  {
    id: '234',
    slug: 'camping-rain-wet-weather-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1485201543483-f06c8d2a8fb4?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-27',
    tags: ['camping', 'rain', 'wet-weather', 'gear', 'structure-6', 'intro-3'],
    content: { en: { title: 'Camping in the Rain - How to Stay Dry and Comfortable', excerpt: 'Rain transforms a camping trip but does not ruin it. Tarp configurations, gear waterproofing, fire-starting in wet conditions, and keeping morale on soggy days.', body: '' } },
  },
  {
    id: '235',
    slug: 'camping-knots-rope-skills',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1470240731273-7821a6eeb6bd?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-18',
    tags: ['camping', 'knots', 'rope-skills', 'outdoor-skills', 'structure-1', 'intro-4'],
    content: { en: { title: 'Essential Camping Knots - The Only Five You Need', excerpt: 'Learn the five essential knots every camper needs. From bowline to taut-line hitch, master practical rope skills that handle 95% of camping situations.', body: '' } },
  },
  {
    id: '236',
    slug: 'vanlife-insurance-registration-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1568454537842-d933259bb258?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-25',
    tags: ['mobile-living', 'insurance', 'registration', 'legal', 'structure-3', 'intro-1'],
    content: { en: { title: 'Legal Coverage for Van Life - Insurance and Registration', excerpt: 'Navigate van life insurance, vehicle registration, and mail forwarding. Understand the legal decisions that protect your mobile lifestyle and your wallet.', body: '' } },
  },
  {
    id: '237',
    slug: 'vanlife-bathroom-toilet-solutions',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-22',
    tags: ['mobile-living', 'bathroom', 'toilet', 'hygiene', 'structure-4', 'intro-2'],
    content: { en: { title: 'Van Life Bathroom and Toilet Solutions - A Step-by-Step Guide', excerpt: 'Solve the van life bathroom challenge with practical toilet, shower, and hygiene solutions. From composting toilets to portable options for your build.', body: '' } },
  },
  {
    id: '238',
    slug: 'vanlife-winter-cold-weather-tips',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-31',
    tags: ['mobile-living', 'winter', 'cold-weather', 'insulation', 'structure-5', 'intro-3'],
    content: { en: { title: 'Winter Van Life - Surviving and Thriving in Cold Weather', excerpt: 'Winter van life strategies for insulation, heating, condensation control, and cold-start routines. Stay warm and functional when temperatures drop below.', body: '' } },
  },
  {
    id: '240',
    slug: 'off-grid-toolshed-workshop-setup',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506126279646-a697353d3166?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-11',
    tags: ['off-grid-homes', 'workshop', 'tools', 'storage', 'structure-5', 'intro-6'],
    content: { en: { title: 'Off-Grid Workshop Setup - Tools, Design, and Power', excerpt: 'Design a functional off-grid workshop from essential hand tools to solar-powered equipment. Create a workspace that handles property maintenance and projects.', body: '' } },
  },
  {
    id: '241',
    slug: 'off-grid-mental-health-isolation-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1588880331179-bc9b93a8cb5e?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-15',
    tags: ['off-grid-homes', 'mental-health', 'isolation', 'wellbeing', 'structure-6', 'intro-1'],
    content: { en: { title: 'Mental Health and Isolation in Off-Grid Living - Honest', excerpt: 'Mental health challenges of off-grid isolation. Practical coping strategies, routine building, and recognizing when solitude shifts from feature to problem.', body: '' } },
  },
  {
    id: '242',
    slug: 'liveaboard-sailing-night-watch-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1495837174058-628aafc7d610?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-27',
    tags: ['boat-living', 'night-watch', 'sailing', 'safety', 'structure-2', 'intro-4'],
    content: { en: { title: 'Night Watch Sailing for Liveaboards - Managing Fatigue', excerpt: 'Night watches on your liveaboard with proven watch systems, fatigue management, and safety protocols for overnight passages and coastal cruising explained.', body: '' } },
  },
  {
    id: '243',
    slug: 'liveaboard-customs-border-cruising',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1532274402911-5a369e4c4bb5?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-26',
    tags: ['boat-living', 'customs', 'border-crossing', 'documentation', 'structure-3', 'intro-5'],
    content: { en: { title: 'Border Cruising for Liveaboards - Documentation Guide', excerpt: 'International customs clearance for liveaboards. Documentation requirements, clearance procedures, and the etiquette of arriving in foreign ports explained.', body: '' } },
  },
  {
    id: '244',
    slug: 'liveaboard-onboard-fitness-health',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-03',
    tags: ['boat-living', 'fitness', 'health', 'exercise', 'structure-4', 'intro-6'],
    content: { en: { title: 'Staying Fit on a Liveaboard - Exercise and Nutrition', excerpt: 'Fitness and health while living aboard - practical exercise routines for small spaces, nutrition strategies, and essential first aid for liveaboard sailors.', body: '' } },
  },
  {
    id: '246',
    slug: 'camping-insect-protection-bug-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533692328991-08159ff19fca?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-14',
    tags: ['camping', 'insects', 'bugs', 'mosquitoes', 'ticks', 'repellent', 'structure-3', 'intro-6'],
    content: { en: { title: 'Insect Protection While Camping - Mosquitoes and Ticks', excerpt: 'Practical strategies for dealing with mosquitoes, ticks, and biting insects while camping - from repellent choices to campsite selection. Honest data.', body: '' } },
  },
  {
    id: '247',
    slug: 'camping-shelter-tent-hammock-bivy-choice',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-02',
    tags: ['camping', 'tent', 'hammock', 'bivy', 'shelter', 'gear', 'structure-4', 'intro-1'],
    content: { en: { title: 'Tent, Hammock, or Bivy Sack - Choosing Your Camping Shelter', excerpt: 'Compare tents, hammocks, and bivy sacks for camping - weight, comfort, weather protection, and which shelter fits your camping style best. With costs.', body: '' } },
  },
  {
    id: '248',
    slug: 'vanlife-breakdown-roadside-repairs',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-02',
    tags: ['mobile-living', 'vanlife', 'repairs', 'breakdown', 'maintenance', 'roadside', 'structure-6', 'intro-4'],
    content: { en: { title: 'Van Breakdowns and Roadside Repairs - A Practical Survival Guide', excerpt: 'Handle van breakdowns confidently with this roadside repair guide covering common failures, emergency tools, and when to call for help. Tested advice.', body: '' } },
  },
  {
    id: '249',
    slug: 'vanlife-finding-campsites-parking-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1498887960847-2a5e46312788?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-08',
    tags: ['mobile-living', 'vanlife', 'campsites', 'parking', 'boondocking', 'structure-1', 'intro-5'],
    content: { en: { title: 'Finding Campsites and Parking Spots for Van Life', excerpt: 'Finding overnight parking as a van dweller means navigating apps, BLM land, stealth rules, and paid campgrounds. Tested strategies that actually work.', body: '' } },
  },
  {
    id: '250',
    slug: 'vanlife-mail-packages-digital-nomad',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1526367790999-0150786686a2?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-02',
    tags: ['mobile-living', 'vanlife', 'mail', 'packages', 'digital-nomad', 'address', 'structure-2', 'intro-6'],
    content: { en: { title: 'Mail, Packages, and Addresses for Van Life Digital Nomads', excerpt: 'Solve the van life mail problem - mail forwarding services, general delivery, package lockers, and maintaining a legal address on the road. Real data.', body: '' } },
  },
  {
    id: '251',
    slug: 'off-grid-building-permits-codes-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-12',
    tags: ['off-grid', 'building-permits', 'zoning', 'codes', 'legal', 'tiny-house', 'structure-1', 'intro-2'],
    content: { en: { title: 'Off-Grid Building Permits and Codes - What You Need to Know', excerpt: 'Navigate building permits, zoning laws, and codes for off-grid homes - including tiny houses, setbacks, septic requirements, and legal workarounds. Real data.', body: '' } },
  },
  {
    id: '253',
    slug: 'off-grid-security-systems-protection',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1484910292437-025e5d13ce87?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-09',
    tags: ['off-grid', 'security', 'cameras', 'protection', 'safety', 'structure-3', 'intro-4'],
    content: { en: { title: 'Off-Grid Security - Cameras, Alarms, and Property Protection', excerpt: 'Protect your off-grid property with practical security - cameras, motion sensors, physical barriers, and community-based strategies that work. Real data.', body: '' } },
  },
  {
    id: '256',
    slug: 'liveaboard-anchoring-techniques-scope-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1507181179506-598491b53db4?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-24',
    tags: ['boat-living', 'liveaboard', 'anchoring', 'seamanship', 'techniques', 'structure-1', 'intro-3'],
    content: { en: { title: 'Anchoring Techniques - A Complete Guide for Liveaboard Sailors', excerpt: 'Master anchoring for liveaboard sailing - anchor types, scope calculation, bottom conditions, setting techniques, and retrieval methods. Real numbers.', body: '' } },
  },
  {
    id: '257',
    slug: 'camping-campfire-safety-wildfire-prevention',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1475113548554-5a36f1f523d6?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-30',
    updatedAt: '2026-07-22',
    tags: ['camping', 'fire-safety', 'wildfire', 'leave-no-trace', 'campfire', 'structure-5', 'intro-2'],
    content: { en: { title: 'Campfire Safety and Wildfire Prevention - A Practical Guide', excerpt: 'Learn campfire safety protocols, fire regulations by region, and wildfire prevention practices that every responsible camper should know before striking a.', body: '' } },
  },
  {
    id: '258',
    slug: 'camping-stargazing-astronomy-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1482784160316-6eb046863ece?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-30',
    tags: ['camping', 'stargazing', 'astronomy', 'night-sky', 'astrophotography', 'structure-6', 'intro-3'],
    content: { en: { title: 'Camping Stargazing - Your Guide to the Night Sky', excerpt: 'Discover how to plan stargazing camping trips, identify constellations, choose the right gear, and capture the night sky through beginner astrophotography.', body: '' } },
  },
  {
    id: '259',
    slug: 'camping-with-teens-older-children',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1529408686214-b48b8532f72c?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-13',
    tags: ['camping', 'teens', 'family', 'teenagers', 'engagement', 'structure-1', 'intro-4'],
    content: { en: { title: 'Camping with Teens - How to Keep Older Kids Engaged Outdoors', excerpt: 'Camping with teenagers who prefer their phones - real responsibilities, activities matching their interests, and strategies that keep older kids engaged.', body: '' } },
  },
  {
    id: '260',
    slug: 'vanlife-cooking-one-pot-meals-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-23',
    tags: ['vanlife', 'cooking', 'one-pot-meals', 'kitchen', 'recipes', 'structure-3', 'intro-1'],
    content: { en: { title: 'Vanlife One-Pot Cooking - Simple Meals for Life on the Road', excerpt: 'Master one-pot cooking for van life with practical recipes, minimal cleanup strategies, and smart approaches to propane, electric, and no-cook meal preparation.', body: '' } },
  },
  {
    id: '261',
    slug: 'vanlife-pet-health-veterinary-care',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-11',
    tags: ['vanlife', 'pets', 'veterinary', 'health', 'dogs', 'structure-4', 'intro-2'],
    content: { en: { title: 'Vanlife Pet Health - Veterinary Care on the Road', excerpt: 'Keep your pet healthy while traveling full-time - finding vets, managing vaccinations, handling emergencies, and maintaining medical records on the move.', body: '' } },
  },
  {
    id: '262',
    slug: 'vanlife-vehicle-storage-organisation',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1527631746610-bca00a040d60?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-23',
    tags: ['vanlife', 'storage', 'organisation', 'space', 'van-build', 'structure-5', 'intro-3'],
    content: { en: { title: 'Vanlife Storage and Organisation - Maximising Every Inch', excerpt: 'Van life storage: overhead cabinets, under-bed systems, door organisers, and the mindset shift that makes 70 square feet feel genuinely spacious and organized.', body: '' } },
  },
  {
    id: '263',
    slug: 'off-grid-greywater-systems-recycling',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-16',
    tags: ['off-grid', 'greywater', 'water-recycling', 'sustainability', 'irrigation', 'structure-4', 'intro-5'],
    content: { en: { title: 'Off-Grid Greywater Systems - Recycling for Irrigation', excerpt: 'Design and install a greywater recycling system for your off-grid home. Practical guidance on collection, filtration, irrigation reuse, and code compliance.', body: '' } },
  },
  {
    id: '264',
    slug: 'off-grid-homestead-business-income',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-20',
    tags: ['off-grid', 'homestead', 'business', 'income', 'remote-work', 'agritourism', 'structure-5', 'intro-6'],
    content: { en: { title: 'Off-Grid Homestead Income - Building a Business from Your', excerpt: 'Realistic income streams for off-grid living: remote work, selling produce, agritourism, crafts, and digital products that sustain self-sufficient lifestyles.', body: '' } },
  },
  {
    id: '265',
    slug: 'off-grid-emergency-preparedness-plan',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-21',
    tags: ['off-grid', 'emergency', 'preparedness', 'safety', 'evacuation', 'structure-6', 'intro-1'],
    content: { en: { title: 'Off-Grid Emergency Preparedness - Planning for When Systems Fail', excerpt: 'Emergency preparedness for off-grid properties - power outages, medical emergencies, wildfire evacuation, and communication when infrastructure fails entirely.', body: '' } },
  },
  {
    id: '266',
    slug: 'liveaboard-sailing-weather-forecasting',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1527489377706-5bf97e608852?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-23',
    tags: ['boat-living', 'weather', 'forecasting', 'sailing', 'GRIB', 'navigation', 'structure-2', 'intro-4'],
    content: { en: { title: 'Weather Forecasting for Liveaboard Sailors', excerpt: 'Marine weather forecasting with GRIB files, routing software, barometric trends, cloud reading, and storm avoidance strategies for liveaboard sailors.', body: '' } },
  },
  {
    id: '268',
    slug: 'liveaboard-solo-sailing-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518709766631-a6a7f45921c3?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-23',
    tags: ['boat-living', 'solo-sailing', 'single-handed', 'autopilot', 'safety', 'structure-4', 'intro-6'],
    content: { en: { title: 'Solo Sailing as a Liveaboard - Single-Handed Techniques and', excerpt: 'Single-handed sailing for liveaboards: autopilot systems, self-tacking setups, safety tethers, and the mental framework for sailing alone safely at sea.', body: '' } },
  },
  {
    id: '271',
    slug: 'camping-group-logistics-planning',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1490730141103-6cac27aaab94?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-02',
    tags: ['camping', 'group', 'logistics', 'planning', 'organization', 'meals', 'structure-4', 'intro-1'],
    content: { en: { title: 'Group Camping Logistics - Planning for 6+ People', excerpt: 'Organise group camping trips that actually work. Meal planning, gear sharing, task delegation, and communication strategies for groups of six or more people.', body: '' } },
  },
  {
    id: '273',
    slug: 'vanlife-downsizing-decluttering-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1468818438311-4bab781ab9b8?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-03',
    tags: ['mobile-living', 'downsizing', 'decluttering', 'minimalism', 'transition', 'structure-1', 'intro-5'],
    content: { en: { title: 'Downsizing for Van Life - What to Keep, Sell, Store, and Let Go', excerpt: 'The practical and emotional process of reducing your possessions to fit a van. Storage units, sentimental items, digital alternatives, and decision frameworks.', body: '' } },
  },
  {
    id: '274',
    slug: 'vanlife-seasonal-work-income-ideas',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1535953472862-9cc610a70f8a?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-03',
    tags: ['mobile-living', 'seasonal-work', 'income', 'jobs', 'freelancing', 'budget', 'structure-2', 'intro-6'],
    content: { en: { title: 'Seasonal Work for Vanlifers - Earning Income While Staying Mobile', excerpt: 'Fund your van life with seasonal and location-flexible jobs. Harvest work, camp hosting, ski resorts, freelancing, and building income that moves with you.', body: '' } },
  },
  {
    id: '275',
    slug: 'off-grid-root-cellar-food-preservation',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1472396961693-142e6e269027?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-28',
    tags: ['off-grid-homes', 'root-cellar', 'food-preservation', 'canning', 'storage', 'self-sufficiency', 'structure-1', 'intro-2'],
    content: { en: { title: 'Root Cellars and Food Preservation for Off-Grid Living', excerpt: 'Build and use a root cellar to store food without electricity. Construction methods, temperature control, shelf life expectations, and complementary strategies.', body: '' } },
  },
  {
    id: '277',
    slug: 'off-grid-neighbourhood-community-building',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-23',
    tags: ['off-grid-homes', 'community', 'intentional-living', 'shared-resources', 'governance', 'structure-3', 'intro-4'],
    content: { en: { title: 'Building Off-Grid Communities - Governance and Resources', excerpt: 'Forming off-grid intentional communities - shared resources, decision-making structures, conflict resolution, and the realities of communal self-sufficiency.', body: '' } },
  },
  {
    id: '278',
    slug: 'liveaboard-electrical-systems-12v-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1536431311719-398b6704d4cc?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-05',
    tags: ['boat-living', 'electrical', '12v', 'batteries', 'inverter', 'shore-power', 'structure-5', 'intro-1'],
    content: { en: { title: 'Liveaboard Electrical - 12V, Batteries, and Inverters', excerpt: 'Master your liveaboard boat electrical system. 12V vs 24V, battery bank sizing, inverter selection, shore power integration, and keeping the lights on at.', body: '' } },
  },
  {
    id: '280',
    slug: 'liveaboard-sailing-with-children-family',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1541185933-ef5d8ed016c2?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-02',
    tags: ['boat-living', 'children', 'family', 'boat-schooling', 'safety', 'parenting', 'structure-1', 'intro-3'],
    content: { en: { title: 'Sailing with Children - Family Life on a Liveaboard Boat', excerpt: 'Raising children aboard a sailing boat - safety systems, boat-schooling, daily routines, passage planning with kids, and the challenges of family life afloat.', body: '' } },
  },
  {
    id: '281',
    slug: 'camping-wildlife-safety-encounters-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-28',
    tags: ['camping', 'wildlife', 'safety', 'bears', 'snakes', 'emergency', 'structure-5', 'intro-2'],
    content: { en: { title: 'Wildlife Safety While Camping - How to Handle Animal Encounters', excerpt: 'Camping safely in wildlife territory - bear protocols, snake awareness, food storage systems, and emergency response for real animal encounters outdoors.', body: '' } },
  },
  {
    id: '284',
    slug: 'vanlife-bathroom-toilet-shower-options',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1472289065668-ce650ac443d2?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-09',
    tags: ['mobile-living', 'bathroom', 'toilet', 'shower', 'hygiene', 'van-conversion', 'structure-3', 'intro-1'],
    content: { en: { title: 'Van Life Bathroom - Toilets, Showers, and Hygiene', excerpt: 'Cassette toilets, composting systems, portable showers, and privacy setups for van life - practical costs, maintenance realities, and what works long-term.', body: '' } },
  },
  {
    id: '285',
    slug: 'vanlife-meeting-people-community-travel',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-17',
    tags: ['mobile-living', 'community', 'social', 'gatherings', 'travel', 'connections', 'structure-4', 'intro-2'],
    content: { en: { title: 'Meeting People on the Road - Community and Connection in Van Life', excerpt: 'Building genuine connections while living in a van - gatherings, online communities, serendipitous friendships, healthy boundaries, and combating loneliness.', body: '' } },
  },
  {
    id: '286',
    slug: 'vanlife-extreme-weather-prep-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516912481808-3406841bd33c?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-02',
    tags: ['mobile-living', 'weather', 'extreme', 'heat', 'cold', 'wind', 'safety', 'structure-5', 'intro-3'],
    content: { en: { title: 'Preparing Your Van for Extreme Weather - Heat and Cold', excerpt: 'Survive heat waves, blizzards, and windstorms in your van - insulation, ventilation, emergency protocols, and weather patterns that catch van dwellers off.', body: '' } },
  },
  {
    id: '287',
    slug: 'off-grid-rainwater-harvesting-system-design',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1468245856972-a0333f3f8293?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-03',
    tags: ['off-grid', 'rainwater', 'harvesting', 'water', 'filtration', 'storage', 'structure-4', 'intro-5'],
    content: { en: { title: 'Rainwater Harvesting Systems for Off-Grid Homes', excerpt: 'Roof catchment sizing, first-flush diverters, storage tanks, and filtration options with realistic yield calculations for off-grid water independence.', body: '' } },
  },
  {
    id: '288',
    slug: 'off-grid-greenhouse-year-round-growing',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-14',
    updatedAt: '2026-07-22',
    tags: ['off-grid', 'greenhouse', 'growing', 'food', 'passive-solar', 'season-extension', 'structure-5', 'intro-6'],
    content: { en: { title: 'Off-Grid Greenhouses - Year-Round Passive Solar Growing', excerpt: 'Build a greenhouse that grows food year-round off-grid - passive solar design, thermal mass heating, season extension strategies, and cold-climate crop.', body: '' } },
  },
  {
    id: '289',
    slug: 'off-grid-backup-power-generator-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-03',
    tags: ['off-grid', 'generator', 'backup-power', 'energy', 'self-sufficiency', 'structure-6', 'intro-1'],
    content: { en: { title: 'Off-Grid Backup Power & Generator Guide - Sizing, Fuel, and', excerpt: 'Generators fill the gap when renewables fall short. Choosing the right type, sizing it properly, and storing fuel safely keeps your off-grid home running.', body: '' } },
  },
  {
    id: '291',
    slug: 'liveaboard-boat-buying-inspection-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1484291470158-b8f8d608850d?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-11',
    tags: ['boat-living', 'buying', 'inspection', 'survey', 'liveaboard', 'structure-3', 'intro-5'],
    content: { en: { title: 'Liveaboard Boat Buying: Surveys and Sea Trials', excerpt: 'Buying a liveaboard demands different priorities than a weekend cruiser. What to inspect, red flags that mean walk away, and how to negotiate your future home.', body: '' } },
  },
  {
    id: '292',
    slug: 'liveaboard-cruising-permits-visas-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1473116763249-2faaef81ccda?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-17',
    updatedAt: '2026-07-22',
    tags: ['boat-living', 'cruising', 'permits', 'visas', 'international', 'structure-4', 'intro-6'],
    content: { en: { title: 'Liveaboard Cruising Permits: International Clearance', excerpt: 'Border crossings by boat involve customs clearance, cruising permits, and visa rules most sailors learn too late. Staying legal afloat requires preparation.', body: '' } },
  },
  {
    id: '293',
    slug: 'camping-vs-glamping-which-is-right',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517823382935-51bfcb0ec6bc?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-19',
    tags: ['camping', 'glamping', 'comparison', 'beginner', 'outdoor', 'structure-3', 'intro-5'],
    content: { en: { title: 'Camping vs Glamping: Which One Actually Fits Your Life?', excerpt: 'Traditional camping and glamping promise wildly different experiences. Here is an honest comparison of cost, comfort, and what each really delivers outdoors.', body: '' } },
  },
  {
    id: '294',
    slug: 'tent-camping-vs-hammock-camping-comparison',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519331379826-f10be5486c6f?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-24',
    tags: ['camping', 'hammock', 'tent', 'comparison', 'gear', 'structure-3', 'intro-6'],
    content: { en: { title: 'Tent Camping vs Hammock Camping: An Honest Comparison', excerpt: 'Tents and hammocks serve the same purpose but create completely different camping experiences. An honest look at weight, comfort, terrain, and weather.', body: '' } },
  },
  {
    id: '295',
    slug: 'van-life-vs-rv-life-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-25',
    tags: ['mobile-living', 'van-life', 'rv', 'comparison', 'nomad', 'structure-3', 'intro-4'],
    content: { en: { title: 'Van Life vs RV Life: Which Mobile Lifestyle Actually Fits?', excerpt: 'Vans and RVs both offer life on the road, but the daily reality differs dramatically. An honest comparison of cost, stealth, comfort, and freedom. Real data.', body: '' } },
  },
  {
    id: '296',
    slug: 'van-life-vs-boat-life-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502003148287-a82ef80a6abc?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-17',
    tags: ['mobile-living', 'van-life', 'boat-living', 'comparison', 'nomad', 'structure-3', 'intro-5'],
    content: { en: { title: 'Van Life vs Boat Life: Two Paths, Different Realities', excerpt: 'Both promise freedom and adventure, but van life and boat life demand different skills, budgets, and temperaments. Here is what each path actually requires.', body: '' } },
  },
  {
    id: '297',
    slug: 'off-grid-vs-homestead-comparison',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-23',
    tags: ['off-grid-homes', 'homestead', 'comparison', 'self-sufficiency', 'structure-3', 'intro-2'],
    content: { en: { title: 'Off-Grid Living vs Homesteading: Real Differences', excerpt: 'Off-grid living and homesteading overlap but demand different skills, budgets, and commitments. A clear framework for choosing your path to self-sufficiency.', body: '' } },
  },
  {
    id: '298',
    slug: 'off-grid-solar-vs-wind-power-comparison',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-02',
    tags: ['off-grid-homes', 'solar', 'wind', 'energy', 'comparison', 'structure-3', 'intro-3'],
    content: { en: { title: 'Off-Grid Solar vs Wind Power: Choosing the Right Energy Source', excerpt: 'Solar and wind each have clear advantages for off-grid power. Climate, budget, and maintenance tolerance determine which system - or combination - makes sense.', body: '' } },
  },
  {
    id: '299',
    slug: 'sailboat-vs-motorboat-liveaboard-comparison',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1586508577428-120d15be7e46?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-16',
    tags: ['boat-living', 'sailboat', 'motorboat', 'comparison', 'liveaboard', 'structure-3', 'intro-1'],
    content: { en: { title: 'Sailboat vs Motorboat for Liveaboard Life: A Direct Comparison', excerpt: 'Sailboats and motorboats offer different liveaboard experiences. Cost, range, maintenance, comfort, and required skills all factor into the right choice.', body: '' } },
  },
  {
    id: '300',
    slug: 'marina-living-vs-anchor-out-comparison',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544551763-92ab472cad1d?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-01',
    tags: ['boat-living', 'marina', 'anchoring', 'comparison', 'liveaboard', 'structure-3', 'intro-2'],
    content: { en: { title: 'Marina Living vs Anchoring Out: Finding Your Liveaboard Style', excerpt: 'Marina berths and anchorages offer different liveaboard experiences. Cost, convenience, community, and freedom all shift depending on where you keep your boat.', body: '' } },
  },
  {
    id: '301',
    slug: 'why-beginners-quit-camping',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-08',
    tags: ['camping', 'beginners', 'mistakes', 'outdoor', 'structure-2', 'intro-1'],
    content: { en: { title: 'Why Beginners Quit Camping (And How to Make Sure You Don\'t)', excerpt: 'Most people who try camping once never go again. The reasons are predictable, preventable, and almost always about preparation rather than preference.', body: '' } },
  },
  {
    id: '302',
    slug: 'camping-exhaustion-why-camping-feels-so-tiring',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1482192505345-5655af888cc4?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-08',
    tags: ['camping', 'exhaustion', 'sleep', 'outdoor', 'wellness', 'structure-2', 'intro-2'],
    content: { en: { title: 'Camping Exhaustion: Why It Feels So Tiring', excerpt: 'You went camping to relax, but came home needing a vacation from your vacation. The exhaustion is real, predictable, and entirely fixable with the right.', body: '' } },
  },
  {
    id: '303',
    slug: 'van-life-problems-nobody-talks-about',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533073526757-2c8ca1df9f1c?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-26',
    tags: ['mobile-living', 'van-life', 'problems', 'reality', 'structure-2', 'intro-6'],
    content: { en: { title: 'Van Life Problems Nobody Talks About (But Should)', excerpt: 'The curated version of van life skips breakdowns, loneliness, and hygiene challenges. Real problems and what experienced van dwellers actually do about them.', body: '' } },
  },
  {
    id: '304',
    slug: 'why-people-quit-van-life',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1470104240373-bc1812eddc9f?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-28',
    tags: ['mobile-living', 'van-life', 'quitting', 'transition', 'structure-2', 'intro-1'],
    content: { en: { title: 'Why People Quit Van Life: The Real Reasons', excerpt: 'Thousands start van life every year. Most quit within 18 months. The reasons reveal more about preparation failures than lifestyle incompatibility. Real data.', body: '' } },
  },
  {
    id: '305',
    slug: 'off-grid-living-regrets-common-mistakes',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-16',
    tags: ['off-grid', 'mistakes', 'regrets', 'planning', 'structure-2', 'intro-4'],
    content: { en: { title: 'Off-Grid Living Regrets: The Mistakes That Cost the Most', excerpt: 'The costliest off-grid mistakes happen before move-in: wrong land, undersized systems, and skipped permits. Learn from homeowners who already made these errors.', body: '' } },
  },
  {
    id: '306',
    slug: 'off-grid-power-failures-what-goes-wrong',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-21',
    tags: ['off-grid', 'solar', 'power', 'batteries', 'troubleshooting', 'structure-2', 'intro-5'],
    content: { en: { title: 'Off-Grid Power Failures: What Goes Wrong and How to Prevent It', excerpt: 'Your off-grid power system will fail at some point. Whether that failure is a minor inconvenience or catastrophic depends on how you designed and maintain it.', body: '' } },
  },
  {
    id: '307',
    slug: 'boat-life-mistakes-new-liveaboards-make',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1562281302-809108fd533c?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-18',
    tags: ['boat-living', 'mistakes', 'beginners', 'liveaboard', 'structure-2', 'intro-3'],
    content: { en: { title: 'Boat Life Mistakes That New Liveaboards Always Make', excerpt: 'New liveaboards make predictable, expensive mistakes - wrong boat choice, skipped surveys, deferred maintenance - each compounding into serious consequences.', body: '' } },
  },
  {
    id: '308',
    slug: 'liveaboard-problems-nobody-warns-you-about',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517021897933-0e0319cfbc28?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-29',
    tags: ['boat-living', 'problems', 'liveaboard', 'reality', 'structure-2', 'intro-4'],
    content: { en: { title: 'Liveaboard Problems Nobody Warns You About', excerpt: 'Moisture that never stops, marina politics, and systems failing on the worst day. The hidden problems of living on a boat and practical ways to manage them.', body: '' } },
  },
  {
    id: '309',
    slug: 'how-to-set-up-camp-in-rain',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-18',
    tags: ['camping', 'rain', 'setup', 'beginner', 'weather', 'structure-4', 'intro-3'],
    content: { en: { title: 'How to Set Up Camp in Rain: A Step-by-Step Guide', excerpt: 'Setting up camp in rain requires a specific sequence most campers get wrong. Follow these steps to stay dry from arrival to morning. Practical advice.', body: '' } },
  },
  {
    id: '310',
    slug: 'how-to-plan-your-first-overnight-camping-trip',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1452827073306-6e6e661baf57?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-11',
    tags: ['camping', 'planning', 'beginner', 'overnight', 'first-time', 'structure-4', 'intro-4'],
    content: { en: { title: 'How to Plan Your First Overnight Camping Trip', excerpt: 'Your first overnight camping trip needs a plan, not perfection. This step-by-step walkthrough covers everything from location to pack-out. With costs.', body: '' } },
  },
  {
    id: '311',
    slug: 'van-electrical-system-setup',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-24',
    tags: ['mobile-living', 'electrical', 'solar', 'diy', 'van-build', 'structure-4', 'intro-2'],
    content: { en: { title: 'Van Electrical System Setup: Complete Step-by-Step Guide', excerpt: 'Building a van electrical system intimidates most people, but the logic is straightforward. Follow this sequence for a reliable 12V setup. With costs.', body: '' } },
  },
  {
    id: '312',
    slug: 'how-to-insulate-a-van-for-four-seasons',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1565191999001-551c187427bb?w=800',
    publishedAt: '2025-10-17',
    tags: ['mobile-living', 'insulation', 'van-build', 'diy', 'four-seasons', 'structure-4', 'intro-3'],
    content: { en: { title: 'How to Insulate a Van for Four Seasons: Step-by-Step', excerpt: 'Four-season van insulation requires the right materials in the right order. This guide covers walls, ceiling, floor, and the vapor barrier most builders forget.', body: '' } },
  },
  {
    id: '313',
    slug: 'off-grid-rainwater-collection',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-20',
    tags: ['off-grid-homes', 'rainwater', 'water', 'diy', 'self-sufficient', 'structure-4', 'intro-6'],
    content: { en: { title: 'Off-Grid Rainwater Collection: Complete System Setup Guide', excerpt: 'A properly designed rainwater system provides reliable water independence. This step-by-step guide covers catchment, storage, and filtration. Real data.', body: '' } },
  },
  {
    id: '314',
    slug: 'how-to-install-off-grid-solar-system-beginners',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-28',
    tags: ['off-grid-homes', 'solar', 'diy', 'beginner', 'energy', 'structure-4', 'intro-1'],
    content: { en: { title: 'Off-Grid Solar Installation: A Beginner Guide', excerpt: 'An off-grid solar system has five core components wired in a specific sequence. This guide walks you through sizing, mounting, and commissioning. Real data.', body: '' } },
  },
  {
    id: '315',
    slug: 'boat-anchoring-step-by-step',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502680390548-bdbac40ae4e7?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-24',
    tags: ['boat-living', 'anchoring', 'seamanship', 'technique', 'safety', 'structure-4', 'intro-5'],
    content: { en: { title: 'Boat Anchoring Step by Step: The Complete Technique Guide', excerpt: 'Anchoring looks simple until the wind shifts at 3 AM. This step-by-step method covers approach, setting, scope, and overnight watch protocols. Real data.', body: '' } },
  },
  {
    id: '316',
    slug: 'how-to-prepare-boat-for-liveaboard-conversion',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-02',
    tags: ['boat-living', 'liveaboard', 'conversion', 'beginner', 'preparation', 'structure-4', 'intro-6'],
    content: { en: { title: 'Preparing a Boat for Liveaboard Conversion', excerpt: 'Converting a boat from weekend use to full-time living requires systematic upgrades across six core systems. Here is the step-by-step process. Real data.', body: '' } },
  },
  {
    id: '317',
    slug: 'caught-in-storm-while-camping',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1546587348-d12660c30c50?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-24',
    tags: ['camping', 'weather', 'safety', 'emergency', 'storm', 'structure-6', 'intro-5'],
    content: { en: { title: 'Caught in a Storm While Camping: What to Do', excerpt: 'A real-time scenario guide for handling sudden storms at camp - from securing your tent to making evacuation decisions under pressure with real costs.', body: '' } },
  },
  {
    id: '318',
    slug: 'lost-while-hiking-back-to-campsite',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1542810634-71277d95dcbb?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-15',
    tags: ['camping', 'hiking', 'navigation', 'safety', 'survival', 'structure-6', 'intro-6'],
    content: { en: { title: 'Lost While Hiking Back to Your Campsite: A Survival Scenario', excerpt: 'What happens when the trail disappears and darkness approaches - a step-by-step scenario for navigating disorientation in the backcountry. With costs.', body: '' } },
  },
  {
    id: '319',
    slug: 'what-if-your-van-breaks-down-remote',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1520939817895-060bdaf4fe1b?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-27',
    tags: ['mobile-living', 'van-life', 'emergency', 'breakdown', 'remote', 'structure-6', 'intro-4'],
    content: { en: { title: 'What If Your Van Breaks Down in a Remote Area?', excerpt: 'Mechanical failure far from cell service demands quick thinking. Self-diagnosis steps, signaling for help, and survival priorities when you are truly alone.', body: '' } },
  },
  {
    id: '320',
    slug: 'van-life-extreme-weather-emergency',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-29',
    tags: ['mobile-living', 'van-life', 'emergency', 'weather', 'flood', 'safety', 'structure-6', 'intro-5'],
    content: { en: { title: 'Van Life Extreme Weather: When Evacuation Fails', excerpt: 'Flash floods, extreme heat, and sudden storms can trap a van in minutes. Early detection, emergency relocation, and weather-specific survival steps.', body: '' } },
  },
  {
    id: '321',
    slug: 'off-grid-winter-power-outage-scenario',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-22',
    tags: ['off-grid-homes', 'power', 'winter', 'emergency', 'battery', 'structure-6', 'intro-2'],
    content: { en: { title: 'Off-Grid Winter Power Outage: Battery Bank Failure', excerpt: 'Complete power loss during extreme cold is every off-gridder\'s nightmare. Triage your loads, activate backup heat, and prevent pipe freeze damage.', body: '' } },
  },
  {
    id: '322',
    slug: 'off-grid-medical-emergency-remote',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-02',
    tags: ['off-grid-homes', 'medical', 'emergency', 'remote', 'first-aid', 'structure-6', 'intro-3'],
    content: { en: { title: 'Off-Grid Medical Emergency: Injury Miles from Help', excerpt: 'Serious injuries at a remote property require fast triage, stabilization, and knowing when helicopter evacuation is the only realistic option available.', body: '' } },
  },
  {
    id: '323',
    slug: 'boat-engine-failure-at-sea',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1468413253725-0d5181091126?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-05',
    tags: ['boat-living', 'engine', 'emergency', 'safety', 'sailing', 'structure-6', 'intro-1'],
    content: { en: { title: 'Boat Engine Failure at Sea: What to Do Offshore', excerpt: 'A real-time scenario guide for handling engine failure offshore - from drift calculations to calling for assistance and making the right decisions. Real data.', body: '' } },
  },
  {
    id: '324',
    slug: 'storm-anchor-dragging-emergency',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1515488764276-beab7607c1e6?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-09',
    tags: ['boat-living', 'anchor', 'storm', 'emergency', 'safety', 'structure-6', 'intro-2'],
    content: { en: { title: 'Storm Anchor Dragging Emergency: When Your Anchor Loses Its Grip', excerpt: 'Anchor drag during a squall demands rapid scope adjustment, engine-ready protocols, and knowing when to cut and relocate to safer holding ground.', body: '' } },
  },
  {
    id: '325',
    slug: 'best-camping-water-purification-methods',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1511994298241-608e28f14fde?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-14',
    tags: ['structure-1', 'intro-1', 'camping', 'water-purification', 'safety'],
    content: { en: { title: 'Best Camping Water Purification Methods: What Actually Works', excerpt: 'Pump filters, UV pens, chemical tablets, or boiling? A direct breakdown of which water purification method delivers safest results for camping. Real data.', body: '' } },
  },
  {
    id: '326',
    slug: 'camping-sleep-deprivation-problems',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501820488136-72669149e0d4?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-29',
    tags: ['structure-2', 'intro-2', 'camping', 'sleep', 'safety'],
    content: { en: { title: 'Why Poor Sleep Ruins Camping Trips (And How to Fix It)', excerpt: 'Poor sleep while camping causes impaired judgment and hypothermia risk. Pad selection, site leveling, temperature management, and wind protection are the fix.', body: '' } },
  },
  {
    id: '327',
    slug: 'van-life-electrical-system-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506260408121-e353d10b87c7?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-24',
    tags: ['structure-1', 'intro-6', 'mobile-living', 'electrical', 'solar'],
    content: { en: { title: 'What You Actually Need for Van Electrical', excerpt: 'Battery types, solar sizing, inverter selection, and real consumption math for van electrical systems. No jargon, just practical numbers. Honest data.', body: '' } },
  },
  {
    id: '328',
    slug: 'van-life-loneliness-problem',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1528728329032-2972f65dfb3f?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-08',
    tags: ['structure-2', 'intro-1', 'mobile-living', 'loneliness', 'mental-health'],
    content: { en: { title: 'The Van Life Loneliness Problem: Why Month Three Breaks People', excerpt: 'Chronic loneliness after the honeymoon period causes most people to quit van life. Understanding why it happens and building social structure that prevents it.', body: '' } },
  },
  {
    id: '329',
    slug: 'off-grid-septic-system-options-explained',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600210491369-e753d80a41f3?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-15',
    tags: ['structure-1', 'intro-4', 'off-grid-homes', 'septic', 'waste-management'],
    content: { en: { title: 'Off-Grid Septic Systems: Which Waste System Works', excerpt: 'Composting toilet, traditional septic, or constructed wetland? A practical comparison of off-grid waste systems covering costs, permits, and maintenance.', body: '' } },
  },
  {
    id: '330',
    slug: 'off-grid-home-moisture-mold-problems',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?w=800',
    publishedAt: '2026-01-13',
    tags: ['structure-2', 'intro-5', 'off-grid-homes', 'moisture', 'mold', 'ventilation'],
    content: { en: { title: 'Moisture and Mold in Off-Grid Homes: Why Tight Buildings Get Sick', excerpt: 'Condensation and mold in energy-efficient off-grid structures cause health risks and structural damage. Understanding the physics and designing proper.', body: '' } },
  },
  {
    id: '331',
    slug: 'liveaboard-refrigeration-systems-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-24',
    tags: ['structure-1', 'intro-3', 'boat-living', 'refrigeration', 'galley', 'electrical'],
    content: { en: { title: 'Liveaboard Refrigeration: What Keeps Food Cold', excerpt: 'Comparing 12V compressor, holding plate, and thermoelectric marine fridges. Real power draw numbers, tropical performance, and what liveaboards actually use.', body: '' } },
  },
  {
    id: '332',
    slug: 'liveaboard-hull-osmosis-problem',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-17',
    tags: ['structure-2', 'intro-4', 'boat-living', 'hull', 'osmosis', 'maintenance'],
    content: { en: { title: 'Hull Osmosis on Liveaboards: The Fiberglass Problem', excerpt: 'Osmotic blistering weakens fiberglass hulls over time. Understanding the causes, recognizing early signs, and deciding between prevention and repair economics.', body: '' } },
  },
  {
    id: '333',
    slug: 'camping-hammock-vs-tent-which-is-better',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1448375240586-882707db888b?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-12',
    tags: ['camping', 'hammock', 'tent', 'gear-comparison', 'structure-3', 'intro-3'],
    content: { en: { title: 'Hammock vs Tent for Camping: Which Shelter System Actually Wins?', excerpt: 'Hammock or tent? The right shelter depends on terrain, weather, and sleeping style. A real comparison of weight, comfort, cost, and practical limits. Real data.', body: '' } },
  },
  {
    id: '334',
    slug: 'how-to-set-up-a-tarp-shelter-camping',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533240332313-0db49b459ad6?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-08',
    tags: ['camping', 'tarp', 'shelter', 'skills', 'structure-4', 'intro-4'],
    content: { en: { title: 'How to Set Up a Tarp Shelter for Camping', excerpt: 'Setting up a tarp shelter takes practice but saves weight and money. Step-by-step instructions for A-frame, lean-to, and diamond configurations. Real data.', body: '' } },
  },
  {
    id: '335',
    slug: 'van-life-diesel-vs-gas-van-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-07',
    tags: ['mobile-living', 'van-selection', 'diesel', 'gasoline', 'structure-3', 'intro-2'],
    content: { en: { title: 'Diesel vs Gas Van for Van Life: Making the Right Engine Decision', excerpt: 'Diesel or gasoline for your van life build? Fuel economy, maintenance costs, torque, altitude performance, and resale value compared honestly. Real data.', body: '' } },
  },
  {
    id: '336',
    slug: 'how-to-install-van-life-solar-panels',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502085671122-2d218cd434e6?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-25',
    tags: ['mobile-living', 'solar', 'electrical', 'diy-install', 'structure-4', 'intro-3'],
    content: { en: { title: 'Camper Van Solar Panels: Roof Mounting Guide', excerpt: 'Install van solar panels yourself with this practical guide. Roof prep, panel mounting, wiring to charge controller, and battery connection explained.', body: '' } },
  },
  {
    id: '337',
    slug: 'off-grid-well-water-vs-rainwater-harvesting',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-05',
    tags: ['off-grid-homes', 'water', 'well', 'rainwater', 'structure-3', 'intro-6'],
    content: { en: { title: 'Well Water vs Rainwater Off-Grid: Which Fits Best?', excerpt: 'Well or rainwater for your off-grid home? Permits, costs, filtration needs, seasonal reliability, and long-term scalability compared for real properties.', body: '' } },
  },
  {
    id: '338',
    slug: 'how-to-build-off-grid-root-cellar',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1593696140826-c58b021acf8b?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-04',
    tags: ['off-grid-homes', 'food-storage', 'root-cellar', 'construction', 'structure-4', 'intro-1'],
    content: { en: { title: 'How to Build an Off-Grid Root Cellar: A Practical Guide', excerpt: 'Build a functional root cellar for year-round food storage. Site selection, excavation, drainage, ventilation, and temperature management explained step by.', body: '' } },
  },
  {
    id: '339',
    slug: 'liveaboard-monohull-vs-catamaran-decision',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-10',
    tags: ['boat-living', 'monohull', 'catamaran', 'boat-selection', 'structure-3', 'intro-5'],
    content: { en: { title: 'Monohull vs Catamaran for Liveaboard Life', excerpt: 'Monohull or catamaran for living aboard? Space, stability, marina fees, ocean capability, maintenance costs, and resale value compared honestly. Real data.', body: '' } },
  },
  {
    id: '340',
    slug: 'how-to-install-marine-watermaker',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1540202403-b7abd6747a18?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-03',
    tags: ['boat-living', 'watermaker', 'desalination', 'diy-install', 'structure-4', 'intro-6'],
    content: { en: { title: 'Marine Watermaker Installation: A Step-by-Step Guide', excerpt: 'Install a marine watermaker on your liveaboard boat. Through-hull fitting, pump placement, membrane setup, pre-filters, and commissioning explained step by.', body: '' } },
  },
  {
    id: '341',
    slug: 'how-campfire-smoke-affects-health-explained',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1469521669194-babb45599def?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-23',
    tags: ['camping', 'campfire', 'health', 'smoke', 'structure-5', 'intro-5'],
    content: { en: { title: 'Campfire Smoke and Your Health: What Science Shows', excerpt: 'Campfire smoke contains real pollutants including PM2.5 and carbon monoxide. Understanding the science helps you minimize exposure without giving up campfires.', body: '' } },
  },
  {
    id: '342',
    slug: 'camping-emergency-lost-in-the-woods-scenario',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-07',
    tags: ['camping', 'emergency', 'survival', 'navigation', 'structure-6', 'intro-6'],
    content: { en: { title: 'Lost in the Woods While Camping: A Survival Scenario Guide', excerpt: 'What to do when you realize you are lost while camping. A scenario-based guide covering immediate actions, shelter priorities, signaling, and rescue psychology.', body: '' } },
  },
  {
    id: '343',
    slug: 'van-life-condensation-moisture-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1527786356703-4b100091cd2c?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-20',
    tags: ['mobile-living', 'condensation', 'moisture', 'van-maintenance', 'structure-5', 'intro-4'],
    content: { en: { title: 'Van Life Condensation: Why It Happens and How to Fix It', excerpt: 'Condensation forms when warm interior air meets cold van walls. Insulation, ventilation, and moisture management strategies that prevent mold and keep things.', body: '' } },
  },
  {
    id: '344',
    slug: 'van-life-engine-breakdown-remote-area-scenario',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-05',
    tags: ['mobile-living', 'emergency', 'breakdown', 'roadside', 'structure-6', 'intro-5'],
    content: { en: { title: 'Van Breakdown in a Remote Area: What to Do', excerpt: 'Engine failure far from services tests your preparation. Roadside diagnostics, emergency kits, communication plans, and towing logistics for remote breakdowns.', body: '' } },
  },
  {
    id: '345',
    slug: 'off-grid-greywater-systems-explained',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1505843513577-22bb7d21e455?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-18',
    tags: ['off-grid-homes', 'greywater', 'water-systems', 'sustainability', 'structure-5', 'intro-2'],
    content: { en: { title: 'Off-Grid Greywater Systems: Wastewater as a Resource', excerpt: 'Greywater recycling turns sink and shower water into irrigation. Understanding treatment stages, legal requirements, and system design makes it practical.', body: '' } },
  },
  {
    id: '346',
    slug: 'off-grid-home-wildfire-threat-scenario',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-27',
    tags: ['off-grid-homes', 'wildfire', 'emergency', 'defensible-space', 'structure-6', 'intro-3'],
    content: { en: { title: 'Wildfire Near Your Off-Grid Home: Survival Scenario', excerpt: 'What happens when wildfire threatens your remote off-grid property? Evacuation decisions, defensible space evaluation, and the stay-or-go framework explained.', body: '' } },
  },
  {
    id: '347',
    slug: 'liveaboard-marine-diesel-engine-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1537956965359-7573183d1f57?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-09',
    tags: ['boat-living', 'diesel-engine', 'maintenance', 'marine-systems', 'structure-5', 'intro-1'],
    content: { en: { title: 'Marine Diesel for Liveaboards: How They Work and Fail', excerpt: 'Understanding your marine diesel engine prevents expensive failures. How combustion, cooling, fuel, and electrical systems work together on a liveaboard boat.', body: '' } },
  },
  {
    id: '348',
    slug: 'liveaboard-storm-at-anchor-scenario',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-28',
    tags: ['boat-living', 'storm', 'anchoring', 'emergency', 'structure-6', 'intro-2'],
    content: { en: { title: 'Storm at Anchor on Your Liveaboard: Survival Scenario', excerpt: 'A storm hits while you are anchored on your liveaboard. Anchor watch procedures, dragging response, and the decision to ride it out or seek shelter explained.', body: '' } },
  },
  {
    id: '349',
    slug: 'best-camping-headlamp-how-to-choose',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1464278533981-50106e6176b1?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-06',
    tags: ['camping', 'gear', 'headlamp', 'lighting', 'hiking', 'structure-1', 'intro-1'],
    content: { en: { title: 'Best Camping Headlamp: How to Choose the Right One', excerpt: 'A 200-lumen headlamp with flood beam covers 90% of camping needs. Here is what actually matters when choosing one for the trail. Real-world solutions.', body: '' } },
  },
  {
    id: '350',
    slug: 'camping-dehydration-risks-problems',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1433838552652-f9a46b332c40?w=800&auto=format&fit=crop',
    publishedAt: '2025-08-14',
    tags: ['camping', 'health', 'hydration', 'safety', 'wilderness', 'structure-2', 'intro-2'],
    content: { en: { title: 'Camping Dehydration: The Hidden Risk That Ruins Trips', excerpt: 'Most campers underestimate water needs by 40%. Dehydration causes headaches, poor decisions, and dangerous heat illness before you realize it. Real data.', body: '' } },
  },
  {
    id: '351',
    slug: 'van-life-insulation-materials-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-29',
    tags: ['mobile-living', 'van-life', 'insulation', 'build', 'materials', 'structure-1', 'intro-6'],
    content: { en: { title: 'Van Life Insulation Materials: Which One Actually Works Best', excerpt: 'Closed-cell spray foam wins for thermal performance, but wool insulation handles moisture better. The right choice depends on your climate and budget.', body: '' } },
  },
  {
    id: '352',
    slug: 'van-life-parking-tickets-legal-problems',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1619084273229-8945e1a1ac2c?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-12',
    tags: ['mobile-living', 'van-life', 'legal', 'parking', 'stealth', 'structure-2', 'intro-1'],
    content: { en: { title: 'Van Life Parking Tickets: How to Avoid Legal Trouble', excerpt: 'Parking fines average $50-150 each, and three violations in some cities trigger impound. Here is how experienced van lifers avoid legal confrontation entirely.', body: '' } },
  },
  {
    id: '353',
    slug: 'off-grid-earthship-construction-explained',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-16',
    tags: ['off-grid-homes', 'earthship', 'construction', 'sustainable', 'building', 'structure-1', 'intro-4'],
    content: { en: { title: 'Off-Grid Earthship Construction: How It Actually Works', excerpt: 'An earthship is a passive solar home from recycled materials that heats, cools, and waters itself. Construction costs $50–250/sqft depending on labor choices.', body: '' } },
  },
  {
    id: '354',
    slug: 'off-grid-well-pump-failure-problems',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533327325824-76bc4e62d560?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-07',
    tags: ['off-grid-homes', 'water', 'well', 'pump', 'maintenance', 'emergency', 'structure-2', 'intro-5'],
    content: { en: { title: 'Off-Grid Well Pump Failure: When Your Water Supply Stops', excerpt: 'A failed well pump means zero water within hours. The fix depends on three factors: pump type, depth, and whether you prepared backup systems before failure.', body: '' } },
  },
  {
    id: '355',
    slug: 'liveaboard-anchor-types-holding-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534854638093-bada1813ca19?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-18',
    tags: ['boat-living', 'anchor', 'equipment', 'safety', 'seamanship', 'structure-1', 'intro-3'],
    content: { en: { title: 'Liveaboard Anchor Types and Holding Power: What Actually Works', excerpt: 'A modern concave-fluke anchor (Rocna, Mantus) holds 2-3x more than traditional CQR or Delta designs at equal weight. Here is why, and when it matters.', body: '' } },
  },
  {
    id: '356',
    slug: 'liveaboard-electrical-corrosion-problems',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530870110042-98b2cb110834?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-18',
    tags: ['boat-living', 'electrical', 'corrosion', 'maintenance', 'safety', 'structure-2', 'intro-4'],
    content: { en: { title: 'Liveaboard Electrical Corrosion: The Silent Threat', excerpt: 'Galvanic and stray current corrosion destroy underwater metals invisibly. A $200 zinc anode system prevents $10,000+ in hull damage - if you maintain it.', body: '' } },
  },
  {
    id: '357',
    slug: 'camping-synthetic-vs-down-sleeping-bag',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1414016642493-13b22f83bd0f?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-29',
    tags: ['structure-3', 'intro-3', 'camping', 'sleeping-bag', 'gear-comparison'],
    content: { en: { title: 'Synthetic vs Down Sleeping Bag: Which to Choose?', excerpt: 'The synthetic-vs-down debate has a clear answer for most campers, but the right choice depends on where you sleep, how you pack, and what you can afford.', body: '' } },
  },
  {
    id: '358',
    slug: 'how-to-hang-a-bear-bag-camping',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519944518895-f5544b568ece?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-23',
    tags: ['structure-4', 'intro-4', 'camping', 'bear-safety', 'food-storage'],
    content: { en: { title: 'How to Hang a Bear Bag: Backcountry Guide', excerpt: 'A properly hung bear bag protects your food, your campsite, and the bears themselves - here is exactly how to do it right every time based on testing.', body: '' } },
  },
  {
    id: '359',
    slug: 'van-life-fixed-roof-vs-pop-top-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-04',
    tags: ['structure-3', 'intro-2', 'mobile-living', 'van-conversion', 'roof-comparison'],
    content: { en: { title: 'Fixed High Roof vs Pop-Top Van: Which Is Better?', excerpt: 'The roof decision shapes every aspect of van life from daily comfort to fuel costs - and the right answer depends on how you actually plan to live and travel.', body: '' } },
  },
  {
    id: '360',
    slug: 'how-to-install-van-life-diesel-heater',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-18',
    tags: ['structure-4', 'intro-3', 'mobile-living', 'diesel-heater', 'van-build'],
    content: { en: { title: 'How to Install a Diesel Heater in Your Camper Van', excerpt: 'Installing a diesel heater transforms cold-weather van life from survival mode to genuine comfort - this guide covers every step from fuel tap to first.', body: '' } },
  },
  {
    id: '361',
    slug: 'off-grid-wood-stove-vs-rocket-mass-heater',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1505275350441-83dcda8eeef5?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-09',
    tags: ['structure-3', 'intro-6', 'off-grid-homes', 'heating', 'wood-stove'],
    content: { en: { title: 'Wood Stove vs Rocket Mass Heater for Off-Grid Homes', excerpt: 'Wood stoves and rocket mass heaters burn wood but deliver heat through different physics - choosing between them shapes fuel costs and your daily routine.', body: '' } },
  },
  {
    id: '362',
    slug: 'how-to-install-off-grid-rainwater-system',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516455590571-18256e5bb9ff?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-21',
    tags: ['structure-4', 'intro-1', 'off-grid-homes', 'rainwater', 'water-system'],
    content: { en: { title: 'Rainwater Harvesting Setup for Off-Grid Homes', excerpt: 'A properly designed rainwater system transforms roof runoff into reliable household water supply - here is exactly how to build one from gutters to tap.', body: '' } },
  },
  {
    id: '363',
    slug: 'liveaboard-tiller-vs-wheel-steering-decision',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1559494007-9f5847c49d94?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-03',
    tags: ['structure-3', 'intro-5', 'boat-living', 'steering', 'sailboat-decision'],
    content: { en: { title: 'Tiller vs Wheel Steering for Liveaboard Sailboats', excerpt: 'Your steering system affects cockpit layout, sailing feel, maintenance costs, and autopilot options - the right answer depends on boat size and cruising plans.', body: '' } },
  },
  {
    id: '364',
    slug: 'how-to-splice-marine-rope-liveaboard',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-31',
    tags: ['structure-4', 'intro-6', 'boat-living', 'rope-work', 'boat-skills'],
    content: { en: { title: 'How to Splice Marine Rope for Liveaboards', excerpt: 'Splicing creates permanent rope connections stronger than knots without the bulk that snags on deck hardware. Every liveaboard should master the eye splice.', body: '' } },
  },
  {
    id: '365',
    slug: 'how-wind-chill-affects-camping-explained',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517299321609-52687d1bc55a?w=800',
    publishedAt: '2025-03-29',
    tags: ['camping', 'weather', 'safety', 'structure-5', 'intro-5'],
    content: { en: { title: 'How Wind Chill Affects Camping - And Why Most People Get It Wrong', excerpt: 'Wind chill changes how cold actually feels on exposed skin and affects hypothermia risk. Most campers misunderstand it - here is what the numbers really mean.', body: '' } },
  },
  {
    id: '366',
    slug: 'camping-river-crossing-gone-wrong-scenario',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-21',
    tags: ['camping', 'safety', 'water', 'emergency', 'structure-6', 'intro-6'],
    content: { en: { title: 'Camping River Crossing Gone Wrong: A Survival Scenario', excerpt: 'A swollen river after overnight rain looks crossable until it is not. River crossing safety, current reading, and the decision framework for when to turn back.', body: '' } },
  },
  {
    id: '367',
    slug: 'van-life-grey-water-systems-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1570125909232-eb263c188f7e?w=800',
    publishedAt: '2025-09-18',
    tags: ['mobile-living', 'plumbing', 'van-build', 'structure-5', 'intro-4'],
    content: { en: { title: 'Van Life Grey Water Systems: From Drain to Dump', excerpt: 'Grey water management is the least glamorous part of van life and the one most likely to create problems if ignored. The whole system explained practically.', body: '' } },
  },
  {
    id: '368',
    slug: 'van-life-wildfire-evacuation-scenario',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1603174326823-05b4b0ec6d30?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-11',
    tags: ['mobile-living', 'safety', 'emergency', 'structure-6', 'intro-5'],
    content: { en: { title: 'Van Life Wildfire Evacuation - When Smoke Means Move Now', excerpt: 'Smoke on the horizon looks dramatic and distant until the wind shifts. For van lifers, wildfire evacuation requires different thinking than residential.', body: '' } },
  },
  {
    id: '369',
    slug: 'off-grid-passive-solar-design-explained',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1431540015159-0f9673883be2?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-17',
    tags: ['off-grid-homes', 'design', 'heating', 'solar', 'structure-5', 'intro-2'],
    content: { en: { title: 'Off-Grid Passive Solar Design: Free Heat Done Right', excerpt: 'Passive solar heating slashes energy needs by 50-70%, but glazing ratios, thermal mass, and overhangs must work precisely together. Execution matters most here.', body: '' } },
  },
  {
    id: '370',
    slug: 'off-grid-flooding-emergency-scenario',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1547683905-f686c993aae5?w=800',
    publishedAt: '2025-09-18',
    tags: ['off-grid-homes', 'emergency', 'safety', 'weather', 'structure-6', 'intro-3'],
    content: { en: { title: 'Off-Grid Flooding Emergency: When Water Rises Fast', excerpt: 'Flash flooding reaches off-grid properties faster than most owners expect. Early warning signs, evacuation routes, and property-level flood mitigation.', body: '' } },
  },
  {
    id: '371',
    slug: 'liveaboard-marine-weather-forecasting-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1534067783941-51c9c23ecefd?w=800',
    publishedAt: '2025-07-12',
    tags: ['boat-living', 'weather', 'navigation', 'safety', 'structure-5', 'intro-1'],
    content: { en: { title: 'Marine Weather Forecasting: Reading the Sky Early', excerpt: 'GRIB data, barometric trends, cloud patterns, and local knowledge - four layers that keep liveaboard sailors safe when conditions shift unexpectedly.', body: '' } },
  },
  {
    id: '372',
    slug: 'liveaboard-man-overboard-scenario',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1528580568150-0f0d2917fbe6?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-27',
    tags: ['boat-living', 'safety', 'emergency', 'solo-sailing', 'structure-6', 'intro-2'],
    content: { en: { title: 'Man Overboard While Solo Sailing: A Critical Scenario', excerpt: 'Falling overboard while sailing alone is survivable with the right preparation. Tethering systems, recovery gear, and the protocols that keep solo sailors.', body: '' } },
  },
  {
    id: '373',
    slug: 'best-camping-stove-fuel-types-explained',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1608018093777-8f77c1d7c23f?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-21',
    tags: ['camping', 'stoves', 'fuel', 'gear', 'structure-1', 'intro-1'],
    content: { en: { title: 'Best Camping Stove Fuel Types: Which One Actually Works for You', excerpt: 'Canister gas, liquid fuel, alcohol, wood - each camping stove fuel has real tradeoffs in weight, cold performance, and cost that change everything. Real data.', body: '' } },
  },
  {
    id: '374',
    slug: 'camping-boot-blisters-prevention-problems',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1525811902-f2342640856e?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-22',
    tags: ['camping', 'hiking', 'boots', 'blisters', 'health', 'structure-2', 'intro-2'],
    content: { en: { title: 'Camping Boot Blisters: Prevention That Actually Works', excerpt: 'Boot blisters turn dream hikes into survival marches. Understanding friction, moisture, and fit prevents the problem before the first hot spot appears.', body: '' } },
  },
  {
    id: '375',
    slug: 'van-life-water-heater-options-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?w=800',
    publishedAt: '2025-12-16',
    tags: ['van-life', 'water-heater', 'plumbing', 'comfort', 'structure-1', 'intro-6'],
    content: { en: { title: 'Hot Water in a Van: Heater Options for Small Spaces', excerpt: 'Tankless propane heaters deliver the best balance of hot water performance and space efficiency for most van builds. Here is the full breakdown. Real data.', body: '' } },
  },
  {
    id: '376',
    slug: 'van-life-rust-damage-prevention-problems',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1551524559-8af4e6624178?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-27',
    tags: ['van-life', 'maintenance', 'rust', 'prevention', 'structure-2', 'intro-1'],
    content: { en: { title: 'Van Life Rust Damage: The Silent Home Destroyer', excerpt: 'Rust is the biggest long-term threat to any van conversion. Understanding where it starts, why it spreads, and how to stop it saves thousands in repairs.', body: '' } },
  },
  {
    id: '377',
    slug: 'off-grid-greywater-recycling-systems-explained',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1499955085172-a104c9463ece?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-17',
    tags: ['off-grid', 'greywater', 'recycling', 'water-systems', 'structure-1', 'intro-4'],
    content: { en: { title: 'Off-Grid Greywater Recycling: What System Works', excerpt: 'A branched drain greywater system with mulch basins is the most reliable recycling setup for most off-grid homes. Here is why, and when alternatives win.', body: '' } },
  },
  {
    id: '378',
    slug: 'off-grid-roof-leak-damage-problems',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1513836279014-a89f7a76ae86?w=800',
    publishedAt: '2025-11-16',
    tags: ['off-grid', 'maintenance', 'roof', 'water-damage', 'structure-2', 'intro-5'],
    content: { en: { title: 'Off-Grid Roof Leaks: Why Small Drips Become Structural Disasters', excerpt: 'Your roof type, climate zone, and response speed determine whether a small drip stays minor or becomes structural. A 48-hour delay can triple repair costs.', body: '' } },
  },
  {
    id: '379',
    slug: 'liveaboard-diesel-vs-electric-engine-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1476842634003-7dcca8f832de?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-30',
    tags: ['boat-living', 'engines', 'diesel', 'electric', 'propulsion', 'structure-1', 'intro-3'],
    content: { en: { title: 'Liveaboard Diesel vs Electric Propulsion', excerpt: 'Most people think electric propulsion is the future of boating. For liveaboards, diesel remains the practical choice - but the gap is closing fast. Real data.', body: '' } },
  },
  {
    id: '380',
    slug: 'liveaboard-holding-tank-problems',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1486673748761-a8d18475c757?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-04',
    tags: ['boat-living', 'sanitation', 'holding-tank', 'maintenance', 'structure-2', 'intro-4'],
    content: { en: { title: 'Liveaboard Holding Tank Problems: When Systems Fail', excerpt: 'Holding tank issues rank as the most dreaded maintenance problem on any liveaboard. Understanding the causes prevents the crisis nobody wants to experience.', body: '' } },
  },
  {
    id: '381',
    slug: 'camping-tent-vs-bivy-sack-decision',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1496080174650-637e3f22fa03?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-02',
    tags: ['camping', 'shelter', 'tent', 'bivy', 'decision', 'structure-3', 'intro-3'],
    content: { en: { title: 'Tent vs Bivy Sack: Which Shelter Actually Makes Sense?', excerpt: 'Choosing between a tent and a bivy sack depends on how you camp. Weight, weather protection, comfort, and packability compared for backpackers and minimalists.', body: '' } },
  },
  {
    id: '382',
    slug: 'how-to-filter-water-while-hiking',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1616166330003-8b5f2b2b5b1a?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-02',
    tags: ['camping', 'water', 'filtration', 'hiking', 'how-to', 'structure-4', 'intro-4'],
    content: { en: { title: 'How to Filter Water While Hiking: A Step-by-Step Guide', excerpt: 'Drinking untreated water on the trail guarantees a ruined trip. Step-by-step water filtration with pump filters, gravity systems, and chemical backup methods.', body: '' } },
  },
  {
    id: '383',
    slug: 'van-life-2wd-vs-4wd-van-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1611048268330-53de574cae3b?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-14',
    tags: ['mobile-living', 'van', 'drivetrain', '4wd', 'decision', 'structure-3', 'intro-2'],
    content: { en: { title: '2WD vs 4WD Van for Van Life: Making the Right Choice', excerpt: 'The 2WD vs 4WD debate splits the van life community. Terrain needs, fuel costs, maintenance differences, and resale value compared for real-world van buyers.', body: '' } },
  },
  {
    id: '384',
    slug: 'how-to-build-van-life-bed-platform',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-28',
    tags: ['mobile-living', 'van-build', 'bed', 'diy', 'how-to', 'structure-4', 'intro-3'],
    content: { en: { title: 'Van Bed Platform: A Step-by-Step Building Guide', excerpt: 'Your bed platform is the most important piece of van furniture. Materials, dimensions, storage underneath, and construction steps for a solid sleeping.', body: '' } },
  },
  {
    id: '385',
    slug: 'off-grid-container-home-vs-timber-frame',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1520608421741-68228b76b6df?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-28',
    tags: ['off-grid-homes', 'construction', 'container', 'timber-frame', 'decision', 'structure-3', 'intro-6'],
    content: { en: { title: 'Container Home vs Timber Frame Off-Grid: Which Structure Fits?', excerpt: 'Shipping containers look affordable and fast. Timber frames look traditional and proven. The real comparison involves factors most off-grid builders overlook.', body: '' } },
  },
  {
    id: '386',
    slug: 'how-to-install-off-grid-composting-toilet',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1515496281361-44a42a322b19?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-16',
    tags: ['off-grid-homes', 'composting-toilet', 'sanitation', 'diy', 'how-to', 'structure-4', 'intro-1'],
    content: { en: { title: 'Off-Grid Composting Toilet: Installation Guide', excerpt: 'A composting toilet can be odor-free and low-maintenance. Installation steps, ventilation requirements, and ongoing management for off-grid homes explained.', body: '' } },
  },
  {
    id: '387',
    slug: 'liveaboard-sail-vs-power-boat-decision',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-26',
    tags: ['boat-living', 'sailboat', 'powerboat', 'decision', 'liveaboard', 'structure-3', 'intro-5'],
    content: { en: { title: 'Sailboat vs Powerboat for Living Aboard: The Real Decision', excerpt: 'Your cruising range, maintenance tolerance, and honest feelings about sailing itself determine whether a sailboat or powerboat fits your liveaboard life.', body: '' } },
  },
  {
    id: '388',
    slug: 'how-to-antifoul-boat-hull-liveaboard',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-08',
    tags: ['boat-living', 'maintenance', 'antifouling', 'hull', 'how-to', 'structure-4', 'intro-6'],
    content: { en: { title: 'How to Antifoul Your Boat Hull: Step-by-Step for Liveaboards', excerpt: 'Bottom painting is the most critical maintenance task liveaboards dread. Surface prep, antifouling paint selection, application technique, and timing explained.', body: '' } },
  },
  {
    id: '389',
    slug: 'how-altitude-affects-camping-explained',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504457047772-27faf1c00561?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-20',
    tags: ['camping', 'altitude', 'safety', 'cooking', 'weather', 'structure-5', 'intro-5'],
    content: { en: { title: 'How Altitude Affects Camping: What Changes Above 5,000 Feet', excerpt: 'Altitude changes cooking times, UV exposure, sleep quality, and hydration needs. Here is what actually shifts when you camp above 5,000 feet. Real data.', body: '' } },
  },
  {
    id: '390',
    slug: 'camping-lightning-storm-scenario',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1461511669078-d46bf351cd6e?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-01',
    tags: ['camping', 'lightning', 'safety', 'emergency', 'weather', 'structure-6', 'intro-6'],
    content: { en: { title: 'Caught in a Lightning Storm While Camping: A Survival Scenario', excerpt: 'Exposed terrain, darkening sky, thunder closing in. This scenario walks through real-time lightning safety decisions every camper should rehearse. Real data.', body: '' } },
  },
  {
    id: '391',
    slug: 'van-life-condensation-ventilation-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1610147323479-a7fb11765af5?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-23',
    updatedAt: '2026-07-22',
    tags: ['mobile-living', 'condensation', 'ventilation', 'van-build', 'moisture', 'structure-5', 'intro-4'],
    content: { en: { title: 'Van Life Condensation: Why Your Van Gets Wet Inside', excerpt: 'Condensation destroys van interiors faster than road salt. Understand the dew point science, fan placement, and vapor barrier strategies that keep your van dry.', body: '' } },
  },
  {
    id: '392',
    slug: 'van-life-engine-breakdown-remote-scenario',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1474540412665-1cdae210ae6b?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-20',
    tags: ['mobile-living', 'breakdown', 'emergency', 'remote', 'safety', 'structure-6', 'intro-5'],
    content: { en: { title: 'Your Van Engine Dies on a Remote Road: A Decision-Making Scenario', excerpt: 'No cell signal, 40 miles from town, engine will not restart. This scenario walks through self-diagnosis, emergency priorities, and the walk-vs-wait decision.', body: '' } },
  },
  {
    id: '393',
    slug: 'off-grid-battery-bank-sizing-explained',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1505916349660-8d91a5fba68e?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-07',
    tags: ['off-grid-homes', 'battery', 'solar', 'power', 'electrical', 'structure-5', 'intro-2'],
    content: { en: { title: 'Off-Grid Battery Bank Sizing: Calculate Your Needs', excerpt: 'Most off-grid battery banks are either dangerously undersized or wastefully oversized. Here is the math that gets it right on the first build. Real data.', body: '' } },
  },
  {
    id: '395',
    slug: 'liveaboard-marine-diesel-maintenance-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-21',
    tags: ['boat-living', 'diesel', 'engine', 'maintenance', 'liveaboard', 'structure-5', 'intro-1'],
    content: { en: { title: 'Marine Diesel Maintenance: What Liveaboards Must Know', excerpt: 'Marine diesels are remarkably reliable when maintained on schedule. Neglect them and repair bills escalate fast. Here is how the maintenance cycle works.', body: '' } },
  },
  {
    id: '396',
    slug: 'liveaboard-dragging-anchor-night-scenario',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1506953823645-5e0b975dbf95?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-06',
    tags: ['boat-living', 'anchoring', 'safety', 'emergency', 'scenario', 'structure-6', 'intro-2'],
    content: { en: { title: 'Your Anchor Drags at 3 AM: A Liveaboard Night Emergency Scenario', excerpt: 'Anchor alarm screaming, wind shifted 90 degrees, shore 200 meters downwind. This scenario walks through night re-anchoring and the decision to abandon the.', body: '' } },
  },
  {
    id: '397',
    slug: 'best-camping-knife-how-to-choose',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?w=800&auto=format&fit=crop',
    publishedAt: '2026-02-02',
    tags: ['camping', 'gear', 'knives', 'structure-1', 'intro-1'],
    content: { en: { title: 'Best Camping Knife: How to Choose the Right One', excerpt: 'A 4-inch fixed-blade with full tang and high-carbon steel handles 90% of camp tasks. Here is exactly what to look for and why most campers overcomplicate this.', body: '' } },
  },
  {
    id: '398',
    slug: 'camping-hypothermia-warning-signs-problems',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1614094082869-cd4e4b2dd1bc?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-09',
    tags: ['camping', 'safety', 'hypothermia', 'structure-2', 'intro-2'],
    content: { en: { title: 'Camping Hypothermia Warning Signs: Problems You Must Recognize', excerpt: 'Hypothermia begins before you feel truly cold. Early warning signs are subtle - fumbling fingers, slurred words, poor decisions - and recognizing them saves.', body: '' } },
  },
  {
    id: '399',
    slug: 'van-life-lithium-battery-upgrade-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-24',
    tags: ['mobile-living', 'electrical', 'batteries', 'structure-1', 'intro-6'],
    content: { en: { title: 'Van Life Lithium Battery Upgrade Explained', excerpt: 'In this guide: lithium vs AGM real-world math, BMS requirements, charging profile changes, cost-per-cycle analysis, and when the upgrade genuinely pays for.', body: '' } },
  },
  {
    id: '400',
    slug: 'van-life-black-mold-health-problems',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1492366254240-43affaefc3e3?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-28',
    tags: ['mobile-living', 'health', 'maintenance', 'structure-2', 'intro-1'],
    content: { en: { title: 'Van Life Black Mold Health Problems: Causes and Solutions', excerpt: 'Yes, mold grows behind van panels in as little as 72 hours of sustained humidity above 60%. Here is how to find it, stop it, and prevent structural damage.', body: '' } },
  },
  {
    id: '401',
    slug: 'off-grid-ground-source-heat-pump-explained',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-20',
    tags: ['off-grid-homes', 'heating', 'technology', 'structure-1', 'intro-4'],
    content: { en: { title: 'Off-Grid Ground-Source Heat Pump Explained', excerpt: 'Well water stays 10–15°C year-round. Ground-source heat pumps exploit this for heating and cooling with COPs of 3.5–5.0, but installation starts at $15,000.', body: '' } },
  },
  {
    id: '402',
    slug: 'off-grid-septic-system-failure-problems',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1510525009512-ad7fc13eefab?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-06',
    tags: ['off-grid-homes', 'maintenance', 'sanitation', 'structure-2', 'intro-5'],
    content: { en: { title: 'Off-Grid Septic System Failure: Problems and Solutions', excerpt: 'Septic failure depends on soil type, pumping schedule, and whether your drain field was sized for actual occupancy. Most off-grid septic failures are.', body: '' } },
  },
  {
    id: '403',
    slug: 'liveaboard-marine-vhf-radio-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1517483000871-1dbf64a6e1c6?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-06',
    updatedAt: '2026-07-22',
    tags: ['boat-living', 'safety', 'electronics', 'structure-1', 'intro-3'],
    content: { en: { title: 'Liveaboard Marine VHF Radio Setup and Essentials', excerpt: 'Most liveaboards need a 25-watt fixed-mount VHF with DSC capability and an 8-foot masthead antenna. What each component does and why it matters for safety.', body: '' } },
  },
  {
    id: '404',
    slug: 'liveaboard-rigging-failure-problems',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-01',
    tags: ['boat-living', 'maintenance', 'rigging', 'structure-2', 'intro-4'],
    content: { en: { title: 'Liveaboard Rigging Failure Problems: Prevention and Solutions', excerpt: 'Your standing rigging is under load 24 hours a day, 365 days a year. Fatigue, corrosion, and crevice failure develop silently until catastrophic dismasting.', body: '' } },
  },
  {
    id: '405',
    slug: 'camping-canister-vs-liquid-fuel-stove-decision',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1618083707868-982e3641c157?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-29',
    tags: ['camping', 'stoves', 'gear-decision', 'structure-3', 'intro-3'],
    content: { en: { title: 'Canister vs Liquid Fuel Stove: Which Fits Your Pack?', excerpt: 'Weight, cold-weather performance, fuel availability, and real-world reliability compared for backpackers choosing between canister and liquid fuel stoves.', body: '' } },
  },
  {
    id: '406',
    slug: 'how-to-build-a-campfire-reflector-wall',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1607013407627-6ee814329547?w=800&auto=format&fit=crop',
    publishedAt: '2025-12-06',
    tags: ['camping', 'campfire', 'skills', 'structure-4', 'intro-4'],
    content: { en: { title: 'Campfire Reflector Wall: A Building Guide', excerpt: 'Build a log reflector wall that redirects campfire heat toward your shelter - material selection, stacking technique, positioning angles, and common mistakes.', body: '' } },
  },
  {
    id: '407',
    slug: 'van-life-short-vs-long-wheelbase-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-29',
    tags: ['mobile-living', 'van-selection', 'decision-framework', 'structure-3', 'intro-2'],
    content: { en: { title: 'Short vs Long Wheelbase Van: Which Fits Your Life?', excerpt: 'SWB vs LWB vans compared across living space, drivability, parking ease, fuel economy, and real-world usability for different travel styles and budgets.', body: '' } },
  },
  {
    id: '408',
    slug: 'how-to-install-van-life-roof-rack',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502920514313-52581002a659?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-21',
    tags: ['mobile-living', 'van-build', 'how-to', 'structure-4', 'intro-3'],
    content: { en: { title: 'Van Roof Rack Mounting: A Step-by-Step Guide', excerpt: 'Measuring, mounting, and sealing a roof rack on your conversion van. Drilling vs clamping methods, load ratings, and waterproofing the finished install.', body: '' } },
  },
  {
    id: '409',
    slug: 'off-grid-metal-roof-vs-shingles-decision',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1542889601-399c4f3a8402?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-05',
    tags: ['off-grid-homes', 'building', 'decision-framework', 'structure-3', 'intro-6'],
    content: { en: { title: 'Metal Roof vs Shingles for Off-Grid Homes: Which One Wins?', excerpt: 'Standing seam metal vs asphalt shingles for off-grid homes - lifespan, rainwater harvesting, snow load performance, total cost, and DIY feasibility compared.', body: '' } },
  },
  {
    id: '410',
    slug: 'how-to-build-off-grid-outdoor-shower',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800',
    publishedAt: '2025-12-29',
    tags: ['off-grid-homes', 'diy-build', 'how-to', 'structure-4', 'intro-1'],
    content: { en: { title: 'Off-Grid Outdoor Shower: A Building Guide', excerpt: 'Building a gravity-fed or solar-heated outdoor shower for your off-grid property. Platform construction, drainage design, and winterization steps.', body: '' } },
  },
  {
    id: '411',
    slug: 'liveaboard-outboard-vs-inboard-engine-decision',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1613279706895-4be5b0110c34?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-08',
    tags: ['boat-living', 'engines', 'decision-framework', 'structure-3', 'intro-5'],
    content: { en: { title: 'Outboard vs Inboard for Liveaboards: The Real Choice', excerpt: 'Maintenance costs, fuel efficiency, noise levels, draft, and long-distance reliability compared for liveaboard cruisers choosing their propulsion setup.', body: '' } },
  },
  {
    id: '412',
    slug: 'how-to-install-marine-solar-panels-liveaboard',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=800',
    publishedAt: '2025-07-27',
    tags: ['boat-living', 'solar', 'how-to', 'structure-4', 'intro-6'],
    content: { en: { title: 'Marine Solar Panel Mounting for Liveaboards', excerpt: 'Selecting, mounting, and wiring solar panels on a liveaboard boat - arch vs deck mounting, charge controller selection, and battery bank integration explained.', body: '' } },
  },
  {
    id: '413',
    slug: 'understanding-campfire-heat-transfer-explained',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530027644375-9c83053d392e?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-05',
    tags: ['camping', 'campfire', 'science', 'heat', 'education', 'structure-5', 'intro-5'],
    content: { en: { title: 'Understanding Campfire Heat Transfer: How Fire Actually Warms You', excerpt: 'Campfire warmth involves three distinct heat transfer mechanisms. Understanding the physics changes how you build fires, position yourself, and conserve warmth.', body: '' } },
  },
  {
    id: '414',
    slug: 'camping-flash-flood-emergency-scenario',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1497900304864-273dfb3aae33?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-26',
    tags: ['camping', 'safety', 'flash-flood', 'emergency', 'scenario', 'structure-6', 'intro-6'],
    content: { en: { title: 'Camping Flash Flood Emergency: What to Do When Water Rises', excerpt: 'Flash floods kill more campers than almost any other natural hazard. Recognizing warning signs and acting within minutes determines survival in canyon camping.', body: '' } },
  },
  {
    id: '415',
    slug: 'van-life-electrical-grounding-explained',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1460533893735-45cea2212645?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-01',
    tags: ['mobile-living', 'electrical', 'grounding', 'safety', 'education', 'structure-5', 'intro-4'],
    content: { en: { title: 'Electrical Grounding in Camper Vans: Why It Matters', excerpt: 'Grounding problems cause more van life headaches than undersized batteries or weak solar panels. Understanding ground paths prevents fires and ghost faults.', body: '' } },
  },
  {
    id: '416',
    slug: 'van-life-engine-failure-remote-area-scenario',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1516939884455-1445c8652f83?w=800&auto=format&fit=crop',
    publishedAt: '2025-10-16',
    tags: ['mobile-living', 'emergency', 'engine', 'breakdown', 'scenario', 'structure-6', 'intro-5'],
    content: { en: { title: 'Van Life Engine Failure in a Remote Area: A Survival Scenario', excerpt: 'Your engine dies on a mountain pass with no cell service. The decisions you make in the next two hours determine whether this becomes a story or an emergency.', body: '' } },
  },
  {
    id: '418',
    slug: 'off-grid-well-runs-dry-emergency-scenario',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-24',
    tags: ['off-grid-homes', 'water', 'well', 'emergency', 'scenario', 'structure-6', 'intro-3'],
    content: { en: { title: 'Off-Grid Well Runs Dry: An Emergency Water Scenario', excerpt: 'Your well stops producing water in the middle of summer. The emergency protocol, rationing strategy, and long-term solutions that get you through the crisis.', body: '' } },
  },
  {
    id: '419',
    slug: 'liveaboard-marine-corrosion-types-explained',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1543353071-873f17a7a088?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-28',
    tags: ['boat-living', 'corrosion', 'maintenance', 'science', 'education', 'structure-5', 'intro-1'],
    content: { en: { title: 'Liveaboard Corrosion Types: Protecting Your Boat', excerpt: 'Marine corrosion destroys boats in three distinct ways. Understanding galvanic, electrolytic, and crevice corrosion prevents damage that sinks liveaboard.', body: '' } },
  },
  {
    id: '420',
    slug: 'liveaboard-dragging-anchor-storm-scenario',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1501426026826-31c667bdf23d?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-20',
    tags: ['boat-living', 'anchoring', 'storm', 'emergency', 'scenario', 'structure-6', 'intro-2'],
    content: { en: { title: 'Liveaboard Dragging Anchor in a Storm: What to Do at 2 AM', excerpt: 'Your anchor alarm screams at 2 AM in 40-knot winds. The next ten minutes determine whether you save your boat or watch it drive onto shore. Real data.', body: '' } },
  },
  {
    id: '421',
    slug: 'how-long-does-a-camping-water-filter-last',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1620121692029-d088224ddc74?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-19',
    tags: ['camping', 'water', 'filter', 'gear', 'maintenance', 'structure-1', 'intro-1'],
    content: { en: { title: 'How Long Does a Camping Water Filter Last?', excerpt: 'Most camping water filters last between 1,000 and 100,000 gallons depending on type. Pump, gravity, squeeze, and UV lifespans compared with real cost data.', body: '' } },
  },
  {
    id: '422',
    slug: 'campsite-condensation-problem-solution',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1617083934551-ac1f1c09d4f0?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-09',
    tags: ['camping', 'tent', 'condensation', 'moisture', 'problem-solving', 'structure-2', 'intro-2'],
    content: { en: { title: 'Campsite Condensation: Why Your Tent Is Soaking Wet Inside', excerpt: 'Waking up drenched inside your tent is a ventilation problem, not a leak. Condensation causes, prevention techniques, and campsite choices that keep your.', body: '' } },
  },
  {
    id: '423',
    slug: 'how-much-solar-does-a-van-actually-need',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504609773096-104ff2c73ba4?w=800&auto=format&fit=crop',
    publishedAt: '2025-05-20',
    tags: ['mobile-living', 'solar', 'electrical', 'van-life', 'power', 'structure-1', 'intro-6'],
    content: { en: { title: 'How Much Solar Does a Van Actually Need?', excerpt: 'In this guide: daily consumption audit, panel efficiency losses, seasonal variation, and why 200W is enough for most - but not all - van dwellers. Real data.', body: '' } },
  },
  {
    id: '424',
    slug: 'van-life-rust-spreading-under-floor',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1504222490345-c075b6008014?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-04',
    tags: ['mobile-living', 'van-life', 'rust', 'maintenance', 'repair', 'structure-2', 'intro-1'],
    content: { en: { title: 'Van Life Rust Under the Floor: What to Do Now', excerpt: 'Rust under your van floor spreads faster than you think. Inspection methods, treatment options from rust converter to welding, and prevention for long-term.', body: '' } },
  },
  {
    id: '425',
    slug: 'how-deep-should-an-off-grid-well-be',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1602524811790-9e99898a3311?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-08',
    tags: ['off-grid-homes', 'water', 'well', 'drilling', 'self-sufficiency', 'structure-1', 'intro-4'],
    content: { en: { title: 'How Deep Should an Off-Grid Well Be Drilled?', excerpt: 'Your off-grid well depth depends on aquifer type, geology, and intended use. Most residential wells range from 100 to 400 feet with significant cost variation.', body: '' } },
  },
  {
    id: '426',
    slug: 'off-grid-septic-system-backing-up',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1470770841497-7b3399f2f636?w=800&auto=format&fit=crop',
    publishedAt: '2025-09-07',
    tags: ['off-grid-homes', 'septic', 'waste', 'plumbing', 'troubleshooting', 'structure-2', 'intro-5'],
    content: { en: { title: 'Off-Grid Septic Backup: Emergency Response and Fixes', excerpt: 'Septic backup off-grid depends on soil saturation, system design, and usage patterns. Emergency response steps and long-term fixes to prevent recurring.', body: '' } },
  },
  {
    id: '427',
    slug: 'how-fast-does-a-liveaboard-hull-foul',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1467803738586-46b7eb7b16a1?w=800&auto=format&fit=crop',
    publishedAt: '2026-03-24',
    tags: ['boat-living', 'hull', 'maintenance', 'fouling', 'antifouling', 'structure-1', 'intro-3'],
    content: { en: { title: 'How Fast Does a Liveaboard Hull Foul in Warm Water?', excerpt: 'Hull fouling in tropical water with spent antifouling starts within two weeks. Growth rates, bottom paint choices, and cleaning schedules that actually work.', body: '' } },
  },
  {
    id: '428',
    slug: 'liveaboard-bilge-pump-keeps-running',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1612178991541-b48cc8e92a4d?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-07',
    tags: ['boat-living', 'bilge', 'pump', 'troubleshooting', 'safety', 'structure-2', 'intro-4'],
    content: { en: { title: 'Liveaboard Bilge Pump Running: Diagnosis and Response', excerpt: 'Your bilge pump cycling every few minutes means water entering faster than it should. Diagnosing the source, emergency response, and permanent fixes for.', body: '' } },
  },
  {
    id: '429',
    slug: 'down-vs-synthetic-sleeping-bag-choice',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1602002418082-a4443e081dd1?w=800&auto=format&fit=crop',
    publishedAt: '2025-03-09',
    tags: ['structure-3', 'intro-3'],
    content: { en: { title: 'Down vs Synthetic Sleeping Bag: Making the Choice', excerpt: 'Choosing between down and synthetic fill depends on climate, budget, and maintenance tolerance. Warmth-to-weight, wet performance, and durability compared.', body: '' } },
  },
  {
    id: '430',
    slug: 'how-to-hang-a-bear-bag-step-by-step',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1605106702734-205df224ecce?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-04',
    tags: ['structure-4', 'intro-4'],
    content: { en: { title: 'How to Hang a Bear Bag: A Step-by-Step Guide That Actually Works', excerpt: 'Most bear hangs fail because of poor branch selection or inadequate rope technique. This step-by-step method keeps your food safe and bears wild. Real data.', body: '' } },
  },
  {
    id: '431',
    slug: 'diesel-vs-gas-heater-van-life-choice',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1615220368123-51a9e1f47b19?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-03',
    updatedAt: '2026-05-20',
    tags: ['structure-3', 'intro-2'],
    content: { en: { title: 'Diesel vs Gas Heater for Van Life: Which Is Better?', excerpt: 'Choosing between diesel and propane heating for your van depends on your existing fuel system, altitude habits, and tolerance for installation complexity.', body: '' } },
  },
  {
    id: '432',
    slug: 'how-to-install-van-roof-fan-step-by-step',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1485470733090-0aae1788d668?w=800&auto=format&fit=crop',
    publishedAt: '2025-06-22',
    tags: ['structure-4', 'intro-3'],
    content: { en: { title: 'Roof Fan Installation for Your Camper Van', excerpt: 'Cutting a hole in your van roof is terrifying until you understand the process. Fan selection, marking, cutting, sealing, and wiring explained step by step.', body: '' } },
  },
  {
    id: '433',
    slug: 'composting-vs-incinerating-toilet-off-grid',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1464146072230-91cabc968266?w=800&auto=format&fit=crop',
    publishedAt: '2025-04-01',
    tags: ['structure-3', 'intro-6'],
    content: { en: { title: 'Composting vs Incinerating Toilet Off-Grid', excerpt: 'Both composting and incinerating toilets eliminate septic system needs, but they serve different lifestyles and budgets. An honest comparison of both systems.', body: '' } },
  },
  {
    id: '435',
    slug: 'monohull-vs-catamaran-liveaboard-choice',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1515516089376-88db1e26e9c0?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-10',
    tags: ['structure-3', 'intro-5'],
    content: { en: { title: 'Monohull vs Catamaran: Which Hull Fits Your Plans?', excerpt: 'The monohull vs catamaran decision shapes your marina options, ocean capability, living space, and budget for years. A practical comparison guide.', body: '' } },
  },
  {
    id: '436',
    slug: 'how-to-install-marine-solar-panels-step-by-step',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?w=800&auto=format&fit=crop',
    publishedAt: '2025-07-22',
    tags: ['structure-4', 'intro-6'],
    content: { en: { title: 'How to Install Marine Solar Panels: Step-by-Step Guide', excerpt: 'Installing solar on a boat involves mounting decisions, marine-grade wiring, and charge controller selection that differ significantly from land-based.', body: '' } },
  },
  {
    id: '437',
    slug: 'van-life-financial-planning-tools-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&auto=format&fit=crop',
    publishedAt: '2025-02-03',
    tags: ['van-life', 'budget', 'financial-planning', 'tools', 'structure-5', 'intro-5'],
    bookRecommendation: { title: 'The Simple Path to Wealth', author: 'JL Collins', description: 'Collins strips financial planning down to what actually matters - a refreshing read for anyone building an unconventional life on a lean budget.' },
    content: { en: { title: 'How to Plan Your Van Life Budget Using Real Numbers', excerpt: 'Most van life budgets fail because they ignore irregular costs. A planning framework built on actual expenses changes everything.', body: '' } },
  },
  {
    id: '438',
    slug: 'off-grid-cost-planning-tools-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&auto=format&fit=crop',
    publishedAt: '2026-01-05',
    tags: ['off-grid', 'cost-planning', 'financial', 'tools', 'structure-2', 'intro-4'],
    bookRecommendation: { title: 'Your Money or Your Life', author: 'Vicki Robin', description: 'Robin reframes money as life energy spent - exactly the mindset shift needed before committing to an off-grid property investment.' },
    content: { en: { title: 'Planning Your Off-Grid Finances: Numbers Most People Get Wrong', excerpt: 'Off-grid cost estimates routinely miss 30-40% of actual expenses. Understanding where the gaps hide prevents painful financial surprises.', body: '' } },
  },
  {
    id: '439',
    slug: 'boat-living-budget-planning-tools-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1586953208270-767889fa9b0f?w=800&auto=format&fit=crop',
    publishedAt: '2025-11-24',
    tags: ['boat-living', 'budget', 'financial-planning', 'tools', 'structure-1', 'intro-1'],
    bookRecommendation: { title: 'Voyaging on a Small Income', author: 'Annie Hill', description: 'Hill sailed the world on almost nothing - her practical financial approach to cruising life is still the gold standard decades later.' },
    content: { en: { title: 'Boat Living Budget Planning: A Financial Reality Check', excerpt: 'Living aboard costs between $1,200 and $3,500 monthly depending on marina vs anchor. Breaking down where every dollar goes reveals surprises.', body: '' } },
  },
  {
    id: '440',
    slug: 'camping-gear-budget-planning-tools-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1525811902-f2342640856e?w=800&auto=format&fit=crop',
    publishedAt: '2026-04-12',
    tags: ['camping', 'gear', 'budget', 'equipment', 'tools', 'structure-6', 'intro-2'],
    bookRecommendation: { title: 'Ultralight Backpackin Tips', author: 'Mike Clelland', description: 'Clelland proves that spending less on gear often means carrying less weight - a counterintuitive lesson most campers learn the expensive way.' },
    content: { en: { title: 'Camping Gear Budget Planning: Smart Spending at Every Level', excerpt: 'Spending more on camping gear does not always mean better performance. A structured budget approach prevents the most common purchasing mistakes.', body: '' } },
  },
  {
    id: '441',
    slug: 'off-grid-energy-systems-complete-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&auto=format&fit=crop',
    publishedAt: '2025-02-04',
    updatedAt: '2026-07-22',
    tags: ['off-grid-homes', 'solar', 'battery', 'wind', 'energy', 'electrical', 'sub-hub', 'hub', 'structure-1', 'intro-1'],
    bookRecommendation: { title: 'Off Grid Solar', author: 'Joseph P. O\'Connor', description: 'O\'Connor walks through real residential off-grid solar design with the kind of system-thinking detail most YouTube tutorials skip entirely.' },
    content: { en: { title: 'Off-Grid Energy Systems: The Complete Guide', excerpt: 'A complete walk-through of designing an off-grid power system - solar arrays, battery banks, charge controllers, inverters, and when wind makes sense.', body: '' } },
  },
  {
    id: '442',
    slug: 'off-grid-water-systems-complete-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1543393470-b2da648e088f?w=1200&auto=format&fit=crop',
    publishedAt: '2025-09-20',
    updatedAt: '2026-04-27',
    tags: ['off-grid-homes', 'water', 'well', 'rainwater', 'greywater', 'septic', 'plumbing', 'sub-hub', 'hub', 'structure-3', 'intro-3'],
    bookRecommendation: { title: 'The Home Water Supply', author: 'Stu Campbell', description: 'Campbell\'s book remains the practical reference for understanding wells, springs, and gravity-fed systems decades after publication.' },
    content: { en: { title: 'Off-Grid Water Systems: The Complete Guide', excerpt: 'Wells, rainwater harvesting, greywater recycling, hot water, and waste handling - how to design a complete off-grid water cycle that actually works.', body: '' } },
  },
  {
    id: '443',
    slug: 'off-grid-heating-climate-complete-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8?w=1200&auto=format&fit=crop',
    publishedAt: '2025-04-20',
    updatedAt: '2026-04-27',
    tags: ['off-grid-homes', 'heating', 'wood-stove', 'insulation', 'climate', 'cooling', 'sub-hub', 'hub', 'structure-4', 'intro-4'],
    bookRecommendation: { title: 'The Woodburner\'s Companion', author: 'Dirk Thomas', description: 'Thomas covers wood heat from forest to firebox with a directness that makes the entire seasonal cycle understandable for newcomers.' },
    content: { en: { title: 'Off-Grid Heating and Climate: The Complete Guide', excerpt: 'Wood stoves, insulation strategy, passive solar design, and seasonal rhythms - a complete approach to off-grid climate control without grid electricity.', body: '' } },
  },
  {
    id: '444',
    slug: 'off-grid-food-self-sufficiency-complete-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1200&auto=format&fit=crop',
    publishedAt: '2026-01-31',
    updatedAt: '2026-04-27',
    tags: ['off-grid-homes', 'food', 'gardening', 'preservation', 'livestock', 'root-cellar', 'sub-hub', 'hub', 'structure-5', 'intro-5'],
    bookRecommendation: { title: 'The Resilient Gardener', author: 'Carol Deppe', description: 'Deppe writes about food self-reliance with the rare honesty of someone who has actually fed herself from her own land for decades.' },
    content: { en: { title: 'Off-Grid Food Self-Sufficiency: Complete Guide', excerpt: 'Gardens, livestock, root cellars, and preservation methods - how to build a food system that carries an off-grid household through every season.', body: '' } },
  },
  {
    id: '445',
    slug: 'off-grid-solar-panel-sizing-calculator-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1200&auto=format&fit=crop',
    publishedAt: '2025-12-21',
    updatedAt: '2026-07-22',
    tags: ['off-grid-homes', 'solar', 'sizing', 'energy', 'calculator', 'structure-1', 'intro-1'],
    bookRecommendation: { title: 'Mobile Solar Power Made Easy', author: 'William Errol Prowse IV', description: 'Prowse explains real-world solar sizing with the kind of arithmetic clarity most installers skip when quoting jobs.' },
    content: { en: { title: 'Off-Grid Solar Panel Sizing: A Practical Calculator Guide', excerpt: 'How to translate your daily watt-hour load into the right number of solar panels for your latitude, season, and battery bank.', body: '' } },
  },
  {
    id: '446',
    slug: 'off-grid-battery-bank-lithium-vs-lead-acid',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1200&auto=format&fit=crop',
    publishedAt: '2025-12-02',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'battery', 'lithium', 'lead-acid', 'energy', 'structure-3', 'intro-5'],
    bookRecommendation: { title: 'Off Grid Solar', author: 'Joseph P. O\'Connor', description: 'O\'Connor walks through battery chemistry trade-offs with the patience of someone who has replaced too many flooded banks.' },
    content: { en: { title: 'Off-Grid Battery Bank: Lithium vs Lead-Acid Decision Guide', excerpt: 'Cost per usable kWh, lifespan, charging behavior, and climate tolerance - how to choose the right chemistry for your off-grid home.', body: '' } },
  },
  {
    id: '447',
    slug: 'off-grid-inverter-sizing-and-selection-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=1200&auto=format&fit=crop',
    publishedAt: '2025-06-29',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'inverter', 'electrical', 'energy', 'sizing', 'structure-4', 'intro-6'],
    bookRecommendation: { title: 'Off Grid Solar', author: 'Joseph P. O\'Connor', description: 'O\'Connor treats inverter selection as a load-profile problem, which is exactly how most installers should approach it.' },
    content: { en: { title: 'Off-Grid Inverter Sizing and Selection: A Step-by-Step Guide', excerpt: 'Continuous load, surge capacity, pure sine vs modified sine, and 12V vs 24V vs 48V - how to size and select an inverter that actually fits your home.', body: '' } },
  },
  {
    id: '448',
    slug: 'off-grid-winter-solar-production-strategies',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1418985991508-e47386d96a71?w=1200&auto=format&fit=crop',
    publishedAt: '2025-06-19',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'solar', 'winter', 'energy', 'climate', 'structure-2', 'intro-4'],
    bookRecommendation: { title: 'Mobile Solar Power Made Easy', author: 'William Errol Prowse IV', description: 'Prowse covers the seasonal arithmetic that exposes why summer-sized arrays usually fail by January.' },
    content: { en: { title: 'Off-Grid Winter Solar Production: Strategies That Actually Work', excerpt: 'Why most off-grid solar arrays underperform from November to February - and the tilt, sizing, and load adjustments that fix it.', body: '' } },
  },
  {
    id: '449',
    slug: 'off-grid-rainwater-storage-tank-sizing-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1519455953755-af066f52f1a6?w=1200&auto=format&fit=crop',
    publishedAt: '2025-05-21',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'water', 'rainwater', 'storage', 'sizing', 'structure-1', 'intro-1'],
    bookRecommendation: { title: 'The Home Water Supply', author: 'Stu Campbell', description: 'Campbell\'s sizing chapters remain the cleanest explanation of catchment, storage, and dry-season buffering in print.' },
    content: { en: { title: 'Off-Grid Rainwater Storage Tank Sizing: A Practical Guide', excerpt: 'How to calculate roof catchment, dry-season demand, and the right tank volume for your climate without overbuilding the system or running short in summer.', body: '' } },
  },
  {
    id: '450',
    slug: 'off-grid-well-pump-selection-and-power-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1582736317402-1d3a3a18cd6b?w=1200&auto=format&fit=crop',
    publishedAt: '2025-07-13',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'water', 'well', 'pump', 'energy', 'structure-3', 'intro-5'],
    bookRecommendation: { title: 'The Home Water Supply', author: 'Stu Campbell', description: 'Campbell explains pump curves and lift calculations in language that finally makes selection feel obvious instead of intimidating.' },
    content: { en: { title: 'Off-Grid Well Pump Selection: DC, AC, and Solar Direct Compared', excerpt: 'Submersible vs jet pumps, DC vs AC, and how solar-direct systems eliminate the battery bank from your water budget entirely.', body: '' } },
  },
  {
    id: '451',
    slug: 'off-grid-water-filtration-and-purification-systems',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=1200&auto=format&fit=crop',
    publishedAt: '2026-02-25',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'water', 'filtration', 'purification', 'health', 'structure-5', 'intro-3'],
    bookRecommendation: { title: 'The Home Water Supply', author: 'Stu Campbell', description: 'Campbell separates filtration from purification with the kind of clarity that prevents most off-grid water mistakes.' },
    content: { en: { title: 'Off-Grid Water Filtration and Purification Explained', excerpt: 'Sediment, carbon, UV, reverse osmosis, and ceramic filtration - what each removes, what each misses, and how to layer them correctly.', body: '' } },
  },
  {
    id: '452',
    slug: 'off-grid-frozen-pipe-prevention-cold-climate',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1483982258113-b15532f5c1eb?w=1200&auto=format&fit=crop',
    publishedAt: '2025-08-23',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'water', 'winter', 'plumbing', 'cold-climate', 'structure-2', 'intro-4'],
    bookRecommendation: { title: 'The Woodburner\'s Companion', author: 'Dirk Thomas', description: 'Thomas\'s thermal-envelope thinking translates directly to keeping water lines above freezing without burning extra fuel.' },
    content: { en: { title: 'Off-Grid Frozen Pipe Prevention: Cold-Climate Plumbing That Holds', excerpt: 'Why off-grid pipes freeze even in well-insulated homes - and the layout, drain-down, and heat-trace strategies that prevent winter failure.', body: '' } },
  },
  {
    id: '453',
    slug: 'off-grid-wood-stove-sizing-and-placement-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1545071677-94a9f0a01af3?w=1200&auto=format&fit=crop',
    publishedAt: '2025-12-01',
    updatedAt: '2026-07-22',
    tags: ['off-grid-homes', 'heating', 'wood-stove', 'sizing', 'climate', 'structure-4', 'intro-6'],
    bookRecommendation: { title: 'The Woodburner\'s Companion', author: 'Dirk Thomas', description: 'Thomas explains stove sizing as a thermal-mass and airflow problem rather than a square-footage rating, which is finally the right framing.' },
    content: { en: { title: 'Off-Grid Wood Stove Sizing and Placement: A Step-by-Step Guide', excerpt: 'BTU calculations, room geometry, chimney routing, and clearance rules - how to size and place a wood stove that actually heats the house.', body: '' } },
  },
  {
    id: '454',
    slug: 'off-grid-cabin-insulation-r-value-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1604769311708-31e6e1d3b8ec?w=1200&auto=format&fit=crop',
    publishedAt: '2025-03-11',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'insulation', 'r-value', 'building', 'climate', 'structure-1', 'intro-1'],
    bookRecommendation: { title: 'The Woodburner\'s Companion', author: 'Dirk Thomas', description: 'Thomas keeps returning to insulation because the cheapest cord of wood is the one you never burn.' },
    content: { en: { title: 'Off-Grid Cabin Insulation: R-Value Targets by Climate Zone', excerpt: 'How much insulation your walls, roof, and floor actually need - and where the diminishing returns kick in for off-grid budgets.', body: '' } },
  },
  {
    id: '455',
    slug: 'passive-solar-design-for-off-grid-homes',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=1200&auto=format&fit=crop',
    publishedAt: '2026-02-03',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'passive-solar', 'design', 'climate', 'building', 'structure-5', 'intro-3'],
    bookRecommendation: { title: 'The Passive Solar House', author: 'James Kachadorian', description: 'Kachadorian\'s thermal-mass framework still produces homes that need almost no winter heating decades after the book was written.' },
    content: { en: { title: 'Passive Solar Design for Off-Grid Homes: How It Actually Works', excerpt: 'Glazing ratios, thermal mass, overhang geometry, and orientation - the four levers that turn a house into a year-round climate machine.', body: '' } },
  },
  {
    id: '456',
    slug: 'off-grid-summer-cooling-without-air-conditioning',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1499002238440-d264edd596ec?w=1200&auto=format&fit=crop',
    publishedAt: '2025-09-28',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'cooling', 'summer', 'climate', 'ventilation', 'structure-3', 'intro-5'],
    bookRecommendation: { title: 'The Passive Solar House', author: 'James Kachadorian', description: 'Kachadorian treats summer comfort as the same physics problem as winter heating, which is exactly how off-grid homes need to be designed.' },
    content: { en: { title: 'Off-Grid Summer Cooling Without Air Conditioning', excerpt: 'Cross-ventilation, thermal mass, shade, and evaporative cooling - which strategies work in which climates, and where mini-splits make sense.', body: '' } },
  },
  {
    id: '457',
    slug: 'off-grid-vegetable-garden-planning-first-year',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=1200&auto=format&fit=crop',
    publishedAt: '2026-02-11',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'food', 'gardening', 'planning', 'first-year', 'structure-4', 'intro-6'],
    bookRecommendation: { title: 'The Resilient Gardener', author: 'Carol Deppe', description: 'Deppe is honest about how little a first-year garden actually produces, which is exactly the perspective most beginners need.' },
    content: { en: { title: 'Off-Grid Vegetable Garden Planning: First-Year Guide', excerpt: 'Bed sizing, crop selection, soil building, and realistic yield expectations for the first year of growing your own food off-grid.', body: '' } },
  },
  {
    id: '458',
    slug: 'off-grid-chicken-keeping-cost-and-yield-breakdown',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=1200&auto=format&fit=crop',
    publishedAt: '2025-12-24',
    updatedAt: '2026-07-22',
    tags: ['off-grid-homes', 'food', 'chickens', 'livestock', 'cost', 'structure-1', 'intro-1'],
    bookRecommendation: { title: 'Storey\'s Guide to Raising Chickens', author: 'Gail Damerow', description: 'Damerow remains the reference because she covers feed economics and predator pressure with equal seriousness.' },
    content: { en: { title: 'Off-Grid Chicken Keeping: Real Cost and Yield Breakdown', excerpt: 'What backyard chickens actually cost per egg when you account for feed, infrastructure, predators, and the years between productive birds.', body: '' } },
  },
  {
    id: '459',
    slug: 'off-grid-canning-and-preservation-equipment-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1597362925123-77861d3fbac7?w=1200&auto=format&fit=crop',
    publishedAt: '2025-09-06',
    updatedAt: '2026-07-22',
    tags: ['off-grid-homes', 'food', 'canning', 'preservation', 'equipment', 'structure-3', 'intro-5'],
    bookRecommendation: { title: 'The Resilient Gardener', author: 'Carol Deppe', description: 'Deppe pairs growing strategy with preservation reality in a way most gardening books refuse to do.' },
    content: { en: { title: 'Off-Grid Canning and Preservation Equipment Guide', excerpt: 'Pressure canners, water-bath kettles, dehydrators, and fermentation crocks - which equipment earns its place in an off-grid kitchen.', body: '' } },
  },
  {
    id: '460',
    slug: 'off-grid-root-cellar-construction-step-by-step',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=1200&auto=format&fit=crop',
    publishedAt: '2025-06-16',
    updatedAt: '2026-04-29',
    tags: ['off-grid-homes', 'food', 'root-cellar', 'storage', 'construction', 'structure-4', 'intro-2'],
    bookRecommendation: { title: 'Root Cellaring', author: 'Mike and Nancy Bubel', description: 'The Bubels\' book remains the standard because it treats root cellaring as a building-physics problem first and a food-storage problem second.' },
    content: { en: { title: 'Off-Grid Root Cellar Construction: A Step-by-Step Build Guide', excerpt: 'Excavation, drainage, ventilation, and shelving - how to build a root cellar that holds 0-4C and 90% humidity without any electricity.', body: '' } },
  },
  {
    id: '461',
    slug: 'van-life-cost-europe-country-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-04',
    updatedAt: '2026-05-04',
    tags: ['van-life', 'europe', 'cost', 'budget', 'fuel', 'tolls', 'planning', 'mobile-living', 'structure-3', 'intro-5'],
    bookRecommendation: { title: 'Vagabonding', author: 'Rolf Potts', description: 'Potts treats long-term travel economics as a mindset problem before a money problem - useful framing before you compare bills across borders.' },
    content: { en: { title: 'Van Life Cost in Europe: A Country-by-Country Comparison', excerpt: 'Fuel, tolls, vignettes, gas refills, and overnight parking - what van life actually costs across Portugal, Spain, France, Germany, Italy, and the Nordics.', body: '' } },
  },
  {
    id: '462',
    slug: 'van-life-vehicle-registration-europe',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1597007030739-6d2e7172ee72?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-04',
    updatedAt: '2026-05-04',
    tags: ['van-life', 'europe', 'registration', 'inspection', 'tuv', 'itv', 'legal', 'mobile-living', 'structure-4', 'intro-4'],
    bookRecommendation: { title: 'Shop Class as Soulcraft', author: 'Matthew B. Crawford', description: 'Crawford\'s argument for the moral weight of mechanical work matters when an inspector has your van on a lift and a checklist in hand.' },
    content: { en: { title: 'Van Registration in Europe: TUV, ITV, and Converted Vehicles', excerpt: 'Where converted vans actually pass inspection, what each country demands, and the paperwork sequence most builders learn the expensive way.', body: '' } },
  },
  {
    id: '463',
    slug: 'van-life-usa-state-cost-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['van-life', 'usa', 'cost', 'budget', 'fuel', 'domicile', 'planning', 'mobile-living', 'structure-3', 'intro-1'],
    bookRecommendation: { title: 'Nomadland', author: 'Jessica Bruder', description: 'Bruder\'s reporting on workamping America gives the financial picture of mobile life its real human edges, beyond any spreadsheet.' },
    content: { en: { title: 'Van Life Cost in the USA: A State-by-State Comparison', excerpt: 'Fuel, tolls, registration, and camping fees vary wildly across the US - what van life actually costs in California, Arizona, Texas, the Dakotas, and beyond.', body: '' } },
  },
  {
    id: '464',
    slug: 'boondocking-blm-public-lands-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1533873984035-25970ab07461?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['van-life', 'usa', 'boondocking', 'blm', 'public-lands', 'free-camping', 'mobile-living', 'structure-4', 'intro-2'],
    bookRecommendation: { title: 'Desert Solitaire', author: 'Edward Abbey', description: 'Abbey wrote the philosophy of public-land solitude before BLM became an acronym and a dispersed-camping pin on iOverlander.' },
    content: { en: { title: 'Boondocking on BLM and Public Lands: A Practical Guide', excerpt: 'Where dispersed camping is legal, the 14-day rule, finding water, and the etiquette that keeps these lands open to the next van that pulls in.', body: '' } },
  },
  {
    id: '465',
    slug: 'vanlife-canada-cross-border-realities',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['van-life', 'canada', 'usa', 'border', 'winter', 'crown-land', 'mobile-living', 'structure-2', 'intro-4'],
    bookRecommendation: { title: 'The Lonely Land', author: 'Sigurd F. Olson', description: 'Olson wrote the spiritual case for the Canadian wilderness that still shapes how van-lifers approach Crown Land today.' },
    content: { en: { title: 'Van Life Across the US-Canada Border: What Actually Works', excerpt: 'Border crossings with a converted van, insurance reality, Crown Land rules, and the winter migration south that defines Canadian van life.', body: '' } },
  },
  {
    id: '466',
    slug: 'liveaboard-marina-cost-east-vs-west-coast-usa',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['boat-living', 'usa', 'marina', 'cost', 'liveaboard', 'east-coast', 'west-coast', 'structure-3', 'intro-5'],
    bookRecommendation: { title: 'An Embarrassment of Mangoes', author: 'Ann Vanderhoof', description: 'Vanderhoof\'s account of a year afloat balances cost reality with the harder-to-quantify return that keeps people on boats.' },
    content: { en: { title: 'Liveaboard Marina Cost: US East Coast vs West Coast', excerpt: 'Slip fees, hurricane season, Pacific Northwest rain, Great Lakes winter haul-out - what coastal liveaboard life actually costs in each US region.', body: '' } },
  },
  {
    id: '467',
    slug: 'off-grid-land-cost-usa-realistic-2026',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['off-grid-homes', 'usa', 'land', 'cost', 'water-rights', 'septic', 'planning', 'structure-1', 'intro-1'],
    bookRecommendation: { title: 'The Good Life', author: 'Helen and Scott Nearing', description: 'The Nearings made the financial and philosophical case for cheap rural land long before homestead Instagram, and the land-shopping math holds up.' },
    content: { en: { title: 'Off-Grid Land Cost in the USA: A Realistic 2026 Breakdown', excerpt: 'Real per-acre prices in Arizona, New Mexico, Colorado, Tennessee, and Maine - plus water rights, septic permits, and the hidden costs of rural land.', body: '' } },
  },
  {
    id: '468',
    slug: 'off-grid-canada-northern-realities',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1454942901704-3c44c11b2ad1?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['off-grid-homes', 'canada', 'crown-land', 'winter', 'isolation', 'energy', 'structure-6', 'intro-2'],
    bookRecommendation: { title: 'The Curve of Time', author: 'M. Wylie Blanchet', description: 'Blanchet captured the cadence of remote Canadian living in a way that still shapes how off-grid northerners describe their own years.' },
    content: { en: { title: 'Off-Grid in Northern Canada: The Realities Most Guides Skip', excerpt: 'Crown Land leasing rules, minus-thirty winter energy demand, water systems that survive freeze cycles, and the isolation math nobody quantifies.', body: '' } },
  },
  {
    id: '469',
    slug: 'national-parks-vs-state-parks-camping-usa',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1455763916899-e8b50eca9967?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['camping', 'usa', 'national-parks', 'state-parks', 'reservations', 'planning', 'structure-5', 'intro-3'],
    bookRecommendation: { title: 'The National Parks: America\'s Best Idea', author: 'Dayton Duncan', description: 'Duncan\'s history clarifies why the reservation system feels broken - it was designed for a different America at a different scale.' },
    content: { en: { title: 'National Parks vs State Parks for Camping in the USA', excerpt: 'Reservation systems, real costs, dispersed alternatives, and why state parks often beat the famous names for actual camping experience.', body: '' } },
  },
  {
    id: '470',
    slug: 'winter-camping-canada-rockies-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1483347756197-71ef80e95f73?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-05',
    updatedAt: '2026-05-05',
    tags: ['camping', 'canada', 'winter', 'rockies', 'cold-weather', 'safety', 'structure-4', 'intro-4'],
    bookRecommendation: { title: 'Winter: An Ecological Handbook', author: 'James C. Halfpenny', description: 'Halfpenny treats winter as a system to read rather than a season to survive - the orientation that keeps Rockies camping safe.' },
    content: { en: { title: 'Winter Camping in the Canadian Rockies: A Practical Guide', excerpt: 'Temperature gear thresholds, avalanche awareness, parks that allow winter use, and the routines that make minus-thirty actually workable.', body: '' } },
  },
{
    id: '471',
    slug: 'van-life-patagonia-route-guide',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1531206715517-5c0ba140b2b8?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['van-life', 'patagonia', 'argentina', 'chile', 'south-america', 'route-planning', 'structure-4', 'intro-2'],
    bookRecommendation: { title: 'In Patagonia', author: 'Bruce Chatwin', description: 'Chatwin\'s classic still maps the texture of the place better than any modern guide - the wind, the distances, the silence between towns.' },
    content: { en: { title: 'Van Life in Patagonia: Route, Wind, and Border Realities', excerpt: 'Wind dictates the route, fuel range determines the schedule, and three border crossings shape the calendar in a Bariloche to Ushuaia plan that holds up.', body: '' } },
  },
  {
    id: '472',
    slug: 'van-life-argentina-chile-border-crossings',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['van-life', 'argentina', 'chile', 'border-crossings', 'paperwork', 'south-america', 'structure-2', 'intro-4'],
    bookRecommendation: { title: 'The Old Patagonian Express', author: 'Paul Theroux', description: 'Theroux\'s account of crossing borders by rail still teaches the slower, paperwork-aware mindset that road travel in the region demands.' },
    content: { en: { title: 'Argentina-Chile Border Crossings for Van Lifers', excerpt: 'SAG inspections, Temporary Vehicle Import paperwork, and the timing decisions that turn a six-hour border day into a ninety-minute one across the Andes.', body: '' } },
  },
  {
    id: '473',
    slug: 'van-life-brazil-coastal-route-realities',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['van-life', 'brazil', 'south-america', 'coastal-route', 'tolls', 'security', 'structure-6', 'intro-3'],
    bookRecommendation: { title: 'Brazil on the Rise', author: 'Larry Rohter', description: 'Rohter\'s reporting frames the country at the scale van-lifers actually encounter - regional, contradictory, and far larger than maps suggest.' },
    content: { en: { title: 'Van Life on the Brazilian Coast: What to Expect', excerpt: 'Toll roads, fuel labels, police checkpoints, and the parking culture - what a 3,500 km BR-101 coastal transit looks like for first-time foreign van-lifers.', body: '' } },
  },
  {
    id: '474',
    slug: 'liveaboard-brazil-uruguay-atlantic-coast',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['boat-living', 'liveaboard', 'brazil', 'uruguay', 'south-atlantic', 'cruising', 'structure-1', 'intro-5'],
    bookRecommendation: { title: 'The South American Handbook', author: 'Ben Box', description: 'The reference still used by working cruisers along the South Atlantic - the port, paperwork, and provisioning detail that web guides skip.' },
    content: { en: { title: 'Liveaboard Cruising the Brazil-Uruguay Atlantic Coast', excerpt: 'Marina costs, seasonal patterns, fetch-driven sea state, and the customs realities of cruising 4,800 km from Punta del Este to Recife and back year-round.', body: '' } },
  },
  {
    id: '475',
    slug: 'camping-patagonia-wind-cold-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['camping', 'patagonia', 'wind', 'cold-weather', 'four-season-tent', 'safety', 'structure-2', 'intro-2'],
    bookRecommendation: { title: 'Mountaineering: The Freedom of the Hills', author: 'The Mountaineers', description: 'The cold-weather and weather-judgment chapters apply directly to Patagonian shoulder-season camping - dated in places, still authoritative.' },
    content: { en: { title: 'Camping in Patagonia: Wind, Cold, and Tent Survival', excerpt: 'Why three-season tents fail here, the four-season setups that actually hold up, and the siting decisions that prevent the 2 AM tent-collapse disaster.', body: '' } },
  },
  {
    id: '476',
    slug: 'off-grid-colombia-andes-realities',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518002171953-a080ee817e1f?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['off-grid', 'colombia', 'andes', 'south-america', 'eternal-spring', 'finca', 'structure-5', 'intro-3'],
    bookRecommendation: { title: 'One River', author: 'Wade Davis', description: 'Davis\'s account of the Colombian highlands gives ecological and cultural context that off-grid buyers need before committing to a finca.' },
    content: { en: { title: 'Off-Grid in the Colombian Andes: The Real Picture', excerpt: 'Eternal spring climate, abundant rainfall, $3,000-12,000 per hectare land, and the road, security, and visa realities most foreign buyers underestimate.', body: '' } },
  },
  {
    id: '477',
    slug: 'pan-american-highway-vanlife-overview',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['van-life', 'pan-american-highway', 'south-america', 'central-america', 'long-haul', 'route-planning', 'structure-5', 'intro-6'],
    bookRecommendation: { title: 'Jupiter\'s Travels', author: 'Ted Simon', description: 'Simon\'s around-the-world ride remains the canonical text on slow overland travel - the mindset that the Pan-American actually requires.' },
    content: { en: { title: 'The Pan-American Highway for Van Lifers: Overview', excerpt: 'Five segments, fourteen borders, the Darien Gap shipping reality, and the eighteen to thirty-six month schedule that nearly every traveler underestimates.', body: '' } },
  },
  {
    id: '478',
    slug: 'off-grid-ecuador-cloud-forest-living',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1580130544577-e7c8b6b3f8b1?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['off-grid', 'ecuador', 'andes', 'cloud-forest', 'south-america', 'eternal-spring', 'structure-1', 'intro-2'],
    bookRecommendation: { title: 'Savages', author: 'Joe Kane', description: 'Kane\'s reporting on the Ecuadorian Amazon frames the country\'s environmental and cultural complexity in ways that any prospective resident should read.' },
    content: { en: { title: 'Off-Grid in Ecuador Cloud Forest: The Real Picture', excerpt: 'Year-round 18-22C climate, 2,000-4,500 mm rainfall, $4,000-15,000 per hectare land, and the cloud-cover and visa realities most foreign buyers underestimate.', body: '' } },
  },
  {
    id: '479',
    slug: 'off-grid-peru-sacred-valley-realities',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['off-grid', 'peru', 'sacred-valley', 'andes', 'high-altitude', 'cold-weather', 'structure-6', 'intro-5'],
    bookRecommendation: { title: 'Turn Right at Machu Picchu', author: 'Mark Adams', description: 'Adams\'s account of retracing Hiram Bingham\'s route gives Sacred Valley elevation context that no real-estate listing captures.' },
    content: { en: { title: 'Off-Grid in the Peruvian Sacred Valley at Altitude', excerpt: 'Building for cold-weather at 3,100 meters, the solar boost from thinner atmosphere, water freeze protection, and the cooking realities at altitude here.', body: '' } },
  },
  {
    id: '480',
    slug: 'camping-atacama-desert-high-altitude',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['camping', 'atacama', 'chile', 'high-altitude', 'desert', 'cold-weather', 'structure-4', 'intro-4'],
    bookRecommendation: { title: 'Desert Solitaire', author: 'Edward Abbey', description: 'Abbey on the American desert frames the mental discipline that high-altitude desert camping rewards more than equipment choices ever do.' },
    content: { en: { title: 'Camping the Atacama Desert at High Altitude', excerpt: 'UV index 11-15, 30-degree diurnal swings, altitude acclimatization protocols, and the gear strategy that survives both the day and the night in the desert.', body: '' } },
  },
  {
    id: '481',
    slug: 'camping-bolivia-altiplano-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1531065208531-4036c0dba3ca?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['camping', 'bolivia', 'altiplano', 'high-altitude', 'salar', 'cold-weather', 'structure-3', 'intro-3'],
    bookRecommendation: { title: 'Marching Powder', author: 'Rusty Young', description: 'Young\'s account of life in La Paz frames the Bolivian context that any altiplano camper benefits from understanding before arrival.' },
    content: { en: { title: 'Camping the Bolivian Altiplano: Three Trip Choices', excerpt: 'Salar de Uyuni, Lake Titicaca, or Sajama and Lipez - each altiplano trip type has different gear demands and acclimatization realities to weigh first.', body: '' } },
  },
  {
    id: '482',
    slug: 'van-life-bolivia-paraguay-budget-route',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1551522435-a13afa10f103?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['van-life', 'bolivia', 'paraguay', 'south-america', 'budget-travel', 'overland', 'structure-3', 'intro-1'],
    bookRecommendation: { title: 'The Motorcycle Diaries', author: 'Ernesto Che Guevara', description: 'Guevara\'s overland journal across the same regions frames the cultural friction and the rural reality that every budget overlander still encounters.' },
    content: { en: { title: 'Van Life in Bolivia and Paraguay: The Budget Route', excerpt: 'A 25-45 dollar daily budget, the 700 km Trans-Chaco crossing, three trip-type decisions, and the mechanical preparation that determines if the route works.', body: '' } },
  },
  {
    id: '483',
    slug: 'liveaboard-caribbean-colombia-coast',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1583120816916-4e7d2bb1de46?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['boat-living', 'liveaboard', 'colombia', 'caribbean', 'cartagena', 'cruising', 'structure-6', 'intro-2'],
    bookRecommendation: { title: 'One Hundred Years of Solitude', author: 'Gabriel Garcia Marquez', description: 'The novel set in coastal Colombia is the cultural orientation that no cruiser arriving in Cartagena should skip - context the chart plotter cannot show.' },
    content: { en: { title: 'Liveaboard Cruising the Caribbean Coast of Colombia', excerpt: 'Cartagena marina rates, Christmas trade winds at 35 knots, the Rosario archipelago anchorages, and what Colombian clearance paperwork actually demands.', body: '' } },
  },
  {
    id: '484',
    slug: 'south-america-vs-central-america-nomad-comparison',
    category: 'mobile-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-06',
    updatedAt: '2026-05-06',
    tags: ['van-life', 'south-america', 'central-america', 'pan-american', 'comparison', 'route-planning', 'structure-3', 'intro-5'],
    bookRecommendation: { title: 'Travels with Charley', author: 'John Steinbeck', description: 'Steinbeck on long-haul road travel still frames the choice between depth and breadth that every Latin America overlander eventually faces.' },
    content: { en: { title: 'South America vs Central America for Van Life Comparison', excerpt: 'Three options - Central focus, South focus, or full Pan-American - with cost and time data to choose the trip that matches your actual constraints honestly.', body: '' } },
  },
  {
    id: '485',
    slug: 'off-grid-greywater-reuse-systems-design-guide',
    category: 'off-grid-homes' as Article['category'],
    image: 'https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-22',
    updatedAt: '2026-05-22',
    tags: ['off-grid', 'greywater', 'water-reuse', 'irrigation', 'permaculture', 'plumbing', 'structure-3', 'intro-3'],
    shortAnswer: 'Greywater reuse on an off-grid property means separating sink, shower, and laundry drainage from blackwater and routing it to landscape irrigation through mulch basins or a branched-drain network. A working system handles 20-30 gallons per person per day, costs $400-$2,500 unpermitted or $3,000-$8,000 permitted, and depends entirely on soap chemistry, soil percolation, and winter freeze planning.',
    bookRecommendation: { title: 'The Water-Wise Home', author: 'Laura Allen', description: 'Allen co-founded Greywater Action and wrote the practical reference that every off-grid greywater installer eventually reads - the chapters on branched drain sizing and soap selection alone justify the listen.' },
    content: { en: { title: 'Off-Grid Greywater Reuse: What Actually Works and What Codes Forbid', excerpt: 'Branched drain vs. mulch basin vs. constructed wetland, the soap chemistry that kills soil, US state permit reality, and the winter shutdown protocol that prevents frozen pipes.', body: '' } },
  },
  {
    id: '486',
    slug: 'liveaboard-holding-tank-pumpout-management-guide',
    category: 'boat-living' as Article['category'],
    image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=1200&auto=format&fit=crop',
    publishedAt: '2026-05-22',
    updatedAt: '2026-05-22',
    tags: ['boat-living', 'liveaboard', 'holding-tank', 'sanitation', 'pumpout', 'no-discharge', 'structure-2', 'intro-4'],
    shortAnswer: 'A liveaboard holding tank stores blackwater between pumpouts, and managing it well comes down to four variables: tank capacity sized at 1.5 gallons per person per day with a 14-day buffer, pumpout station spacing along your cruising route, vent filter maintenance every 6-12 months, and knowing which waters are No-Discharge Areas. Odor problems almost always trace back to the vent line, not the tank itself.',
    bookRecommendation: { title: 'Boatowner\'s Mechanical and Electrical Manual', author: 'Nigel Calder', description: 'Calder\'s chapter on marine sanitation systems is the single best plain-English reference for diagnosing odor, vent-line, and macerator problems on any liveaboard boat.' },
    content: { en: { title: 'Liveaboard Holding Tanks: Pumpout Logistics, Odor Control, and the No-Discharge Reality', excerpt: 'Tank sizing per person, pumpout station availability by US coast, Y-valve legality and the 3-mile rule, vent filter maintenance, and the chemical treatments worth using.', body: '' } },
  },
  {
    id: '487',
    slug: 'camping-sleeping-pad-guide',
    category: 'camping' as Article['category'],
    image: 'https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=1200&auto=format&fit=crop',
    publishedAt: '2026-06-29',
    updatedAt: '2026-06-29',
    tags: ['camping', 'sleeping-pad', 'gear', 'R-value', 'backpacking', 'sleep-system', 'insulation', 'comfort', 'structure-3', 'intro-4'],
    shortAnswer: 'A sleeping pad insulates you from the ground, not just cushions you. For three-season camping, choose an R-value of 2.0-3.5. For winter, aim for 4.0 or higher. Air pads are light and compact but puncturable; self-inflating pads balance comfort and durability; closed-cell foam pads are indestructible and cheap. Match the pad width to your sleep position and the R-value to the coldest ground you will sleep on.',
    bookRecommendation: { title: 'The Ultimate Hiker\'s Gear Guide', author: 'Andrew Skurka', description: 'Skurka\'s field-tested guide cuts through marketing hype and explains how to choose sleep systems, shelters, and packs that actually match your trip type.' },
    content: { en: { title: 'Camping Sleeping Pad Guide: R-Value, Weight, and Comfort', excerpt: 'Sleeping pads insulate you from the ground, not just cushion you. Learn how R-value, pad type, and width determine warmth and the right model for your trips.', body: '' } },
  },
];

export const getArticlesByCategory = (category: string): ArticleMeta[] => {
  return articles.filter(article => article.category === category);
};

export const getArticleBySlug = (slug: string): ArticleMeta | undefined => {
  return articles.find(article => article.slug === slug);
};

export const getLatestArticles = (count: number = 4): ArticleMeta[] => {
  return [...articles]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, count);
};

export const searchArticles = (query: string): ArticleMeta[] => {
  const lowercaseQuery = query.toLowerCase();
  return articles.filter(article => {
    const content = article.content.en;
    return (
      content.title.toLowerCase().includes(lowercaseQuery) ||
      content.excerpt.toLowerCase().includes(lowercaseQuery) ||
      article.tags.some(tag => tag.toLowerCase().includes(lowercaseQuery))
    );
  });
};

/**
 * Returns all unique content tags across articles, with frequency counts.
 * Filters out structural meta-tags (structure-*, intro-*, hub).
 */
export const getAllTags = (): { tag: string; count: number }[] => {
  const counts = new Map<string, number>();
  for (const a of articles) {
    for (const tag of a.tags) {
      if (tag.startsWith('structure-') || tag.startsWith('intro-') || tag === 'hub') continue;
      counts.set(tag, (counts.get(tag) || 0) + 1);
    }
  }
  return Array.from(counts.entries())
    .map(([tag, count]) => ({ tag, count }))
    .sort((a, b) => b.count - a.count || a.tag.localeCompare(b.tag));
};

export const getArticlesByTag = (tag: string): ArticleMeta[] => {
  const lower = tag.toLowerCase();
  return articles.filter(a => a.tags.some(t => t.toLowerCase() === lower));
};

/**
 * Ranked search across title, excerpt, tags. Body content is searched
 * lazily by callers when they have already loaded bodies (see Search page).
 * Returns articles ordered by relevance score.
 */
export const searchArticlesRanked = (
  query: string,
  bodies?: Record<string, string>,
  tagFilters: string[] = []
): ArticleMeta[] => {
  const q = query.trim().toLowerCase();
  const terms = q.split(/\s+/).filter(Boolean);
  const activeTags = tagFilters.map(t => t.toLowerCase());

  const scored = articles
    .filter(a => {
      if (activeTags.length === 0) return true;
      const tags = a.tags.map(t => t.toLowerCase());
      return activeTags.every(t => tags.includes(t));
    })
    .map(article => {
      const content = article.content.en;
      const title = content.title.toLowerCase();
      const excerpt = content.excerpt.toLowerCase();
      const tagBlob = article.tags.join(' ').toLowerCase();
      const body = (bodies?.[article.slug] || '').toLowerCase();

      let score = 0;
      if (terms.length === 0) {
        // Tag-only browse
        score = activeTags.length > 0 ? 1 : 0;
      } else {
        for (const term of terms) {
          if (title.includes(term)) score += 10;
          if (tagBlob.includes(term)) score += 6;
          if (excerpt.includes(term)) score += 4;
          if (body && body.includes(term)) score += 2;
        }
        // Phrase boost
        if (title.includes(q)) score += 8;
        if (excerpt.includes(q)) score += 3;
      }
      return { article, score };
    })
    .filter(r => r.score > 0)
    .sort((a, b) => b.score - a.score);

  return scored.map(r => r.article);
};